var zr = (i) => {
  throw TypeError(i);
};
var Ii = (i, e, t) => e.has(i) || zr("Cannot " + t);
var f = (i, e, t) => (Ii(i, e, "read from private field"), t ? t.call(i) : e.get(i)), L = (i, e, t) => e.has(i) ? zr("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t), P = (i, e, t, r) => (Ii(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), B = (i, e, t) => (Ii(i, e, "access private method"), t);
var hi = (i, e, t, r) => ({
  set _(s) {
    P(i, e, s, t);
  },
  get _() {
    return f(i, e, r);
  }
});
import { Checkbox as fa, ActionMenu as pa, LanguageCodeEnum as Ui, Modal as Ei, PrimaryButton as oi, SecondaryButton as tn, FieldErrorAndDescription as mi, ActionMenuItem as Ni, FormInputSearch as ga, FormSelectMultiple as Ur, Loader as ma, toast as be, CheckBoxSwitcher as va, BaseSwitcher as ya, useWindowSize as ba, FormInput as wa, ModalSizeEnum as xa } from "@systemeio/ui";
import { getTFuncWithNamespace as Ca, getUseLocoTranslation as Sa, createHttpClient as Oa, getUseBaseFetch as Ea, RequestMethodsEnum as St, BadRequest as Na } from "@systemeio/util";
import * as ue from "react";
import Oe, { createContext as rn, useContext as _a, useState as V, useRef as we, useEffect as Ee, useCallback as Ra, Children as Pa, memo as Fa } from "react";
import { jsx as v, jsxs as T, Fragment as $i } from "react/jsx-runtime";
import { twMerge as ie } from "tailwind-merge";
import { CloseIcon as $r, InfoIcon as Da, BinIcon as Ia, PenIcon as La, DownloadIcon as Ma, CloseCircleIcon as Br, SmallPenIcon as ka, UploadIcon as Ta } from "@systemeio/ui/icons";
import { flushSync as Aa } from "react-dom";
import br from "axios";
var $e = /* @__PURE__ */ ((i) => (i.Docx = ".docx", i.Doc = ".doc", i.Ttf = ".ttf", i.AD_PRT = ".AD_PRT", i.AD_SMP = ".AD_SMP", i.AD_ASM = ".AD_ASM", i.AD_DRW = ".AD_DRW", i))($e || {}), G = /* @__PURE__ */ ((i) => (i.Editor = "editor", i.Community = "community", i.BlockPreview = "block_preview", i.Membership = "membership", i.Marketplace = "marketplace", i.Settings = "settings", i.Email = "email", i.Ckeditor = "ckeditor", i.TextEditor = "text_editor", i.BlogPost = "blog_post", i.PageTemplate = "page_template", i.PageTemplatePreview = "page_template_preview", i.BlogTemplatePreview = "blog_template_preview", i.EmailTemplate = "email_template", i.WebsiteTemplate = "website_template", i.Product = "product", i.FunnelTemplatePreview = "funnel_template_preview", i.DigitalStore = "digital_store", i.DigitalProductResource = "digital_product_resource", i.CalendarHostAvatar = "calendar_host_avatar", i.FileManager = "file_manager", i.WhiteLabel = "white_label", i))(G || {}), X = /* @__PURE__ */ ((i) => (i.Image = "image", i.ImageOther = "image_other", i.Video = "video", i.Audio = "audio", i.Font = "font", i.Document = "document", i))(X || {});
const ja = (i) => {
  if (typeof i != "object" || i === null) return !1;
  const e = i;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(G).includes(e.source) && typeof e.size == "number" && Object.values(X).includes(e.type) && typeof e.createdAt == "string";
}, za = {
  [G.Editor]: "file_manager.file_source.editor",
  [G.Community]: "file_manager.file_source.community",
  [G.BlockPreview]: "file_manager.file_source.block_preview",
  [G.Membership]: "file_manager.file_source.membership",
  [G.Marketplace]: "file_manager.file_source.marketplace",
  [G.Settings]: "file_manager.file_source.settings",
  [G.Email]: "file_manager.file_source.email",
  [G.Ckeditor]: "file_manager.file_source.ckeditor",
  [G.BlogPost]: "file_manager.file_source.blog_post",
  [G.PageTemplate]: "file_manager.file_source.page_template",
  [G.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [G.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [G.EmailTemplate]: "file_manager.file_source.email_template",
  [G.Product]: "file_manager.file_source.product",
  [G.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [G.DigitalStore]: "file_manager.file_source.digital_store",
  [G.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [G.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [G.FileManager]: "file_manager.file_source.file_manager",
  [G.TextEditor]: "file_manager.file_source.text_editor",
  [G.WhiteLabel]: "file_manager.file_source.white_label",
  [G.WebsiteTemplate]: "file_manager.file_source.website_template"
}, Ua = {
  [X.Image]: "file_manager.file_type.image",
  [X.ImageOther]: "file_manager.file_type.image_other",
  [X.Video]: "file_manager.file_type.video",
  [X.Audio]: "file_manager.file_type.audio",
  [X.Font]: "file_manager.file_type.font",
  [X.Document]: "file_manager.file_type.document"
};
var wr = /* @__PURE__ */ ((i) => (i.Next = "next", i.Prev = "prev", i))(wr || {}), sn = /* @__PURE__ */ ((i) => (i.Asc = "ASC", i.Desc = "DESC", i))(sn || {});
function $a(i) {
  return /* @__PURE__ */ v(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: /* @__PURE__ */ v("g", { id: "_x35_3", children: /* @__PURE__ */ v("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function Hr(i) {
  return /* @__PURE__ */ T(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...i,
      children: [
        /* @__PURE__ */ v("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ v("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function Ba(i) {
  return /* @__PURE__ */ T(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...i,
      children: [
        /* @__PURE__ */ v("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ v("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function Ha(i) {
  return /* @__PURE__ */ T(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...i,
      children: [
        /* @__PURE__ */ v("g", { children: /* @__PURE__ */ v("g", { children: /* @__PURE__ */ v("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ v("g", { children: /* @__PURE__ */ v("g", { children: /* @__PURE__ */ v("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {}),
        /* @__PURE__ */ v("g", {})
      ]
    }
  );
}
function Va(i) {
  switch (i) {
    case X.Audio:
      return /* @__PURE__ */ v($a, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Image:
    case X.ImageOther:
      return /* @__PURE__ */ v(Ba, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Video:
      return /* @__PURE__ */ v(Ha, { className: "fill-text-secondary", width: 40, height: 40 });
    case X.Font:
    case X.Document:
      return /* @__PURE__ */ v(Hr, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ v(Hr, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const $t = /* @__PURE__ */ new Set(), Bt = /* @__PURE__ */ new Set(), pt = Oe.memo(
  ({
    src: i,
    fileType: e,
    alt: t,
    className: r,
    isThumbnail: s = !1,
    width: n,
    height: a,
    title: o
  }) => {
    const [l, c] = Oe.useState(Bt.has(i)), [h, d] = Oe.useState($t.has(i));
    return /* @__PURE__ */ T(
      "div",
      {
        className: ie("flex items-center justify-center", r),
        style: {
          width: n,
          height: a,
          minHeight: a
        },
        title: o,
        children: [
          e !== X.Video && /* @__PURE__ */ v(
            "img",
            {
              src: i,
              alt: t,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && h ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), $t.add(i), Bt.delete(i);
              },
              onError: () => {
                c(!0), $t.delete(i), Bt.add(i);
              }
            }
          ),
          e === X.Video && /* @__PURE__ */ v(
            "video",
            {
              src: i,
              className: ie(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && h ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), $t.add(i), Bt.delete(i);
              },
              onError: () => {
                c(!0), $t.delete(i), Bt.add(i);
              },
              controls: !s
            }
          ),
          /* @__PURE__ */ v(
            "div",
            {
              className: ie(
                "flex-2 flex items-center justify-center rounded-md",
                !s && "min-h-[300px]",
                !i || l ? "flex" : "hidden"
              ),
              children: Va(e)
            }
          )
        ]
      }
    );
  }
);
pt.displayName = "FilePreview";
function Wa({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  secondaryText: s,
  style: n,
  selected: a,
  actionMenu: o,
  className: l,
  imageWidth: c,
  imageHeight: h,
  onSelect: d
}) {
  const u = Oe.useRef(null), p = Oe.useRef(null);
  return /* @__PURE__ */ T(
    "div",
    {
      className: ie("relative flex flex-col cursor-pointer", l),
      style: n,
      onClick: (y) => {
        var b;
        u.current && !((b = p.current) != null && b.contains(y.target)) && u.current.click();
      },
      children: [
        /* @__PURE__ */ v(
          pt,
          {
            src: e ?? "",
            fileType: i,
            alt: t,
            width: c,
            height: h,
            className: ie(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              a && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ v("div", { ref: p, className: "absolute top-1 left-1", children: /* @__PURE__ */ v(fa, { inputRef: u, value: a, onChange: d }) }),
        /* @__PURE__ */ v("div", { onClick: (y) => y.stopPropagation(), children: /* @__PURE__ */ v(
          pa,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...o,
            menuItems: (o == null ? void 0 : o.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ v(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: r,
            children: r
          }
        ),
        /* @__PURE__ */ v(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: s,
            children: s
          }
        )
      ]
    }
  );
}
const qa = (i, e, t) => {
  const r = i[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((s, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      n.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, M = (i) => typeof i == "string", Ht = () => {
  let i, e;
  const t = new Promise((r, s) => {
    i = r, e = s;
  });
  return t.resolve = i, t.reject = e, t;
}, Vr = (i) => i == null ? "" : "" + i, Qa = (i, e, t) => {
  i.forEach((r) => {
    e[r] && (t[r] = e[r]);
  });
}, Ka = /###/g, Wr = (i) => i && i.indexOf("###") > -1 ? i.replace(Ka, ".") : i, qr = (i) => !i || M(i), Yt = (i, e, t) => {
  const r = M(e) ? e.split(".") : e;
  let s = 0;
  for (; s < r.length - 1; ) {
    if (qr(i)) return {};
    const n = Wr(r[s]);
    !i[n] && t && (i[n] = new t()), Object.prototype.hasOwnProperty.call(i, n) ? i = i[n] : i = {}, ++s;
  }
  return qr(i) ? {} : {
    obj: i,
    k: Wr(r[s])
  };
}, Qr = (i, e, t) => {
  const {
    obj: r,
    k: s
  } = Yt(i, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[s] = t;
    return;
  }
  let n = e[e.length - 1], a = e.slice(0, e.length - 1), o = Yt(i, a, Object);
  for (; o.obj === void 0 && a.length; )
    n = `${a[a.length - 1]}.${n}`, a = a.slice(0, a.length - 1), o = Yt(i, a, Object), o && o.obj && typeof o.obj[`${o.k}.${n}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${n}`] = t;
}, Ya = (i, e, t, r) => {
  const {
    obj: s,
    k: n
  } = Yt(i, e, Object);
  s[n] = s[n] || [], s[n].push(t);
}, vi = (i, e) => {
  const {
    obj: t,
    k: r
  } = Yt(i, e);
  if (t)
    return t[r];
}, Xa = (i, e, t) => {
  const r = vi(i, t);
  return r !== void 0 ? r : vi(e, t);
}, nn = (i, e, t) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in i ? M(i[r]) || i[r] instanceof String || M(e[r]) || e[r] instanceof String ? t && (i[r] = e[r]) : nn(i[r], e[r], t) : i[r] = e[r]);
  return i;
}, vt = (i) => i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Ga = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Ja = (i) => M(i) ? i.replace(/[&<>"'\/]/g, (e) => Ga[e]) : i;
class Za {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const eo = [" ", ",", "?", "!", ";"], to = new Za(20), io = (i, e, t) => {
  e = e || "", t = t || "";
  const r = eo.filter((a) => e.indexOf(a) < 0 && t.indexOf(a) < 0);
  if (r.length === 0) return !0;
  const s = to.getRegExp(`(${r.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let n = !s.test(i);
  if (!n) {
    const a = i.indexOf(t);
    a > 0 && !s.test(i.substring(0, a)) && (n = !0);
  }
  return n;
}, Bi = function(i, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!i) return;
  if (i[e]) return i[e];
  const r = e.split(t);
  let s = i;
  for (let n = 0; n < r.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = n; l < r.length; ++l)
      if (l !== n && (o += t), o += r[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < r.length - 1)
          continue;
        n += l - n + 1;
        break;
      }
    s = a;
  }
  return s;
}, yi = (i) => i && i.replace("_", "-"), ro = {
  type: "logger",
  log(i) {
    this.output("log", i);
  },
  warn(i) {
    this.output("warn", i);
  },
  error(i) {
    this.output("error", i);
  },
  output(i, e) {
    console && console[i] && console[i].apply(console, e);
  }
};
class bi {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || ro, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, r, s) {
    return s && !this.debug ? null : (M(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new bi(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new bi(this.logger, e);
  }
}
var Me = new bi();
class _i {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const s = this.observers[r].get(t) || 0;
      this.observers[r].set(t, s + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
      r[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...r]);
    });
  }
}
class Kr extends _i {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, t], r && (Array.isArray(r) ? o.push(...r) : M(r) && n ? o.push(...r.split(n)) : o.push(r)));
    const l = vi(this.data, o);
    return !l && !t && !r && e.indexOf(".") > -1 && (e = o[0], t = o[1], r = o.slice(2).join(".")), l || !a || !M(r) ? l : Bi(this.data && this.data[e] && this.data[e][t], r, n);
  }
  addResource(e, t, r, s) {
    let n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let o = [e, t];
    r && (o = o.concat(a ? r.split(a) : r)), e.indexOf(".") > -1 && (o = e.split("."), s = t, t = o[1]), this.addNamespaces(t), Qr(this.data, o, s), n.silent || this.emit("added", e, t, r, s);
  }
  addResources(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const n in r)
      (M(r[n]) || Array.isArray(r[n])) && this.addResource(e, t, n, r[n], {
        silent: !0
      });
    s.silent || this.emit("added", e, t, r);
  }
  addResourceBundle(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, t];
    e.indexOf(".") > -1 && (o = e.split("."), s = r, r = t, t = o[1]), this.addNamespaces(t);
    let l = vi(this.data, o) || {};
    a.skipCopy || (r = JSON.parse(JSON.stringify(r))), s ? nn(l, r, n) : l = {
      ...l,
      ...r
    }, Qr(this.data, o, l), a.silent || this.emit("added", e, t, r);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((s) => t[s] && Object.keys(t[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var an = {
  processors: {},
  addPostProcessor(i) {
    this.processors[i.name] = i;
  },
  handle(i, e, t, r, s) {
    return i.forEach((n) => {
      this.processors[n] && (e = this.processors[n].process(e, t, r, s));
    }), e;
  }
};
const Yr = {};
class wi extends _i {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Qa(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Me.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, t);
    return r && r.res !== void 0;
  }
  extractFromKey(e, t) {
    let r = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let n = t.ns || this.options.defaultNS || [];
    const a = r && e.indexOf(r) > -1, o = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !io(e, r, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: M(n) ? [n] : n
        };
      const c = e.split(r);
      (r !== s || r === s && this.options.ns.indexOf(c[0]) > -1) && (n = c.shift()), e = c.join(s);
    }
    return {
      key: e,
      namespaces: M(n) ? [n] : n
    };
  }
  translate(e, t, r) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, n = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], t), l = o[o.length - 1], c = t.lng || this.language, h = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (h) {
        const w = t.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${w}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(t)
        } : `${l}${w}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(t)
      } : a;
    }
    const d = this.resolve(e, t);
    let u = d && d.res;
    const p = d && d.usedKey || a, y = d && d.exactUsedKey || a, b = Object.prototype.toString.apply(u), m = ["[object Number]", "[object Function]", "[object RegExp]"], S = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, N = !M(u) && typeof u != "boolean" && typeof u != "number";
    if (x && u && N && m.indexOf(b) < 0 && !(M(S) && Array.isArray(u))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const w = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, u, {
          ...t,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (d.res = w, d.usedParams = this.getUsedParamsDetails(t), d) : w;
      }
      if (n) {
        const w = Array.isArray(u), R = w ? [] : {}, g = w ? y : p;
        for (const E in u)
          if (Object.prototype.hasOwnProperty.call(u, E)) {
            const O = `${g}${n}${E}`;
            R[E] = this.translate(O, {
              ...t,
              joinArrays: !1,
              ns: o
            }), R[E] === O && (R[E] = u[E]);
          }
        u = R;
      }
    } else if (x && M(S) && Array.isArray(u))
      u = u.join(S), u && (u = this.extendTranslation(u, e, t, r));
    else {
      let w = !1, R = !1;
      const g = t.count !== void 0 && !M(t.count), E = wi.hasDefaultValue(t), O = g ? this.pluralResolver.getSuffix(c, t.count, t) : "", _ = t.ordinal && g ? this.pluralResolver.getSuffix(c, t.count, {
        ordinal: !1
      }) : "", C = g && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), F = C && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${O}`] || t[`defaultValue${_}`] || t.defaultValue;
      !this.isValidLookup(u) && E && (w = !0, u = F), this.isValidLookup(u) || (R = !0, u = a);
      const A = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && R ? void 0 : u, $ = E && F !== u && this.options.updateMissing;
      if (R || w || $) {
        if (this.logger.log($ ? "updateKey" : "missingKey", c, l, a, $ ? F : u), n) {
          const j = this.resolve(a, {
            ...t,
            keySeparator: !1
          });
          j && j.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Q = [];
        const k = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && k && k[0])
          for (let j = 0; j < k.length; j++)
            Q.push(k[j]);
        else this.options.saveMissingTo === "all" ? Q = this.languageUtils.toResolveHierarchy(t.lng || this.language) : Q.push(t.lng || this.language);
        const ae = (j, K, ee) => {
          const W = E && ee !== u ? ee : A;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(j, l, K, W, $, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(j, l, K, W, $, t), this.emit("missingKey", j, l, K, u);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && g ? Q.forEach((j) => {
          const K = this.pluralResolver.getSuffixes(j, t);
          C && t[`defaultValue${this.options.pluralSeparator}zero`] && K.indexOf(`${this.options.pluralSeparator}zero`) < 0 && K.push(`${this.options.pluralSeparator}zero`), K.forEach((ee) => {
            ae([j], a + ee, t[`defaultValue${ee}`] || F);
          });
        }) : ae(Q, a, F));
      }
      u = this.extendTranslation(u, e, t, d, r), R && u === a && this.options.appendNamespaceToMissingKey && (u = `${l}:${a}`), (R || w) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? u = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, w ? u : void 0) : u = this.options.parseMissingKeyHandler(u));
    }
    return s ? (d.res = u, d.usedParams = this.getUsedParamsDetails(t), d) : u;
  }
  extendTranslation(e, t, r, s, n) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = M(e) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let h;
      if (c) {
        const u = e.match(this.interpolator.nestingRegexp);
        h = u && u.length;
      }
      let d = r.replace && !M(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), e = this.interpolator.interpolate(e, d, r.lng || this.language || s.usedLng, r), c) {
        const u = e.match(this.interpolator.nestingRegexp), p = u && u.length;
        h < p && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = this.language || s.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var u = arguments.length, p = new Array(u), y = 0; y < u; y++)
          p[y] = arguments[y];
        return n && n[0] === p[0] && !r.context ? (a.logger.warn(`It seems you are nesting recursively key: ${p[0]} in key: ${t[0]}`), null) : a.translate(...p, t);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const o = r.postProcess || this.options.postProcess, l = M(o) ? [o] : o;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = an.handle(l, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, n, a, o;
    return M(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const c = this.extractFromKey(l, t), h = c.key;
      s = h;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const u = t.count !== void 0 && !M(t.count), p = u && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), y = t.context !== void 0 && (M(t.context) || typeof t.context == "number") && t.context !== "", b = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      d.forEach((m) => {
        this.isValidLookup(r) || (o = m, !Yr[`${b[0]}-${m}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Yr[`${b[0]}-${m}`] = !0, this.logger.warn(`key "${s}" for languages "${b.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), b.forEach((S) => {
          if (this.isValidLookup(r)) return;
          a = S;
          const x = [h];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, h, S, m, t);
          else {
            let w;
            u && (w = this.pluralResolver.getSuffix(S, t.count, t));
            const R = `${this.options.pluralSeparator}zero`, g = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (u && (x.push(h + w), t.ordinal && w.indexOf(g) === 0 && x.push(h + w.replace(g, this.options.pluralSeparator)), p && x.push(h + R)), y) {
              const E = `${h}${this.options.contextSeparator}${t.context}`;
              x.push(E), u && (x.push(E + w), t.ordinal && w.indexOf(g) === 0 && x.push(E + w.replace(g, this.options.pluralSeparator)), p && x.push(E + R));
            }
          }
          let N;
          for (; N = x.pop(); )
            this.isValidLookup(r) || (n = N, r = this.getResource(S, m, N, t));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: n,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, s) : this.resourceStore.getResource(e, t, r, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !M(e.replace);
    let s = r ? e.replace : e;
    if (r && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !r) {
      s = {
        ...s
      };
      for (const n of t)
        delete s[n];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t === r.substring(0, t.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
const Li = (i) => i.charAt(0).toUpperCase() + i.slice(1);
class Xr {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Me.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = yi(e), !e || e.indexOf("-") < 0) return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = yi(e), !e || e.indexOf("-") < 0) return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (M(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s) return s;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Li(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Li(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Li(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let t;
    return e.forEach((r) => {
      if (t) return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (t = s);
    }), !t && this.options.supportedLngs && e.forEach((r) => {
      if (t) return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s)) return t = s;
      t = this.options.supportedLngs.find((n) => {
        if (n === s) return n;
        if (!(n.indexOf("-") < 0 && s.indexOf("-") < 0) && (n.indexOf("-") > 0 && s.indexOf("-") < 0 && n.substring(0, n.indexOf("-")) === s || n.indexOf(s) === 0 && s.length > 1))
          return n;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(t)), M(e) && (e = [e]), Array.isArray(e)) return e;
    if (!t) return e.default || [];
    let r = e[t];
    return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, t) {
    const r = this.getFallbackCodes(t || this.options.fallbackLng || [], e), s = [], n = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return M(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && n(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && n(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && n(this.getLanguagePartFromCode(e))) : M(e) && n(this.formatLanguageCode(e)), r.forEach((a) => {
      s.indexOf(a) < 0 && n(this.formatLanguageCode(a));
    }), s;
  }
}
let so = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], no = {
  1: (i) => +(i > 1),
  2: (i) => +(i != 1),
  3: (i) => 0,
  4: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  5: (i) => i == 0 ? 0 : i == 1 ? 1 : i == 2 ? 2 : i % 100 >= 3 && i % 100 <= 10 ? 3 : i % 100 >= 11 ? 4 : 5,
  6: (i) => i == 1 ? 0 : i >= 2 && i <= 4 ? 1 : 2,
  7: (i) => i == 1 ? 0 : i % 10 >= 2 && i % 10 <= 4 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  8: (i) => i == 1 ? 0 : i == 2 ? 1 : i != 8 && i != 11 ? 2 : 3,
  9: (i) => +(i >= 2),
  10: (i) => i == 1 ? 0 : i == 2 ? 1 : i < 7 ? 2 : i < 11 ? 3 : 4,
  11: (i) => i == 1 || i == 11 ? 0 : i == 2 || i == 12 ? 1 : i > 2 && i < 20 ? 2 : 3,
  12: (i) => +(i % 10 != 1 || i % 100 == 11),
  13: (i) => +(i !== 0),
  14: (i) => i == 1 ? 0 : i == 2 ? 1 : i == 3 ? 2 : 3,
  15: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i % 10 >= 2 && (i % 100 < 10 || i % 100 >= 20) ? 1 : 2,
  16: (i) => i % 10 == 1 && i % 100 != 11 ? 0 : i !== 0 ? 1 : 2,
  17: (i) => i == 1 || i % 10 == 1 && i % 100 != 11 ? 0 : 1,
  18: (i) => i == 0 ? 0 : i == 1 ? 1 : 2,
  19: (i) => i == 1 ? 0 : i == 0 || i % 100 > 1 && i % 100 < 11 ? 1 : i % 100 > 10 && i % 100 < 20 ? 2 : 3,
  20: (i) => i == 1 ? 0 : i == 0 || i % 100 > 0 && i % 100 < 20 ? 1 : 2,
  21: (i) => i % 100 == 1 ? 1 : i % 100 == 2 ? 2 : i % 100 == 3 || i % 100 == 4 ? 3 : 0,
  22: (i) => i == 1 ? 0 : i == 2 ? 1 : (i < 0 || i > 10) && i % 10 == 0 ? 2 : 3
};
const ao = ["v1", "v2", "v3"], oo = ["v4"], Gr = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, lo = () => {
  const i = {};
  return so.forEach((e) => {
    e.lngs.forEach((t) => {
      i[t] = {
        numbers: e.nr,
        plurals: no[e.fc]
      };
    });
  }), i;
};
class co {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = Me.create("pluralResolver"), (!this.options.compatibilityJSON || oo.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = lo(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = yi(e === "dev" ? "en" : e), s = t.ordinal ? "ordinal" : "cardinal", n = JSON.stringify({
        cleanedCode: r,
        type: s
      });
      if (n in this.pluralRulesCache)
        return this.pluralRulesCache[n];
      let a;
      try {
        a = new Intl.PluralRules(r, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, t);
      }
      return this.pluralRulesCache[n] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((s) => `${t}${s}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, t);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, n) => Gr[s] - Gr[n]).map((s) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(e, s, t)) : [];
  }
  getSuffix(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(t)}` : this.getSuffixRetroCompatible(s, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let s = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const n = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : n() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? n() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !ao.includes(this.options.compatibilityJSON);
  }
}
const Jr = function(i, e, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, n = Xa(i, e, t);
  return !n && s && M(t) && (n = Bi(i, t, r), n === void 0 && (n = Bi(e, t, r))), n;
}, Mi = (i) => i.replace(/\$/g, "$$$$");
class uo {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Me.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: r,
      useRawValueToEscape: s,
      prefix: n,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: h,
      unescapePrefix: d,
      nestingPrefix: u,
      nestingPrefixEscaped: p,
      nestingSuffix: y,
      nestingSuffixEscaped: b,
      nestingOptionsSeparator: m,
      maxReplaces: S,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Ja, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = n ? vt(n) : a || "{{", this.suffix = o ? vt(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = h ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : h || "", this.nestingPrefix = u ? vt(u) : p || vt("$t("), this.nestingSuffix = y ? vt(y) : b || vt(")"), this.nestingOptionsSeparator = m || ",", this.maxReplaces = S || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, r) => t && t.source === r ? (t.lastIndex = 0, t) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, r, s) {
    let n, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const S = Jr(t, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(S, void 0, r, {
          ...s,
          ...t,
          interpolationkey: p
        }) : S;
      }
      const y = p.split(this.formatSeparator), b = y.shift().trim(), m = y.join(this.formatSeparator).trim();
      return this.format(Jr(t, l, b, this.options.keySeparator, this.options.ignoreJSONStructure), m, r, {
        ...s,
        ...t,
        interpolationkey: b
      });
    };
    this.resetRegExp();
    const h = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, d = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => Mi(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? Mi(this.escape(p)) : Mi(p)
    }].forEach((p) => {
      for (o = 0; n = p.regex.exec(e); ) {
        const y = n[1].trim();
        if (a = c(y), a === void 0)
          if (typeof h == "function") {
            const m = h(e, n, s);
            a = M(m) ? m : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, y))
            a = "";
          else if (d) {
            a = n[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${y} for interpolating ${e}`), a = "";
        else !M(a) && !this.useRawValueToEscape && (a = Vr(a));
        const b = p.safeValue(a);
        if (e = e.replace(n[0], b), d ? (p.regex.lastIndex += a.length, p.regex.lastIndex -= n[0].length) : p.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, n, a;
    const o = (l, c) => {
      const h = this.nestingOptionsSeparator;
      if (l.indexOf(h) < 0) return l;
      const d = l.split(new RegExp(`${h}[ ]*{`));
      let u = `{${d[1]}`;
      l = d[0], u = this.interpolate(u, a);
      const p = u.match(/'/g), y = u.match(/"/g);
      (p && p.length % 2 === 0 && !y || y.length % 2 !== 0) && (u = u.replace(/'/g, '"'));
      try {
        a = JSON.parse(u), c && (a = {
          ...c,
          ...a
        });
      } catch (b) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, b), `${l}${h}${u}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...r
      }, a = a.replace && !M(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const h = s[1].split(this.formatSeparator).map((d) => d.trim());
        s[1] = h.shift(), l = h, c = !0;
      }
      if (n = t(o.call(this, s[1].trim(), a), a), n && s[0] === e && !M(n)) return n;
      M(n) || (n = Vr(n)), n || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), n = ""), c && (n = l.reduce((h, d) => this.format(h, d, r.lng, {
        ...r,
        interpolationkey: s[1].trim()
      }), n.trim())), e = e.replace(s[0], n), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const ho = (i) => {
  let e = i.toLowerCase().trim();
  const t = {};
  if (i.indexOf("(") > -1) {
    const r = i.split("(");
    e = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? t.currency || (t.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? t.range || (t.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), h = o.trim();
        t[h] || (t[h] = c), c === "false" && (t[h] = !1), c === "true" && (t[h] = !0), isNaN(c) || (t[h] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, yt = (i) => {
  const e = {};
  return (t, r, s) => {
    let n = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (n = {
      ...n,
      [s.interpolationkey]: void 0
    });
    const a = r + JSON.stringify(n);
    let o = e[a];
    return o || (o = i(yi(r), s), e[a] = o), o(t);
  };
};
class fo {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Me.create("formatter"), this.options = e, this.formats = {
      number: yt((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      currency: yt((t, r) => {
        const s = new Intl.NumberFormat(t, {
          ...r,
          style: "currency"
        });
        return (n) => s.format(n);
      }),
      datetime: yt((t, r) => {
        const s = new Intl.DateTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      }),
      relativetime: yt((t, r) => {
        const s = new Intl.RelativeTimeFormat(t, {
          ...r
        });
        return (n) => s.format(n, r.range || "day");
      }),
      list: yt((t, r) => {
        const s = new Intl.ListFormat(t, {
          ...r
        });
        return (n) => s.format(n);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = yt(t);
  }
  format(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const n = t.split(this.formatSeparator);
    if (n.length > 1 && n[0].indexOf("(") > 1 && n[0].indexOf(")") < 0 && n.find((o) => o.indexOf(")") > -1)) {
      const o = n.findIndex((l) => l.indexOf(")") > -1);
      n[0] = [n[0], ...n.splice(1, o)].join(this.formatSeparator);
    }
    return n.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: h
      } = ho(l);
      if (this.formats[c]) {
        let d = o;
        try {
          const u = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, p = u.locale || u.lng || s.locale || s.lng || r;
          d = this.formats[c](o, p, {
            ...h,
            ...s,
            ...u
          });
        } catch (u) {
          this.logger.warn(u);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const po = (i, e) => {
  i.pending[e] !== void 0 && (delete i.pending[e], i.pendingCount--);
};
class go extends _i {
  constructor(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = Me.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(e, t, r, s) {
    const n = {}, a = {}, o = {}, l = {};
    return e.forEach((c) => {
      let h = !0;
      t.forEach((d) => {
        const u = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[u] = 2 : this.state[u] < 0 || (this.state[u] === 1 ? a[u] === void 0 && (a[u] = !0) : (this.state[u] = 1, h = !1, a[u] === void 0 && (a[u] = !0), n[u] === void 0 && (n[u] = !0), l[d] === void 0 && (l[d] = !0)));
      }), h || (o[c] = !0);
    }), (Object.keys(n).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(n),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, t, r) {
    const s = e.split("|"), n = s[0], a = s[1];
    t && this.emit("failedLoading", n, a, t), !t && r && this.store.addResourceBundle(n, a, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && r && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      Ya(l.loaded, [n], a), po(l, e), t && l.errors.push(t), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const h = l.loaded[c];
        h.length && h.forEach((d) => {
          o[c][d] === void 0 && (o[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: r,
        tried: s,
        wait: n,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (c, h) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && h && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, r, s + 1, n * 2, a);
        }, n);
        return;
      }
      a(c, h);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, t);
        c && typeof c.then == "function" ? c.then((h) => o(null, h)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, t, o);
  }
  prepareLoading(e, t) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    M(e) && (e = this.languageUtils.toResolveHierarchy(e)), M(t) && (t = [t]);
    const n = this.queueLoad(e, t, r, s);
    if (!n.toLoad.length)
      return n.pending.length || s(), null;
    n.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, t, r) {
    this.prepareLoading(e, t, {}, r);
  }
  reload(e, t, r) {
    this.prepareLoading(e, t, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), s = r[0], n = r[1];
    this.read(s, n, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${t}loading namespace ${n} for language ${s} failed`, a), !a && o && this.logger.log(`${t}loaded namespace ${n} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, t, r, s, n) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: n
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let h;
            c.length === 5 ? h = c(e, t, r, s, l) : h = c(e, t, r, s), h && typeof h.then == "function" ? h.then((d) => o(null, d)).catch(o) : o(null, h);
          } catch (h) {
            o(h);
          }
        else
          c(e, t, r, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], t, r, s);
    }
  }
}
const Zr = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (i) => {
    let e = {};
    if (typeof i[1] == "object" && (e = i[1]), M(i[1]) && (e.defaultValue = i[1]), M(i[2]) && (e.tDescription = i[2]), typeof i[2] == "object" || typeof i[3] == "object") {
      const t = i[3] || i[2];
      Object.keys(t).forEach((r) => {
        e[r] = t[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (i) => i,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), es = (i) => (M(i.ns) && (i.ns = [i.ns]), M(i.fallbackLng) && (i.fallbackLng = [i.fallbackLng]), M(i.fallbackNS) && (i.fallbackNS = [i.fallbackNS]), i.supportedLngs && i.supportedLngs.indexOf("cimode") < 0 && (i.supportedLngs = i.supportedLngs.concat(["cimode"])), i), di = () => {
}, mo = (i) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(i)).forEach((t) => {
    typeof i[t] == "function" && (i[t] = i[t].bind(i));
  });
};
class Gt extends _i {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = es(e), this.services = {}, this.logger = Me, this.modules = {
      external: []
    }, mo(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (M(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const s = Zr();
    this.options = {
      ...s,
      ...this.options,
      ...es(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (h) => h ? typeof h == "function" ? new h() : h : null;
    if (!this.options.isClone) {
      this.modules.logger ? Me.init(n(this.modules.logger), this.options) : Me.init(null, this.options);
      let h;
      this.modules.formatter ? h = this.modules.formatter : typeof Intl < "u" && (h = fo);
      const d = new Xr(this.options);
      this.store = new Kr(this.options.resources, this.options);
      const u = this.services;
      u.logger = Me, u.resourceStore = this.store, u.languageUtils = d, u.pluralResolver = new co(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), h && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (u.formatter = n(h), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new uo(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new go(n(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(p) {
        for (var y = arguments.length, b = new Array(y > 1 ? y - 1 : 0), m = 1; m < y; m++)
          b[m - 1] = arguments[m];
        e.emit(p, ...b);
      }), this.modules.languageDetector && (u.languageDetector = n(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = n(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new wi(this.services, this.options), this.translator.on("*", function(p) {
        for (var y = arguments.length, b = new Array(y > 1 ? y - 1 : 0), m = 1; m < y; m++)
          b[m - 1] = arguments[m];
        e.emit(p, ...b);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = di), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const h = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      h.length > 0 && h[0] !== "dev" && (this.options.lng = h[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((h) => {
      this[h] = function() {
        return e.store[h](...arguments), e;
      };
    });
    const l = Ht(), c = () => {
      const h = (d, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(u), r(d, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return h(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, h);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : di;
    const s = M(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const n = [], a = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && n.indexOf(c) < 0 && n.push(c);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(n, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(o);
      });
    } else
      r(null);
  }
  reloadResources(e, t, r) {
    const s = Ht();
    return typeof e == "function" && (r = e, e = void 0), typeof t == "function" && (r = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), r || (r = di), this.services.backendConnector.reload(e, t, (n) => {
      s.resolve(), r(n);
    }), s;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && an.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const r = this.languages[t];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var r = this;
    this.isLanguageChangingTo = e;
    const s = Ht();
    this.emit("languageChanging", e);
    const n = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (n(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), t && t(l, function() {
        return r.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = M(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (h) => {
        a(h, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, t, r) {
    var s = this;
    const n = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, h = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          h[d - 2] = arguments[d];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(h));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || n.keyPrefix);
      const u = s.options.keySeparator || ".";
      let p;
      return l.keyPrefix && Array.isArray(a) ? p = a.map((y) => `${l.keyPrefix}${u}${y}`) : p = l.keyPrefix ? `${l.keyPrefix}${u}${a}` : a, s.t(p, l);
    };
    return M(e) ? n.lng = e : n.lngs = e, n.ns = t, n.keyPrefix = r, n;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = t.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, n = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const a = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (t.precheck) {
      const o = t.precheck(this, a);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(r, e) && (!s || a(n, e)));
  }
  loadNamespaces(e, t) {
    const r = Ht();
    return this.options.ns ? (M(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), t && t(s);
    }), r) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const r = Ht();
    M(e) && (e = [e]);
    const s = this.options.preload || [], n = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return n.length ? (this.options.preload = s.concat(n), this.loadResources((a) => {
      r.resolve(), t && t(a);
    }), r) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Xr(Zr());
    return t.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new Gt(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : di;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, n = new Gt(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (n.logger = n.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      n[o] = this[o];
    }), n.services = {
      ...this.services
    }, n.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, r && (n.store = new Kr(this.store.data, s), n.services.resourceStore = n.store), n.translator = new wi(n.services, s), n.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
        c[h - 1] = arguments[h];
      n.emit(o, ...c);
    }), n.init(s, t), n.translator.options = s, n.translator.backendConnector.services.utils = {
      hasLoadedNamespace: n.hasLoadedNamespace.bind(n)
    }, n;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const re = Gt.createInstance();
re.createInstance = Gt.createInstance;
re.createInstance;
re.dir;
re.init;
re.loadResources;
re.reloadResources;
re.use;
re.changeLanguage;
re.getFixedT;
const vo = re.t;
re.exists;
re.setDefaultNamespace;
re.hasLoadedNamespace;
re.loadNamespaces;
re.loadLanguages;
function zt(i) {
  "@babel/helpers - typeof";
  return zt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zt(i);
}
function yo(i, e) {
  if (zt(i) != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (zt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(i);
}
function on(i) {
  var e = yo(i, "string");
  return zt(e) == "symbol" ? e : e + "";
}
function ln(i, e, t) {
  return (e = on(e)) in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function bo() {
  if (console && console.warn) {
    for (var i, e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    typeof t[0] == "string" && (t[0] = "react-i18next:: ".concat(t[0])), (i = console).warn.apply(i, t);
  }
}
var ts = {};
function Hi() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  typeof e[0] == "string" && ts[e[0]] || (typeof e[0] == "string" && (ts[e[0]] = /* @__PURE__ */ new Date()), bo.apply(void 0, e));
}
var cn = function(e, t) {
  return function() {
    if (e.isInitialized)
      t();
    else {
      var r = function s() {
        setTimeout(function() {
          e.off("initialized", s);
        }, 0), t();
      };
      e.on("initialized", r);
    }
  };
};
function is(i, e, t) {
  i.loadNamespaces(e, cn(i, t));
}
function rs(i, e, t, r) {
  typeof t == "string" && (t = [t]), t.forEach(function(s) {
    i.options.ns.indexOf(s) < 0 && i.options.ns.push(s);
  }), i.loadLanguages(e, cn(i, r));
}
function wo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = e.languages[0], s = e.options ? e.options.fallbackLng : !1, n = e.languages[e.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  var a = function(l, c) {
    var h = e.services.backendConnector.state["".concat(l, "|").concat(c)];
    return h === -1 || h === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !a(e.isLanguageChangingTo, i) ? !1 : !!(e.hasResourceBundle(r, i) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || a(r, i) && (!s || a(n, i)));
}
function xo(i, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return Hi("i18n.languages were undefined or empty", e.languages), !0;
  var r = e.options.ignoreJSONStructure !== void 0;
  return r ? e.hasLoadedNamespace(i, {
    lng: t.lng,
    precheck: function(n, a) {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !a(n.isLanguageChangingTo, i)) return !1;
    }
  }) : wo(i, e, t);
}
var Co = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, So = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Oo = function(e) {
  return So[e];
}, Eo = function(e) {
  return e.replace(Co, Oo);
};
function ss(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ns(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ss(Object(t), !0).forEach(function(r) {
      ln(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : ss(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var Vi = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Eo
};
function No() {
  var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Vi = ns(ns({}, Vi), i);
}
function _o() {
  return Vi;
}
var un;
function Ro(i) {
  un = i;
}
function Po() {
  return un;
}
function Fo(i, e) {
  if (!(i instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Do(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, on(r.key), r);
  }
}
function Io(i, e, t) {
  return e && Do(i.prototype, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
var Lo = {
  type: "3rdParty",
  init: function(e) {
    No(e.options.react), Ro(e);
  }
}, Mo = rn(), ko = (function() {
  function i() {
    Fo(this, i), this.usedNamespaces = {};
  }
  return Io(i, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var r = this;
      t.forEach(function(s) {
        r.usedNamespaces[s] || (r.usedNamespaces[s] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), i;
})();
function To(i) {
  if (Array.isArray(i)) return i;
}
function Ao(i, e) {
  var t = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (t != null) {
    var r, s, n, a, o = [], l = !0, c = !1;
    try {
      if (n = (t = t.call(i)).next, e !== 0) for (; !(l = (r = n.call(t)).done) && (o.push(r.value), o.length !== e); l = !0) ;
    } catch (h) {
      c = !0, s = h;
    } finally {
      try {
        if (!l && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (c) throw s;
      }
    }
    return o;
  }
}
function as(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function jo(i, e) {
  if (i) {
    if (typeof i == "string") return as(i, e);
    var t = {}.toString.call(i).slice(8, -1);
    return t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set" ? Array.from(i) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? as(i, e) : void 0;
  }
}
function zo() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uo(i, e) {
  return To(i) || Ao(i, e) || jo(i, e) || zo();
}
function os(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ki(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? os(Object(t), !0).forEach(function(r) {
      ln(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : os(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
var $o = function(e, t) {
  var r = we();
  return Ee(function() {
    r.current = e;
  }, [e, t]), r.current;
};
function Bo(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.i18n, r = _a(Mo) || {}, s = r.i18n, n = r.defaultNS, a = t || s || Po();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new ko()), !a) {
    Hi("You will need to pass in an i18next instance by using initReactI18next");
    var o = function(_, C) {
      return typeof C == "string" ? C : C && zt(C) === "object" && typeof C.defaultValue == "string" ? C.defaultValue : Array.isArray(_) ? _[_.length - 1] : _;
    }, l = [o, {}, !1];
    return l.t = o, l.i18n = {}, l.ready = !1, l;
  }
  a.options.react && a.options.react.wait !== void 0 && Hi("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = ki(ki(ki({}, _o()), a.options.react), e), h = c.useSuspense, d = c.keyPrefix, u = i || n || a.options && a.options.defaultNS;
  u = typeof u == "string" ? [u] : u || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(u);
  var p = (a.isInitialized || a.initializedStoreOnce) && u.every(function(O) {
    return xo(O, a, c);
  });
  function y() {
    return a.getFixedT(e.lng || null, c.nsMode === "fallback" ? u : u[0], d);
  }
  var b = V(y), m = Uo(b, 2), S = m[0], x = m[1], N = u.join();
  e.lng && (N = "".concat(e.lng).concat(N));
  var w = $o(N), R = we(!0);
  Ee(function() {
    var O = c.bindI18n, _ = c.bindI18nStore;
    R.current = !0, !p && !h && (e.lng ? rs(a, e.lng, u, function() {
      R.current && x(y);
    }) : is(a, u, function() {
      R.current && x(y);
    })), p && w && w !== N && R.current && x(y);
    function C() {
      R.current && x(y);
    }
    return O && a && a.on(O, C), _ && a && a.store.on(_, C), function() {
      R.current = !1, O && a && O.split(" ").forEach(function(F) {
        return a.off(F, C);
      }), _ && a && _.split(" ").forEach(function(F) {
        return a.store.off(F, C);
      });
    };
  }, [a, N]);
  var g = we(!0);
  Ee(function() {
    R.current && !g.current && x(y), g.current = !1;
  }, [a, d]);
  var E = [S, a, p];
  if (E.t = S, E.i18n = a, E.ready = p, p || !p && !h) return E;
  throw new Promise(function(O) {
    e.lng ? rs(a, e.lng, u, function() {
      return O();
    }) : is(a, u, function() {
      return O();
    });
  });
}
const hn = { cancel: "Cancel", cancelled: "Cancelled", confirm: "Confirm", confirm_action: "Confirm action", created_at: "Created at", delete: "Delete", download: "Download", error: "Error", errors: { conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!", fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue", internal_error_message: "Something went wrong. Please try again", payload_to_large_error_message: "The file size is too big" }, file: "File", file_deleted_successfully: "Deleted successfully", file_details: "File details", file_renamed_successfully: "Renamed successfully", file_selector: { choose_file: "Choose a file", enter_new_file_name: "Enter a new file name", failed_delete_file: "Failed to delete file", failed_download_file: "Failed to download file", failed_rename_file: "Failed to rename file", file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?', file_name: "File name", files_selected: "file selected", rename_file: "Rename file", search_file: "Search file" }, file_source: { block_preview: "Block preview", blog_post: "Blog post", blog_template_preview: "Blog template preview", calendar_host_avatar: "Calendar", ckeditor: "CKEditor", community: "Community", digital_product_resource: "Digital product resource", digital_store: "Creator store", editor: "Editor", email: "Email", email_template: "Email template", file_manager: "File manager", funnel_template_preview: "Funnel template preview", marketplace: "Marketplace", membership: "Membership", page_template: "Page template", page_template_preview: "Page template preview", product: "Product", settings: "Settings", text_editor: "Text editor", website_template: "Website template", white_label: "White Label" }, file_type: { audio: "Audio", document: "Document", font: "Font", image: "Image", image_other: "Other image", video: "Video" }, file_upload: { crop_and_select_file: "Crop and select an image", crop_file: "Crop image ", drop_files_here: "Drag and drop your files here, or click to browse", file_not_supported: "File type not supported", upload_and_select_file: "Upload and select", upload_files: "Upload files", uploaded_successfully: "Successfully uploaded" }, image_cropper: { aspect_ratio: { need_to_crop: "Crop image before selecting", need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one" }, rounded_crop: "Circle", square_crop: "Square" }, name: "Name", preview: "Preview", processing_size: "Processing", rename: "Rename", search: "Search", select: "Select", select_source: "Select source", select_type: "Select file type", size: "Size", something_went_wrong: "Something went wrong", title: "File Manager", type: "Type", upload: "Upload" }, dn = {
  file_manager: hn
}, Ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dn,
  file_manager: hn
}, Symbol.toStringTag, { value: "Module" })), Ri = ["common"], xr = Ri[0], Vo = Object.values(Ui), Wo = {
  en: { common: dn }
}, qo = {
  supportedLngs: Vo,
  load: "languageOnly",
  debug: !1,
  defaultNS: xr,
  react: { useSuspense: !1 },
  ns: Ri,
  fallbackLng: Ui.ENGLISH,
  lng: Ui.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Wo,
  returnEmptyString: !1
};
re.use(Lo).init(qo);
const Qo = async (i) => {
  const e = await qa(/* @__PURE__ */ Object.assign({ "./assets/translations/locales/ar/common.json": () => import("./common-BiUNQUaO.mjs"), "./assets/translations/locales/cs/common.json": () => import("./common-BIX_yG0z.mjs"), "./assets/translations/locales/da/common.json": () => import("./common-CmWLPwEQ.mjs"), "./assets/translations/locales/de/common.json": () => import("./common-Cw7xctGt.mjs"), "./assets/translations/locales/el/common.json": () => import("./common-Hc-JLLAK.mjs"), "./assets/translations/locales/en/common.json": () => Promise.resolve().then(() => Ho), "./assets/translations/locales/es/common.json": () => import("./common-B7s-uvsB.mjs"), "./assets/translations/locales/fr/common.json": () => import("./common-CJhbNkOt.mjs"), "./assets/translations/locales/hi/common.json": () => import("./common-D_1a0VK4.mjs"), "./assets/translations/locales/hu/common.json": () => import("./common-BFtA733L.mjs"), "./assets/translations/locales/id/common.json": () => import("./common-DPD4uoZv.mjs"), "./assets/translations/locales/it/common.json": () => import("./common-da2y9628.mjs"), "./assets/translations/locales/ja/common.json": () => import("./common-4CePQuUB.mjs"), "./assets/translations/locales/nl/common.json": () => import("./common-CO2CqQbx.mjs"), "./assets/translations/locales/no/common.json": () => import("./common-q62t7SjF.mjs"), "./assets/translations/locales/pl/common.json": () => import("./common-SMnVlqFb.mjs"), "./assets/translations/locales/pt/common.json": () => import("./common-DVUmkw6s.mjs"), "./assets/translations/locales/ro/common.json": () => import("./common-CsHcJ2fo.mjs"), "./assets/translations/locales/ru/common.json": () => import("./common-DmVn9jDc.mjs"), "./assets/translations/locales/sk/common.json": () => import("./common-CAwDBH5P.mjs"), "./assets/translations/locales/sl/common.json": () => import("./common-D1Zm1O5M.mjs"), "./assets/translations/locales/sq/common.json": () => import("./common-x8PV9oQa.mjs"), "./assets/translations/locales/sr/common.json": () => import("./common-V3y_kBN2.mjs"), "./assets/translations/locales/sv/common.json": () => import("./common-6vfySZ_P.mjs"), "./assets/translations/locales/th/common.json": () => import("./common-BEsAg02f.mjs"), "./assets/translations/locales/tr/common.json": () => import("./common-44Gw3LKu.mjs"), "./assets/translations/locales/uk/common.json": () => import("./common-CqzCbrIf.mjs"), "./assets/translations/locales/zh/common.json": () => import("./common-DFrWFbD7.mjs") }), `./assets/translations/locales/${i}/common.json`, 6);
  return re.addResourceBundle(i, xr, {
    file_manager: e.default.file_manager
  }), e;
}, fn = () => Ri, pn = (i) => i.startsWith("core.error.") ? i.replace("core.error.", "file_manager.errors.") : i.replace(/^(global\.|core\.)/g, "file_manager."), gn = Ca(vo, fn, pn), pe = Sa({
  useTranslation: Bo,
  defaultNamespaces: Ri,
  namespaceMapper: fn,
  assetKeyMapper: pn
}), Cr = Oa(), Ot = Ea({
  httpClient: Cr,
  useLocoTranslation: pe,
  useRouter: () => ({
    push: async (i) => (window.location.assign(i), !0),
    replace: async (i) => (window.location.replace(i), !0)
  })
});
function Ko(i, e = 2, t) {
  if (i < 0) return (t == null ? void 0 : t.whenNegative) ?? gn("file_manager.processing_size");
  if (i === 0) return "0 Bytes";
  const r = 1024, s = e < 0 ? 0 : e, n = ["Bytes", "KB", "MB", "GB"], a = Math.floor(Math.log(i) / Math.log(r));
  return parseFloat((i / Math.pow(r, a)).toFixed(s)) + " " + n[a];
}
const Yo = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function Wi(i) {
  var t;
  const e = (t = i.name.split(".").pop()) == null ? void 0 : t.toLowerCase();
  return i.type.startsWith("image/") || Yo.includes(e ?? "-");
}
async function mn(i) {
  return new Promise((e, t) => {
    const r = new Image();
    r.src = i, r.crossOrigin = "Anonymous", r.onload = () => {
      const s = r.width / r.height;
      e([r, s]);
    }, r.onerror = (s) => {
      t(new Error("Failed to load image"));
    };
  });
}
function vn(i, e, t = 0.02) {
  return Math.abs(i - e) < t;
}
function yn(i, e = 0.02) {
  const r = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((s) => Math.abs(i - s.value) < e);
  return r == null ? void 0 : r.label;
}
function Xo(i, e = 0.02) {
  const t = yn(i, e);
  let r = gn("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return t && (r += ` ${t}`), r;
}
function ls(i, e) {
  if (!e || isNaN(e))
    return i;
  const t = yn(e);
  if (!t)
    return i;
  const r = t.replace(/[\s:]+/g, "_"), s = i.name.split(".").pop(), a = `${i.name.replace(/\.[^.]+$/, "")}_${r}.${s}`;
  return new File([i], a, {
    type: i.type,
    lastModified: i.lastModified
  });
}
function Go(i, e) {
  return {
    id: i.id,
    name: i.filename,
    filename: i.filename,
    path: i.path,
    thumbnail: i.thumbnail || null,
    source: e,
    size: i.size,
    type: i.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
async function Jo(i, e, t = "image/png") {
  const r = new OffscreenCanvas(i.width, i.height), s = r.getContext("2d");
  if (!s) throw new Error("Canvas context is not available");
  s.drawImage(i, 0, 0);
  const n = await r.convertToBlob({ type: t });
  return new File([n], e, { type: t });
}
function cs(i, e) {
  const t = we(null);
  Ee(() => {
    t.current !== null && e(t.current, i), t.current = i;
  }, [i]);
}
function us(i, e) {
  return {
    added: e.filter((t) => !i.includes(t)),
    removed: i.filter((t) => !e.includes(t))
  };
}
async function Zo(i) {
  const e = await i.arrayBuffer(), t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
function hs(i, e) {
  const s = `${i.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([e], s, {
    type: "image/png",
    lastModified: i.lastModified
  });
}
const Iu = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, ds = (i, e) => e.some((t) => {
  if (t.includes("*")) {
    const r = t.replace("*", ".*");
    return new RegExp(`^${r}$`).test(i);
  } else
    return i.toLowerCase() === t.toLowerCase();
}), el = (i) => i.join(", ");
function Lu(i) {
  var l;
  const e = (l = i.split(".").pop()) == null ? void 0 : l.toLowerCase();
  if (!e) return X.Document;
  const t = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], r = ["tiff", "heic", "raw"], s = ["mp4", "mov", "avi", "mkv", "webm"], n = ["mp3", "wav", "ogg", "aac", "flac"], a = ["ttf", "otf", "woff", "woff2"], o = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return t.includes(e) ? X.Image : r.includes(e) ? X.ImageOther : s.includes(e) ? X.Video : n.includes(e) ? X.Audio : a.includes(e) ? X.Font : (o.includes(e), X.Document);
}
function tl({
  fileType: i,
  src: e,
  alt: t,
  name: r,
  size: s,
  className: n,
  onClose: a,
  showCloseButton: o = !0,
  isFetching: l
}) {
  const { t: c } = pe();
  return l ? /* @__PURE__ */ T("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ v("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v($r, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ T("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ v("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ v("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ T("div", { className: ie("flex w-full flex-col items-end", n), children: [
    o && /* @__PURE__ */ v("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v($r, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ T("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v(pt, { src: e ?? "", fileType: i, alt: t }),
      r && /* @__PURE__ */ T($i, { children: [
        /* @__PURE__ */ v(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.name")
          }
        ),
        /* @__PURE__ */ v(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: r,
            style: { lineHeight: 1.1 },
            children: r
          }
        )
      ] }),
      typeof s == "number" && /* @__PURE__ */ T($i, { children: [
        /* @__PURE__ */ v(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: c("file_manager.size")
          }
        ),
        /* @__PURE__ */ v(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: Ko(s)
          }
        )
      ] })
    ] })
  ] });
}
const bn = Oe.memo(({ file: i, className: e }) => i.type.startsWith("image/") ? /* @__PURE__ */ v(
  pt,
  {
    src: URL.createObjectURL(i),
    fileType: X.Image,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : i.type === "application/pdf" ? /* @__PURE__ */ v(
  "div",
  {
    className: ie(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      e
    ),
    title: i.name,
    children: /* @__PURE__ */ v(
      "embed",
      {
        src: URL.createObjectURL(i),
        type: i.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : i.type.startsWith("video/") ? /* @__PURE__ */ v(
  pt,
  {
    src: URL.createObjectURL(i),
    fileType: X.Video,
    alt: i.name,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
) : /* @__PURE__ */ v(
  pt,
  {
    src: "",
    fileType: X.Document,
    className: e,
    isThumbnail: !0,
    title: i.name
  }
));
bn.displayName = "FilePreviewFromOS";
function fs({
  opened: i,
  onClose: e,
  onConfirm: t,
  onDecline: r,
  title: s,
  confirmationText: n = "",
  className: a,
  cancelButtonCaption: o,
  confirmButtonCaption: l,
  buttonClassName: c,
  buttonTextClassName: h,
  confirmationContent: d,
  afterLeave: u
}) {
  const { t: p } = pe(), [y, b] = V(""), [m, S] = V(!1), [x, N] = V(!1), w = async () => {
    try {
      S(!0), await t(), S(!1), N(!0);
    } catch {
      S(!1), b(p("file_manager.something_went_wrong"));
    }
  }, R = () => {
    b(""), N(!1);
  };
  return /* @__PURE__ */ v(
    Ei,
    {
      opened: i,
      onClose: () => {
        !x && r && r(), e();
      },
      title: s || p("file_manager.confirm_action"),
      afterLeave: () => {
        u && u(), R();
      },
      isFetching: m,
      isCentered: !0,
      className: a,
      children: /* @__PURE__ */ T("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        n && /* @__PURE__ */ v("div", { className: "flex justify-center", children: /* @__PURE__ */ v("p", { className: "text-text-primary text-base", children: n }) }),
        d,
        /* @__PURE__ */ T("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ v(
            oi,
            {
              isFetching: m,
              className: ie("w-full", c),
              buttonTextClassName: h,
              width: "large",
              onClick: async (g) => {
                g.preventDefault(), await w();
              },
              type: "submit",
              children: l || p("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ v(
            tn,
            {
              className: ie("w-full", c),
              width: "large",
              buttonTextClassName: h,
              onClick: (g) => {
                g.preventDefault(), r && r(), e();
              },
              disabled: m,
              children: o || p("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ v(mi, { error: y, errorClassName: "text-center" })
      ] })
    }
  );
}
function il({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ v(
    Ni,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ T("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ v(
          Da,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.file_details")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function rl({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ v(
    Ni,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ T("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ v(
          Ia,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.delete")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function sl({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ v(
    Ni,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ T("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ v(
          La,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.rename")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function nl({ label: i, ...e }) {
  const { t } = pe();
  return /* @__PURE__ */ v(
    Ni,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: i ?? /* @__PURE__ */ T("div", { className: "text-text-primary group-hover:text-brand-primary main-transition-colors flex items-center gap-2", children: [
        /* @__PURE__ */ v(
          Ma,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        t("file_manager.download")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
var li = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(i) {
    return this.listeners.add(i), this.onSubscribe(), () => {
      this.listeners.delete(i), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, al = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (i, e) => setTimeout(i, e),
  clearTimeout: (i) => clearTimeout(i),
  setInterval: (i, e) => setInterval(i, e),
  clearInterval: (i) => clearInterval(i)
}, Fe, st, Ws, ol = (Ws = class {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    L(this, Fe, al);
    L(this, st, !1);
  }
  setTimeoutProvider(i) {
    process.env.NODE_ENV !== "production" && f(this, st) && i !== f(this, Fe) && console.error(
      "[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.",
      { previous: f(this, Fe), provider: i }
    ), P(this, Fe, i), process.env.NODE_ENV !== "production" && P(this, st, !1);
  }
  setTimeout(i, e) {
    return process.env.NODE_ENV !== "production" && P(this, st, !0), f(this, Fe).setTimeout(i, e);
  }
  clearTimeout(i) {
    f(this, Fe).clearTimeout(i);
  }
  setInterval(i, e) {
    return process.env.NODE_ENV !== "production" && P(this, st, !0), f(this, Fe).setInterval(i, e);
  }
  clearInterval(i) {
    f(this, Fe).clearInterval(i);
  }
}, Fe = new WeakMap(), st = new WeakMap(), Ws), rt = new ol();
function ll(i) {
  setTimeout(i, 0);
}
var gt = typeof window > "u" || "Deno" in globalThis;
function ve() {
}
function cl(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function qi(i) {
  return typeof i == "number" && i >= 0 && i !== 1 / 0;
}
function wn(i, e) {
  return Math.max(i + (e || 0) - Date.now(), 0);
}
function Je(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function Se(i, e) {
  return typeof i == "function" ? i(e) : i;
}
function ps(i, e) {
  const {
    type: t = "all",
    exact: r,
    fetchStatus: s,
    predicate: n,
    queryKey: a,
    stale: o
  } = i;
  if (a) {
    if (r) {
      if (e.queryHash !== Sr(a, e.options))
        return !1;
    } else if (!Zt(e.queryKey, a))
      return !1;
  }
  if (t !== "all") {
    const l = e.isActive();
    if (t === "active" && !l || t === "inactive" && l)
      return !1;
  }
  return !(typeof o == "boolean" && e.isStale() !== o || s && s !== e.state.fetchStatus || n && !n(e));
}
function gs(i, e) {
  const { exact: t, status: r, predicate: s, mutationKey: n } = i;
  if (n) {
    if (!e.options.mutationKey)
      return !1;
    if (t) {
      if (Jt(e.options.mutationKey) !== Jt(n))
        return !1;
    } else if (!Zt(e.options.mutationKey, n))
      return !1;
  }
  return !(r && e.state.status !== r || s && !s(e));
}
function Sr(i, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Jt)(i);
}
function Jt(i) {
  return JSON.stringify(
    i,
    (e, t) => Yi(t) ? Object.keys(t).sort().reduce((r, s) => (r[s] = t[s], r), {}) : t
  );
}
function Zt(i, e) {
  return i === e ? !0 : typeof i != typeof e ? !1 : i && e && typeof i == "object" && typeof e == "object" ? Object.keys(e).every((t) => Zt(i[t], e[t])) : !1;
}
var ul = Object.prototype.hasOwnProperty;
function Qi(i, e) {
  if (i === e)
    return i;
  const t = ms(i) && ms(e);
  if (!t && !(Yi(i) && Yi(e))) return e;
  const s = (t ? i : Object.keys(i)).length, n = t ? e : Object.keys(e), a = n.length, o = t ? new Array(a) : {};
  let l = 0;
  for (let c = 0; c < a; c++) {
    const h = t ? c : n[c], d = i[h], u = e[h];
    if (d === u) {
      o[h] = d, (t ? c < s : ul.call(i, h)) && l++;
      continue;
    }
    if (d === null || u === null || typeof d != "object" || typeof u != "object") {
      o[h] = u;
      continue;
    }
    const p = Qi(d, u);
    o[h] = p, p === d && l++;
  }
  return s === a && l === s ? i : o;
}
function Ki(i, e) {
  if (!e || Object.keys(i).length !== Object.keys(e).length)
    return !1;
  for (const t in i)
    if (i[t] !== e[t])
      return !1;
  return !0;
}
function ms(i) {
  return Array.isArray(i) && i.length === Object.keys(i).length;
}
function Yi(i) {
  if (!vs(i))
    return !1;
  const e = i.constructor;
  if (e === void 0)
    return !0;
  const t = e.prototype;
  return !(!vs(t) || !t.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(i) !== Object.prototype);
}
function vs(i) {
  return Object.prototype.toString.call(i) === "[object Object]";
}
function hl(i) {
  return new Promise((e) => {
    rt.setTimeout(e, i);
  });
}
function Xi(i, e, t) {
  if (typeof t.structuralSharing == "function")
    return t.structuralSharing(i, e);
  if (t.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Qi(i, e);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${t.queryHash}]: ${r}`
        ), r;
      }
    return Qi(i, e);
  }
  return e;
}
function dl(i, e, t = 0) {
  const r = [...i, e];
  return t && r.length > t ? r.slice(1) : r;
}
function fl(i, e, t = 0) {
  const r = [e, ...i];
  return t && r.length > t ? r.slice(0, -1) : r;
}
var xi = Symbol();
function xn(i, e) {
  return process.env.NODE_ENV !== "production" && i.queryFn === xi && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${i.queryHash}'`
  ), !i.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !i.queryFn || i.queryFn === xi ? () => Promise.reject(new Error(`Missing queryFn: '${i.queryHash}'`)) : i.queryFn;
}
function pl(i, e) {
  return typeof i == "function" ? i(...e) : !!i;
}
var nt, He, _t, qs, gl = (qs = class extends li {
  constructor() {
    super();
    L(this, nt);
    L(this, He);
    L(this, _t);
    P(this, _t, (e) => {
      if (!gt && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    });
  }
  onSubscribe() {
    f(this, He) || this.setEventListener(f(this, _t));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = f(this, He)) == null || e.call(this), P(this, He, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, _t, e), (t = f(this, He)) == null || t.call(this), P(this, He, e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(e) {
    f(this, nt) !== e && (P(this, nt, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    var e;
    return typeof f(this, nt) == "boolean" ? f(this, nt) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, nt = new WeakMap(), He = new WeakMap(), _t = new WeakMap(), qs), Or = new gl();
function Gi() {
  let i, e;
  const t = new Promise((s, n) => {
    i = s, e = n;
  });
  t.status = "pending", t.catch(() => {
  });
  function r(s) {
    Object.assign(t, s), delete t.resolve, delete t.reject;
  }
  return t.resolve = (s) => {
    r({
      status: "fulfilled",
      value: s
    }), i(s);
  }, t.reject = (s) => {
    r({
      status: "rejected",
      reason: s
    }), e(s);
  }, t;
}
var ml = ll;
function vl() {
  let i = [], e = 0, t = (o) => {
    o();
  }, r = (o) => {
    o();
  }, s = ml;
  const n = (o) => {
    e ? i.push(o) : s(() => {
      t(o);
    });
  }, a = () => {
    const o = i;
    i = [], o.length && s(() => {
      r(() => {
        o.forEach((l) => {
          t(l);
        });
      });
    });
  };
  return {
    batch: (o) => {
      let l;
      e++;
      try {
        l = o();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (o) => (...l) => {
      n(() => {
        o(...l);
      });
    },
    schedule: n,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (o) => {
      t = o;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (o) => {
      r = o;
    },
    setScheduler: (o) => {
      s = o;
    }
  };
}
var ce = vl(), Rt, Ve, Pt, Qs, yl = (Qs = class extends li {
  constructor() {
    super();
    L(this, Rt, !0);
    L(this, Ve);
    L(this, Pt);
    P(this, Pt, (e) => {
      if (!gt && window.addEventListener) {
        const t = () => e(!0), r = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    f(this, Ve) || this.setEventListener(f(this, Pt));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = f(this, Ve)) == null || e.call(this), P(this, Ve, void 0));
  }
  setEventListener(e) {
    var t;
    P(this, Pt, e), (t = f(this, Ve)) == null || t.call(this), P(this, Ve, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    f(this, Rt) !== e && (P(this, Rt, e), this.listeners.forEach((r) => {
      r(e);
    }));
  }
  isOnline() {
    return f(this, Rt);
  }
}, Rt = new WeakMap(), Ve = new WeakMap(), Pt = new WeakMap(), Qs), Ci = new yl();
function bl(i) {
  return Math.min(1e3 * 2 ** i, 3e4);
}
function Cn(i) {
  return (i ?? "online") === "online" ? Ci.isOnline() : !0;
}
var Ji = class extends Error {
  constructor(i) {
    super("CancelledError"), this.revert = i == null ? void 0 : i.revert, this.silent = i == null ? void 0 : i.silent;
  }
};
function Sn(i) {
  let e = !1, t = 0, r;
  const s = Gi(), n = () => s.status !== "pending", a = (b) => {
    var m;
    if (!n()) {
      const S = new Ji(b);
      u(S), (m = i.onCancel) == null || m.call(i, S);
    }
  }, o = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, c = () => Or.isFocused() && (i.networkMode === "always" || Ci.isOnline()) && i.canRun(), h = () => Cn(i.networkMode) && i.canRun(), d = (b) => {
    n() || (r == null || r(), s.resolve(b));
  }, u = (b) => {
    n() || (r == null || r(), s.reject(b));
  }, p = () => new Promise((b) => {
    var m;
    r = (S) => {
      (n() || c()) && b(S);
    }, (m = i.onPause) == null || m.call(i);
  }).then(() => {
    var b;
    r = void 0, n() || (b = i.onContinue) == null || b.call(i);
  }), y = () => {
    if (n())
      return;
    let b;
    const m = t === 0 ? i.initialPromise : void 0;
    try {
      b = m ?? i.fn();
    } catch (S) {
      b = Promise.reject(S);
    }
    Promise.resolve(b).then(d).catch((S) => {
      var g;
      if (n())
        return;
      const x = i.retry ?? (gt ? 0 : 3), N = i.retryDelay ?? bl, w = typeof N == "function" ? N(t, S) : N, R = x === !0 || typeof x == "number" && t < x || typeof x == "function" && x(t, S);
      if (e || !R) {
        u(S);
        return;
      }
      t++, (g = i.onFail) == null || g.call(i, t, S), hl(w).then(() => c() ? void 0 : p()).then(() => {
        e ? u(S) : y();
      });
    });
  };
  return {
    promise: s,
    status: () => s.status,
    cancel: a,
    continue: () => (r == null || r(), s),
    cancelRetry: o,
    continueRetry: l,
    canStart: h,
    start: () => (h() ? y() : p().then(y), s)
  };
}
var at, Ks, On = (Ks = class {
  constructor() {
    L(this, at);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), qi(this.gcTime) && P(this, at, rt.setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(i) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      i ?? (gt ? 1 / 0 : 300 * 1e3)
    );
  }
  clearGcTimeout() {
    f(this, at) && (rt.clearTimeout(f(this, at)), P(this, at, void 0));
  }
}, at = new WeakMap(), Ks), ot, Ft, Ce, lt, oe, ii, ct, Re, Ae, Ys, wl = (Ys = class extends On {
  constructor(e) {
    super();
    L(this, Re);
    L(this, ot);
    L(this, Ft);
    L(this, Ce);
    L(this, lt);
    L(this, oe);
    L(this, ii);
    L(this, ct);
    P(this, ct, !1), P(this, ii, e.defaultOptions), this.setOptions(e.options), this.observers = [], P(this, lt, e.client), P(this, Ce, f(this, lt).getQueryCache()), this.queryKey = e.queryKey, this.queryHash = e.queryHash, P(this, ot, bs(this.options)), this.state = e.state ?? f(this, ot), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = f(this, oe)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    if (this.options = { ...f(this, ii), ...e }, this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
      const t = bs(this.options);
      t.data !== void 0 && (this.setState(
        ys(t.data, t.dataUpdatedAt)
      ), P(this, ot, t));
    }
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && f(this, Ce).remove(this);
  }
  setData(e, t) {
    const r = Xi(this.state.data, e, this.options);
    return B(this, Re, Ae).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), r;
  }
  setState(e, t) {
    B(this, Re, Ae).call(this, { type: "setState", state: e, setStateOptions: t });
  }
  cancel(e) {
    var r, s;
    const t = (r = f(this, oe)) == null ? void 0 : r.promise;
    return (s = f(this, oe)) == null || s.cancel(e), t ? t.then(ve).catch(ve) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(f(this, ot));
  }
  isActive() {
    return this.observers.some(
      (e) => Se(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === xi || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (e) => Je(e.options.staleTime, this) === "static"
    ) : !1;
  }
  isStale() {
    return this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(e = 0) {
    return this.state.data === void 0 ? !0 : e === "static" ? !1 : this.state.isInvalidated ? !0 : !wn(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = f(this, oe)) == null || t.continue();
  }
  onOnline() {
    var t;
    const e = this.observers.find((r) => r.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (t = f(this, oe)) == null || t.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), f(this, Ce).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (f(this, oe) && (f(this, ct) ? f(this, oe).cancel({ revert: !0 }) : f(this, oe).cancelRetry()), this.scheduleGc()), f(this, Ce).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || B(this, Re, Ae).call(this, { type: "invalidate" });
  }
  async fetch(e, t) {
    var l, c, h, d, u, p, y, b, m, S, x, N;
    if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
    // re-start the fetch; there is a chance that the query is still in a
    // pending state when that happens
    ((l = f(this, oe)) == null ? void 0 : l.status()) !== "rejected") {
      if (this.state.data !== void 0 && (t != null && t.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (f(this, oe))
        return f(this, oe).continueRetry(), f(this, oe).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const w = this.observers.find((R) => R.options.queryFn);
      w && this.setOptions(w.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), s = (w) => {
      Object.defineProperty(w, "signal", {
        enumerable: !0,
        get: () => (P(this, ct, !0), r.signal)
      });
    }, n = () => {
      const w = xn(this.options, t), g = (() => {
        const E = {
          client: f(this, lt),
          queryKey: this.queryKey,
          meta: this.meta
        };
        return s(E), E;
      })();
      return P(this, ct, !1), this.options.persister ? this.options.persister(
        w,
        g,
        this
      ) : w(g);
    }, o = (() => {
      const w = {
        fetchOptions: t,
        options: this.options,
        queryKey: this.queryKey,
        client: f(this, lt),
        state: this.state,
        fetchFn: n
      };
      return s(w), w;
    })();
    (c = this.options.behavior) == null || c.onFetch(o, this), P(this, Ft, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((h = o.fetchOptions) == null ? void 0 : h.meta)) && B(this, Re, Ae).call(this, { type: "fetch", meta: (d = o.fetchOptions) == null ? void 0 : d.meta }), P(this, oe, Sn({
      initialPromise: t == null ? void 0 : t.initialPromise,
      fn: o.fetchFn,
      onCancel: (w) => {
        w instanceof Ji && w.revert && this.setState({
          ...f(this, Ft),
          fetchStatus: "idle"
        }), r.abort();
      },
      onFail: (w, R) => {
        B(this, Re, Ae).call(this, { type: "failed", failureCount: w, error: R });
      },
      onPause: () => {
        B(this, Re, Ae).call(this, { type: "pause" });
      },
      onContinue: () => {
        B(this, Re, Ae).call(this, { type: "continue" });
      },
      retry: o.options.retry,
      retryDelay: o.options.retryDelay,
      networkMode: o.options.networkMode,
      canRun: () => !0
    }));
    try {
      const w = await f(this, oe).start();
      if (w === void 0)
        throw process.env.NODE_ENV !== "production" && console.error(
          `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
        ), new Error(`${this.queryHash} data is undefined`);
      return this.setData(w), (p = (u = f(this, Ce).config).onSuccess) == null || p.call(u, w, this), (b = (y = f(this, Ce).config).onSettled) == null || b.call(
        y,
        w,
        this.state.error,
        this
      ), w;
    } catch (w) {
      if (w instanceof Ji) {
        if (w.silent)
          return f(this, oe).promise;
        if (w.revert) {
          if (this.state.data === void 0)
            throw w;
          return this.state.data;
        }
      }
      throw B(this, Re, Ae).call(this, {
        type: "error",
        error: w
      }), (S = (m = f(this, Ce).config).onError) == null || S.call(
        m,
        w,
        this
      ), (N = (x = f(this, Ce).config).onSettled) == null || N.call(
        x,
        this.state.data,
        w,
        this
      ), w;
    } finally {
      this.scheduleGc();
    }
  }
}, ot = new WeakMap(), Ft = new WeakMap(), Ce = new WeakMap(), lt = new WeakMap(), oe = new WeakMap(), ii = new WeakMap(), ct = new WeakMap(), Re = new WeakSet(), Ae = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...En(r.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        const s = {
          ...r,
          ...ys(e.data, e.dataUpdatedAt),
          dataUpdateCount: r.dataUpdateCount + 1,
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
        return P(this, Ft, e.manual ? s : void 0), s;
      case "error":
        const n = e.error;
        return {
          ...r,
          error: n,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: n,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...e.state
        };
    }
  };
  this.state = t(this.state), ce.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), f(this, Ce).notify({ query: this, type: "updated", action: e });
  });
}, Ys);
function En(i, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Cn(e.networkMode) ? "fetching" : "paused",
    ...i === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function ys(i, e) {
  return {
    data: i,
    dataUpdatedAt: e ?? Date.now(),
    error: null,
    isInvalidated: !1,
    status: "success"
  };
}
function bs(i) {
  const e = typeof i.initialData == "function" ? i.initialData() : i.initialData, t = e !== void 0, r = t ? typeof i.initialDataUpdatedAt == "function" ? i.initialDataUpdatedAt() : i.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: t ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: t ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var ge, H, ri, de, ut, Dt, je, We, si, It, Lt, ht, dt, qe, Mt, q, Kt, Zi, er, tr, ir, rr, sr, nr, _n, Xs, Nn = (Xs = class extends li {
  constructor(e, t) {
    super();
    L(this, q);
    L(this, ge);
    L(this, H);
    L(this, ri);
    L(this, de);
    L(this, ut);
    L(this, Dt);
    L(this, je);
    L(this, We);
    L(this, si);
    L(this, It);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    L(this, Lt);
    L(this, ht);
    L(this, dt);
    L(this, qe);
    L(this, Mt, /* @__PURE__ */ new Set());
    this.options = t, P(this, ge, e), P(this, We, null), P(this, je, Gi()), this.bindMethods(), this.setOptions(t);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (f(this, H).addObserver(this), ws(f(this, H), this.options) ? B(this, q, Kt).call(this) : this.updateResult(), B(this, q, ir).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return ar(
      f(this, H),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return ar(
      f(this, H),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), B(this, q, rr).call(this), B(this, q, sr).call(this), f(this, H).removeObserver(this);
  }
  setOptions(e) {
    const t = this.options, r = f(this, H);
    if (this.options = f(this, ge).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Se(this.options.enabled, f(this, H)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    B(this, q, nr).call(this), f(this, H).setOptions(this.options), t._defaulted && !Ki(this.options, t) && f(this, ge).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: f(this, H),
      observer: this
    });
    const s = this.hasListeners();
    s && xs(
      f(this, H),
      r,
      this.options,
      t
    ) && B(this, q, Kt).call(this), this.updateResult(), s && (f(this, H) !== r || Se(this.options.enabled, f(this, H)) !== Se(t.enabled, f(this, H)) || Je(this.options.staleTime, f(this, H)) !== Je(t.staleTime, f(this, H))) && B(this, q, Zi).call(this);
    const n = B(this, q, er).call(this);
    s && (f(this, H) !== r || Se(this.options.enabled, f(this, H)) !== Se(t.enabled, f(this, H)) || n !== f(this, qe)) && B(this, q, tr).call(this, n);
  }
  getOptimisticResult(e) {
    const t = f(this, ge).getQueryCache().build(f(this, ge), e), r = this.createResult(t, e);
    return Cl(this, r) && (P(this, de, r), P(this, Dt, this.options), P(this, ut, f(this, H).state)), r;
  }
  getCurrentResult() {
    return f(this, de);
  }
  trackResult(e, t) {
    return new Proxy(e, {
      get: (r, s) => (this.trackProp(s), t == null || t(s), s === "promise" && (this.trackProp("data"), !this.options.experimental_prefetchInRender && f(this, je).status === "pending" && f(this, je).reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      )), Reflect.get(r, s))
    });
  }
  trackProp(e) {
    f(this, Mt).add(e);
  }
  getCurrentQuery() {
    return f(this, H);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const t = f(this, ge).defaultQueryOptions(e), r = f(this, ge).getQueryCache().build(f(this, ge), t);
    return r.fetch().then(() => this.createResult(r, t));
  }
  fetch(e) {
    return B(this, q, Kt).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), f(this, de)));
  }
  createResult(e, t) {
    var _;
    const r = f(this, H), s = this.options, n = f(this, de), a = f(this, ut), o = f(this, Dt), c = e !== r ? e.state : f(this, ri), { state: h } = e;
    let d = { ...h }, u = !1, p;
    if (t._optimisticResults) {
      const C = this.hasListeners(), F = !C && ws(e, t), I = C && xs(e, r, t, s);
      (F || I) && (d = {
        ...d,
        ...En(h.data, e.options)
      }), t._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: y, errorUpdatedAt: b, status: m } = d;
    p = d.data;
    let S = !1;
    if (t.placeholderData !== void 0 && p === void 0 && m === "pending") {
      let C;
      n != null && n.isPlaceholderData && t.placeholderData === (o == null ? void 0 : o.placeholderData) ? (C = n.data, S = !0) : C = typeof t.placeholderData == "function" ? t.placeholderData(
        (_ = f(this, Lt)) == null ? void 0 : _.state.data,
        f(this, Lt)
      ) : t.placeholderData, C !== void 0 && (m = "success", p = Xi(
        n == null ? void 0 : n.data,
        C,
        t
      ), u = !0);
    }
    if (t.select && p !== void 0 && !S)
      if (n && p === (a == null ? void 0 : a.data) && t.select === f(this, si))
        p = f(this, It);
      else
        try {
          P(this, si, t.select), p = t.select(p), p = Xi(n == null ? void 0 : n.data, p, t), P(this, It, p), P(this, We, null);
        } catch (C) {
          P(this, We, C);
        }
    f(this, We) && (y = f(this, We), p = f(this, It), b = Date.now(), m = "error");
    const x = d.fetchStatus === "fetching", N = m === "pending", w = m === "error", R = N && x, g = p !== void 0, O = {
      status: m,
      fetchStatus: d.fetchStatus,
      isPending: N,
      isSuccess: m === "success",
      isError: w,
      isInitialLoading: R,
      isLoading: R,
      data: p,
      dataUpdatedAt: d.dataUpdatedAt,
      error: y,
      errorUpdatedAt: b,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: x,
      isRefetching: x && !N,
      isLoadingError: w && !g,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: u,
      isRefetchError: w && g,
      isStale: Er(e, t),
      refetch: this.refetch,
      promise: f(this, je),
      isEnabled: Se(t.enabled, e) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const C = (A) => {
        O.status === "error" ? A.reject(O.error) : O.data !== void 0 && A.resolve(O.data);
      }, F = () => {
        const A = P(this, je, O.promise = Gi());
        C(A);
      }, I = f(this, je);
      switch (I.status) {
        case "pending":
          e.queryHash === r.queryHash && C(I);
          break;
        case "fulfilled":
          (O.status === "error" || O.data !== I.value) && F();
          break;
        case "rejected":
          (O.status !== "error" || O.error !== I.reason) && F();
          break;
      }
    }
    return O;
  }
  updateResult() {
    const e = f(this, de), t = this.createResult(f(this, H), this.options);
    if (P(this, ut, f(this, H).state), P(this, Dt, this.options), f(this, ut).data !== void 0 && P(this, Lt, f(this, H)), Ki(t, e))
      return;
    P(this, de, t);
    const r = () => {
      if (!e)
        return !0;
      const { notifyOnChangeProps: s } = this.options, n = typeof s == "function" ? s() : s;
      if (n === "all" || !n && !f(this, Mt).size)
        return !0;
      const a = new Set(
        n ?? f(this, Mt)
      );
      return this.options.throwOnError && a.add("error"), Object.keys(f(this, de)).some((o) => {
        const l = o;
        return f(this, de)[l] !== e[l] && a.has(l);
      });
    };
    B(this, q, _n).call(this, { listeners: r() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && B(this, q, ir).call(this);
  }
}, ge = new WeakMap(), H = new WeakMap(), ri = new WeakMap(), de = new WeakMap(), ut = new WeakMap(), Dt = new WeakMap(), je = new WeakMap(), We = new WeakMap(), si = new WeakMap(), It = new WeakMap(), Lt = new WeakMap(), ht = new WeakMap(), dt = new WeakMap(), qe = new WeakMap(), Mt = new WeakMap(), q = new WeakSet(), Kt = function(e) {
  B(this, q, nr).call(this);
  let t = f(this, H).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (t = t.catch(ve)), t;
}, Zi = function() {
  B(this, q, rr).call(this);
  const e = Je(
    this.options.staleTime,
    f(this, H)
  );
  if (gt || f(this, de).isStale || !qi(e))
    return;
  const r = wn(f(this, de).dataUpdatedAt, e) + 1;
  P(this, ht, rt.setTimeout(() => {
    f(this, de).isStale || this.updateResult();
  }, r));
}, er = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(f(this, H)) : this.options.refetchInterval) ?? !1;
}, tr = function(e) {
  B(this, q, sr).call(this), P(this, qe, e), !(gt || Se(this.options.enabled, f(this, H)) === !1 || !qi(f(this, qe)) || f(this, qe) === 0) && P(this, dt, rt.setInterval(() => {
    (this.options.refetchIntervalInBackground || Or.isFocused()) && B(this, q, Kt).call(this);
  }, f(this, qe)));
}, ir = function() {
  B(this, q, Zi).call(this), B(this, q, tr).call(this, B(this, q, er).call(this));
}, rr = function() {
  f(this, ht) && (rt.clearTimeout(f(this, ht)), P(this, ht, void 0));
}, sr = function() {
  f(this, dt) && (rt.clearInterval(f(this, dt)), P(this, dt, void 0));
}, nr = function() {
  const e = f(this, ge).getQueryCache().build(f(this, ge), this.options);
  if (e === f(this, H))
    return;
  const t = f(this, H);
  P(this, H, e), P(this, ri, e.state), this.hasListeners() && (t == null || t.removeObserver(this), e.addObserver(this));
}, _n = function(e) {
  ce.batch(() => {
    e.listeners && this.listeners.forEach((t) => {
      t(f(this, de));
    }), f(this, ge).getQueryCache().notify({
      query: f(this, H),
      type: "observerResultsUpdated"
    });
  });
}, Xs);
function xl(i, e) {
  return Se(e.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && e.retryOnMount === !1);
}
function ws(i, e) {
  return xl(i, e) || i.state.data !== void 0 && ar(i, e, e.refetchOnMount);
}
function ar(i, e, t) {
  if (Se(e.enabled, i) !== !1 && Je(e.staleTime, i) !== "static") {
    const r = typeof t == "function" ? t(i) : t;
    return r === "always" || r !== !1 && Er(i, e);
  }
  return !1;
}
function xs(i, e, t, r) {
  return (i !== e || Se(r.enabled, i) === !1) && (!t.suspense || i.state.status !== "error") && Er(i, t);
}
function Er(i, e) {
  return Se(e.enabled, i) !== !1 && i.isStaleByTime(Je(e.staleTime, i));
}
function Cl(i, e) {
  return !Ki(i.getCurrentResult(), e);
}
function Si(i) {
  return {
    onFetch: (e, t) => {
      var h, d, u, p, y;
      const r = e.options, s = (u = (d = (h = e.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : d.fetchMore) == null ? void 0 : u.direction, n = ((p = e.state.data) == null ? void 0 : p.pages) || [], a = ((y = e.state.data) == null ? void 0 : y.pageParams) || [];
      let o = { pages: [], pageParams: [] }, l = 0;
      const c = async () => {
        let b = !1;
        const m = (N) => {
          Object.defineProperty(N, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? b = !0 : e.signal.addEventListener("abort", () => {
              b = !0;
            }), e.signal)
          });
        }, S = xn(e.options, e.fetchOptions), x = async (N, w, R) => {
          if (b)
            return Promise.reject();
          if (w == null && N.pages.length)
            return Promise.resolve(N);
          const E = (() => {
            const F = {
              client: e.client,
              queryKey: e.queryKey,
              pageParam: w,
              direction: R ? "backward" : "forward",
              meta: e.options.meta
            };
            return m(F), F;
          })(), O = await S(E), { maxPages: _ } = e.options, C = R ? fl : dl;
          return {
            pages: C(N.pages, O, _),
            pageParams: C(N.pageParams, w, _)
          };
        };
        if (s && n.length) {
          const N = s === "backward", w = N ? Rn : or, R = {
            pages: n,
            pageParams: a
          }, g = w(r, R);
          o = await x(R, g, N);
        } else {
          const N = i ?? n.length;
          do {
            const w = l === 0 ? a[0] ?? r.initialPageParam : or(r, o);
            if (l > 0 && w == null)
              break;
            o = await x(o, w), l++;
          } while (l < N);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var b, m;
        return (m = (b = e.options).persister) == null ? void 0 : m.call(
          b,
          c,
          {
            client: e.client,
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          t
        );
      } : e.fetchFn = c;
    }
  };
}
function or(i, { pages: e, pageParams: t }) {
  const r = e.length - 1;
  return e.length > 0 ? i.getNextPageParam(
    e[r],
    e,
    t[r],
    t
  ) : void 0;
}
function Rn(i, { pages: e, pageParams: t }) {
  var r;
  return e.length > 0 ? (r = i.getPreviousPageParam) == null ? void 0 : r.call(i, e[0], e, t[0], t) : void 0;
}
function Sl(i, e) {
  return e ? or(i, e) != null : !1;
}
function Ol(i, e) {
  return !e || !i.getPreviousPageParam ? !1 : Rn(i, e) != null;
}
var El = class extends Nn {
  constructor(i, e) {
    super(i, e);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(i) {
    super.setOptions({
      ...i,
      behavior: Si()
    });
  }
  getOptimisticResult(i) {
    return i.behavior = Si(), super.getOptimisticResult(i);
  }
  fetchNextPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(i) {
    return this.fetch({
      ...i,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(i, e) {
    var y, b;
    const { state: t } = i, r = super.createResult(i, e), { isFetching: s, isRefetching: n, isError: a, isRefetchError: o } = r, l = (b = (y = t.fetchMeta) == null ? void 0 : y.fetchMore) == null ? void 0 : b.direction, c = a && l === "forward", h = s && l === "forward", d = a && l === "backward", u = s && l === "backward";
    return {
      ...r,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Sl(e, t.data),
      hasPreviousPage: Ol(e, t.data),
      isFetchNextPageError: c,
      isFetchingNextPage: h,
      isFetchPreviousPageError: d,
      isFetchingPreviousPage: u,
      isRefetchError: o && !c && !d,
      isRefetching: n && !h && !u
    };
  }
}, ni, De, fe, ft, Ie, Be, Gs, Nl = (Gs = class extends On {
  constructor(e) {
    super();
    L(this, Ie);
    L(this, ni);
    L(this, De);
    L(this, fe);
    L(this, ft);
    P(this, ni, e.client), this.mutationId = e.mutationId, P(this, fe, e.mutationCache), P(this, De, []), this.state = e.state || _l(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    f(this, De).includes(e) || (f(this, De).push(e), this.clearGcTimeout(), f(this, fe).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    P(this, De, f(this, De).filter((t) => t !== e)), this.scheduleGc(), f(this, fe).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    f(this, De).length || (this.state.status === "pending" ? this.scheduleGc() : f(this, fe).remove(this));
  }
  continue() {
    var e;
    return ((e = f(this, ft)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var a, o, l, c, h, d, u, p, y, b, m, S, x, N, w, R, g, E, O, _;
    const t = () => {
      B(this, Ie, Be).call(this, { type: "continue" });
    }, r = {
      client: f(this, ni),
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    P(this, ft, Sn({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e, r) : Promise.reject(new Error("No mutationFn found")),
      onFail: (C, F) => {
        B(this, Ie, Be).call(this, { type: "failed", failureCount: C, error: F });
      },
      onPause: () => {
        B(this, Ie, Be).call(this, { type: "pause" });
      },
      onContinue: t,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => f(this, fe).canRun(this)
    }));
    const s = this.state.status === "pending", n = !f(this, ft).canStart();
    try {
      if (s)
        t();
      else {
        B(this, Ie, Be).call(this, { type: "pending", variables: e, isPaused: n }), await ((o = (a = f(this, fe).config).onMutate) == null ? void 0 : o.call(
          a,
          e,
          this,
          r
        ));
        const F = await ((c = (l = this.options).onMutate) == null ? void 0 : c.call(
          l,
          e,
          r
        ));
        F !== this.state.context && B(this, Ie, Be).call(this, {
          type: "pending",
          context: F,
          variables: e,
          isPaused: n
        });
      }
      const C = await f(this, ft).start();
      return await ((d = (h = f(this, fe).config).onSuccess) == null ? void 0 : d.call(
        h,
        C,
        e,
        this.state.context,
        this,
        r
      )), await ((p = (u = this.options).onSuccess) == null ? void 0 : p.call(
        u,
        C,
        e,
        this.state.context,
        r
      )), await ((b = (y = f(this, fe).config).onSettled) == null ? void 0 : b.call(
        y,
        C,
        null,
        this.state.variables,
        this.state.context,
        this,
        r
      )), await ((S = (m = this.options).onSettled) == null ? void 0 : S.call(
        m,
        C,
        null,
        e,
        this.state.context,
        r
      )), B(this, Ie, Be).call(this, { type: "success", data: C }), C;
    } catch (C) {
      try {
        throw await ((N = (x = f(this, fe).config).onError) == null ? void 0 : N.call(
          x,
          C,
          e,
          this.state.context,
          this,
          r
        )), await ((R = (w = this.options).onError) == null ? void 0 : R.call(
          w,
          C,
          e,
          this.state.context,
          r
        )), await ((E = (g = f(this, fe).config).onSettled) == null ? void 0 : E.call(
          g,
          void 0,
          C,
          this.state.variables,
          this.state.context,
          this,
          r
        )), await ((_ = (O = this.options).onSettled) == null ? void 0 : _.call(
          O,
          void 0,
          C,
          e,
          this.state.context,
          r
        )), C;
      } finally {
        B(this, Ie, Be).call(this, { type: "error", error: C });
      }
    } finally {
      f(this, fe).runNext(this);
    }
  }
}, ni = new WeakMap(), De = new WeakMap(), fe = new WeakMap(), ft = new WeakMap(), Ie = new WeakSet(), Be = function(e) {
  const t = (r) => {
    switch (e.type) {
      case "failed":
        return {
          ...r,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: e.error,
          failureCount: r.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = t(this.state), ce.batch(() => {
    f(this, De).forEach((r) => {
      r.onMutationUpdate(e);
    }), f(this, fe).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, Gs);
function _l() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var ze, Pe, ai, Js, Rl = (Js = class extends li {
  constructor(e = {}) {
    super();
    L(this, ze);
    L(this, Pe);
    L(this, ai);
    this.config = e, P(this, ze, /* @__PURE__ */ new Set()), P(this, Pe, /* @__PURE__ */ new Map()), P(this, ai, 0);
  }
  build(e, t, r) {
    const s = new Nl({
      client: e,
      mutationCache: this,
      mutationId: ++hi(this, ai)._,
      options: e.defaultMutationOptions(t),
      state: r
    });
    return this.add(s), s;
  }
  add(e) {
    f(this, ze).add(e);
    const t = fi(e);
    if (typeof t == "string") {
      const r = f(this, Pe).get(t);
      r ? r.push(e) : f(this, Pe).set(t, [e]);
    }
    this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    if (f(this, ze).delete(e)) {
      const t = fi(e);
      if (typeof t == "string") {
        const r = f(this, Pe).get(t);
        if (r)
          if (r.length > 1) {
            const s = r.indexOf(e);
            s !== -1 && r.splice(s, 1);
          } else r[0] === e && f(this, Pe).delete(t);
      }
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    const t = fi(e);
    if (typeof t == "string") {
      const r = f(this, Pe).get(t), s = r == null ? void 0 : r.find(
        (n) => n.state.status === "pending"
      );
      return !s || s === e;
    } else
      return !0;
  }
  runNext(e) {
    var r;
    const t = fi(e);
    if (typeof t == "string") {
      const s = (r = f(this, Pe).get(t)) == null ? void 0 : r.find((n) => n !== e && n.state.isPaused);
      return (s == null ? void 0 : s.continue()) ?? Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    ce.batch(() => {
      f(this, ze).forEach((e) => {
        this.notify({ type: "removed", mutation: e });
      }), f(this, ze).clear(), f(this, Pe).clear();
    });
  }
  getAll() {
    return Array.from(f(this, ze));
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => gs(t, r)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => gs(e, t));
  }
  notify(e) {
    ce.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return ce.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(ve))
      )
    );
  }
}, ze = new WeakMap(), Pe = new WeakMap(), ai = new WeakMap(), Js);
function fi(i) {
  var e;
  return (e = i.options.scope) == null ? void 0 : e.id;
}
var Le, Zs, Pl = (Zs = class extends li {
  constructor(e = {}) {
    super();
    L(this, Le);
    this.config = e, P(this, Le, /* @__PURE__ */ new Map());
  }
  build(e, t, r) {
    const s = t.queryKey, n = t.queryHash ?? Sr(s, t);
    let a = this.get(n);
    return a || (a = new wl({
      client: e,
      queryKey: s,
      queryHash: n,
      options: e.defaultQueryOptions(t),
      state: r,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(e) {
    f(this, Le).has(e.queryHash) || (f(this, Le).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = f(this, Le).get(e.queryHash);
    t && (e.destroy(), t === e && f(this, Le).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    ce.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return f(this, Le).get(e);
  }
  getAll() {
    return [...f(this, Le).values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (r) => ps(t, r)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((r) => ps(e, r)) : t;
  }
  notify(e) {
    ce.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    ce.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    ce.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Le = new WeakMap(), Zs), te, Qe, Ke, kt, Tt, Ye, At, jt, en, Fl = (en = class {
  constructor(i = {}) {
    L(this, te);
    L(this, Qe);
    L(this, Ke);
    L(this, kt);
    L(this, Tt);
    L(this, Ye);
    L(this, At);
    L(this, jt);
    P(this, te, i.queryCache || new Pl()), P(this, Qe, i.mutationCache || new Rl()), P(this, Ke, i.defaultOptions || {}), P(this, kt, /* @__PURE__ */ new Map()), P(this, Tt, /* @__PURE__ */ new Map()), P(this, Ye, 0);
  }
  mount() {
    hi(this, Ye)._++, f(this, Ye) === 1 && (P(this, At, Or.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), f(this, te).onFocus());
    })), P(this, jt, Ci.subscribe(async (i) => {
      i && (await this.resumePausedMutations(), f(this, te).onOnline());
    })));
  }
  unmount() {
    var i, e;
    hi(this, Ye)._--, f(this, Ye) === 0 && ((i = f(this, At)) == null || i.call(this), P(this, At, void 0), (e = f(this, jt)) == null || e.call(this), P(this, jt, void 0));
  }
  isFetching(i) {
    return f(this, te).findAll({ ...i, fetchStatus: "fetching" }).length;
  }
  isMutating(i) {
    return f(this, Qe).findAll({ ...i, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = f(this, te).get(e.queryHash)) == null ? void 0 : t.state.data;
  }
  ensureQueryData(i) {
    const e = this.defaultQueryOptions(i), t = f(this, te).build(this, e), r = t.state.data;
    return r === void 0 ? this.fetchQuery(i) : (i.revalidateIfStale && t.isStaleByTime(Je(e.staleTime, t)) && this.prefetchQuery(e), Promise.resolve(r));
  }
  getQueriesData(i) {
    return f(this, te).findAll(i).map(({ queryKey: e, state: t }) => {
      const r = t.data;
      return [e, r];
    });
  }
  setQueryData(i, e, t) {
    const r = this.defaultQueryOptions({ queryKey: i }), s = f(this, te).get(
      r.queryHash
    ), n = s == null ? void 0 : s.state.data, a = cl(e, n);
    if (a !== void 0)
      return f(this, te).build(this, r).setData(a, { ...t, manual: !0 });
  }
  setQueriesData(i, e, t) {
    return ce.batch(
      () => f(this, te).findAll(i).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, e, t)
      ])
    );
  }
  getQueryState(i) {
    var t;
    const e = this.defaultQueryOptions({ queryKey: i });
    return (t = f(this, te).get(
      e.queryHash
    )) == null ? void 0 : t.state;
  }
  removeQueries(i) {
    const e = f(this, te);
    ce.batch(() => {
      e.findAll(i).forEach((t) => {
        e.remove(t);
      });
    });
  }
  resetQueries(i, e) {
    const t = f(this, te);
    return ce.batch(() => (t.findAll(i).forEach((r) => {
      r.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...i
      },
      e
    )));
  }
  cancelQueries(i, e = {}) {
    const t = { revert: !0, ...e }, r = ce.batch(
      () => f(this, te).findAll(i).map((s) => s.cancel(t))
    );
    return Promise.all(r).then(ve).catch(ve);
  }
  invalidateQueries(i, e = {}) {
    return ce.batch(() => (f(this, te).findAll(i).forEach((t) => {
      t.invalidate();
    }), (i == null ? void 0 : i.refetchType) === "none" ? Promise.resolve() : this.refetchQueries(
      {
        ...i,
        type: (i == null ? void 0 : i.refetchType) ?? (i == null ? void 0 : i.type) ?? "active"
      },
      e
    )));
  }
  refetchQueries(i, e = {}) {
    const t = {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }, r = ce.batch(
      () => f(this, te).findAll(i).filter((s) => !s.isDisabled() && !s.isStatic()).map((s) => {
        let n = s.fetch(void 0, t);
        return t.throwOnError || (n = n.catch(ve)), s.state.fetchStatus === "paused" ? Promise.resolve() : n;
      })
    );
    return Promise.all(r).then(ve);
  }
  fetchQuery(i) {
    const e = this.defaultQueryOptions(i);
    e.retry === void 0 && (e.retry = !1);
    const t = f(this, te).build(this, e);
    return t.isStaleByTime(
      Je(e.staleTime, t)
    ) ? t.fetch(e) : Promise.resolve(t.state.data);
  }
  prefetchQuery(i) {
    return this.fetchQuery(i).then(ve).catch(ve);
  }
  fetchInfiniteQuery(i) {
    return i.behavior = Si(i.pages), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(i) {
    return this.fetchInfiniteQuery(i).then(ve).catch(ve);
  }
  ensureInfiniteQueryData(i) {
    return i.behavior = Si(i.pages), this.ensureQueryData(i);
  }
  resumePausedMutations() {
    return Ci.isOnline() ? f(this, Qe).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return f(this, te);
  }
  getMutationCache() {
    return f(this, Qe);
  }
  getDefaultOptions() {
    return f(this, Ke);
  }
  setDefaultOptions(i) {
    P(this, Ke, i);
  }
  setQueryDefaults(i, e) {
    f(this, kt).set(Jt(i), {
      queryKey: i,
      defaultOptions: e
    });
  }
  getQueryDefaults(i) {
    const e = [...f(this, kt).values()], t = {};
    return e.forEach((r) => {
      Zt(i, r.queryKey) && Object.assign(t, r.defaultOptions);
    }), t;
  }
  setMutationDefaults(i, e) {
    f(this, Tt).set(Jt(i), {
      mutationKey: i,
      defaultOptions: e
    });
  }
  getMutationDefaults(i) {
    const e = [...f(this, Tt).values()], t = {};
    return e.forEach((r) => {
      Zt(i, r.mutationKey) && Object.assign(t, r.defaultOptions);
    }), t;
  }
  defaultQueryOptions(i) {
    if (i._defaulted)
      return i;
    const e = {
      ...f(this, Ke).queries,
      ...this.getQueryDefaults(i.queryKey),
      ...i,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = Sr(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.queryFn === xi && (e.enabled = !1), e;
  }
  defaultMutationOptions(i) {
    return i != null && i._defaulted ? i : {
      ...f(this, Ke).mutations,
      ...(i == null ? void 0 : i.mutationKey) && this.getMutationDefaults(i.mutationKey),
      ...i,
      _defaulted: !0
    };
  }
  clear() {
    f(this, te).clear(), f(this, Qe).clear();
  }
}, te = new WeakMap(), Qe = new WeakMap(), Ke = new WeakMap(), kt = new WeakMap(), Tt = new WeakMap(), Ye = new WeakMap(), At = new WeakMap(), jt = new WeakMap(), en), Pn = ue.createContext(
  void 0
), Pi = (i) => {
  const e = ue.useContext(Pn);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Dl = ({
  client: i,
  children: e
}) => (ue.useEffect(() => (i.mount(), () => {
  i.unmount();
}), [i]), /* @__PURE__ */ v(Pn.Provider, { value: i, children: e })), Fn = ue.createContext(!1), Il = () => ue.useContext(Fn);
Fn.Provider;
function Ll() {
  let i = !1;
  return {
    clearReset: () => {
      i = !1;
    },
    reset: () => {
      i = !0;
    },
    isReset: () => i
  };
}
var Ml = ue.createContext(Ll()), kl = () => ue.useContext(Ml), Tl = (i, e) => {
  (i.suspense || i.throwOnError || i.experimental_prefetchInRender) && (e.isReset() || (i.retryOnMount = !1));
}, Al = (i) => {
  ue.useEffect(() => {
    i.clearReset();
  }, [i]);
}, jl = ({
  result: i,
  errorResetBoundary: e,
  throwOnError: t,
  query: r,
  suspense: s
}) => i.isError && !e.isReset() && !i.isFetching && r && (s && i.data === void 0 || pl(t, [i.error, r])), zl = (i) => {
  if (i.suspense) {
    const t = (s) => s === "static" ? s : Math.max(s ?? 1e3, 1e3), r = i.staleTime;
    i.staleTime = typeof r == "function" ? (...s) => t(r(...s)) : t(r), typeof i.gcTime == "number" && (i.gcTime = Math.max(
      i.gcTime,
      1e3
    ));
  }
}, Ul = (i, e) => i.isLoading && i.isFetching && !e, $l = (i, e) => (i == null ? void 0 : i.suspense) && e.isPending, Cs = (i, e, t) => e.fetchOptimistic(i).catch(() => {
  t.clearReset();
});
function Dn(i, e, t) {
  var d, u, p, y, b;
  if (process.env.NODE_ENV !== "production" && (typeof i != "object" || Array.isArray(i)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = Il(), s = kl(), n = Pi(), a = n.defaultQueryOptions(i);
  (u = (d = n.getDefaultOptions().queries) == null ? void 0 : d._experimental_beforeQuery) == null || u.call(
    d,
    a
  ), process.env.NODE_ENV !== "production" && (a.queryFn || console.error(
    `[${a.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
  )), a._optimisticResults = r ? "isRestoring" : "optimistic", zl(a), Tl(a, s), Al(s);
  const o = !n.getQueryCache().get(a.queryHash), [l] = ue.useState(
    () => new e(
      n,
      a
    )
  ), c = l.getOptimisticResult(a), h = !r && i.subscribed !== !1;
  if (ue.useSyncExternalStore(
    ue.useCallback(
      (m) => {
        const S = h ? l.subscribe(ce.batchCalls(m)) : ve;
        return l.updateResult(), S;
      },
      [l, h]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), ue.useEffect(() => {
    l.setOptions(a);
  }, [a, l]), $l(a, c))
    throw Cs(a, l, s);
  if (jl({
    result: c,
    errorResetBoundary: s,
    throwOnError: a.throwOnError,
    query: n.getQueryCache().get(a.queryHash),
    suspense: a.suspense
  }))
    throw c.error;
  if ((y = (p = n.getDefaultOptions().queries) == null ? void 0 : p._experimental_afterQuery) == null || y.call(
    p,
    a,
    c
  ), a.experimental_prefetchInRender && !gt && Ul(c, r)) {
    const m = o ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      Cs(a, l, s)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (b = n.getQueryCache().get(a.queryHash)) == null ? void 0 : b.promise
    );
    m == null || m.catch(ve).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? c : l.trackResult(c);
}
function In(i, e) {
  return Dn(i, Nn);
}
function Bl(i, e) {
  return Dn(
    i,
    El
  );
}
const Hl = new Fl({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function Mu({ children: i }) {
  return /* @__PURE__ */ v(Dl, { client: Hl, children: i });
}
const Vl = rn(null), ku = ({
  children: i,
  languageCode: e
}) => {
  const [t, r] = V(e), s = Ra((n) => {
    re.hasResourceBundle(n, xr) ? (re.changeLanguage(n), r(n)) : Qo(n).then(() => {
      re.changeLanguage(n), r(n);
    });
  }, []);
  return Ee(() => {
    re.isInitialized && s(e);
  }, [e, s]), /* @__PURE__ */ v(Vl.Provider, { value: { currentLanguageCode: t, changeLocale: s }, children: i });
};
function Wl(i) {
  return /* @__PURE__ */ T(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ v(
          "path",
          {
            d: "M18.2047 18.8767C18.2047 14.9996 15.0623 11.8559 11.1853 11.8555C7.30794 11.8555 4.16412 14.9993 4.16412 18.8767C4.16446 22.7537 7.30815 25.8961 11.1853 25.8961V29.3727L10.6437 29.3591C5.27672 29.0867 0.973281 24.7836 0.701081 19.4165L0.6875 18.8767C0.6875 13.0793 5.38786 8.37891 11.1853 8.37891L11.7251 8.39249C17.2713 8.67377 21.6813 13.2605 21.6813 18.8767L21.6677 19.4165C21.3864 24.9625 16.8011 29.3724 11.1853 29.3727V25.8961C15.0621 25.8958 18.2044 22.7535 18.2047 18.8767Z",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M26.5202 0.700195C28.0666 0.700195 29.321 1.95328 29.321 3.49967V11.1598C29.3206 12.7059 28.0664 13.9593 26.5202 13.9593H22.7064C22.1923 12.9004 21.5799 11.9181 20.8861 11.027H26.3874V3.63249H18.2467V8.3903C17.3373 7.69342 16.3544 7.12177 15.3145 6.69499V3.49967C15.3145 1.95328 16.5675 0.700195 18.1139 0.700195H26.5202Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M22.2473 24.314C21.5653 24.3662 21.0547 24.9614 21.1069 25.6434C21.1591 26.3255 21.7543 26.8361 22.4364 26.7839C25.6817 26.5355 28.148 23.8282 28.1542 20.6279L28.5671 20.9821L28.6676 21.0593C29.1829 21.4178 29.8958 21.3351 30.3133 20.8484C30.7309 20.3617 30.704 19.6445 30.2713 19.1897L30.1797 19.1021L27.5208 16.8213C27.0016 16.376 26.2199 16.4358 25.7745 16.955L23.4937 19.6139C23.0483 20.133 23.1082 20.9148 23.6273 21.3601C24.1465 21.8055 24.9283 21.7457 25.3736 21.2265L25.6698 20.8799C25.5402 22.685 24.1061 24.1717 22.2473 24.314Z",
            fill: "rgb(var(--fill-primary))"
          }
        )
      ]
    }
  );
}
function ql(i) {
  return /* @__PURE__ */ T(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ v(
          "path",
          {
            d: "M3.82747 25.0379H16.3561V13.5614H3.82747V25.0379ZM19.4225 25.2384C19.4225 26.8215 18.1396 28.1053 16.5566 28.1056H3.62695C2.04374 28.1056 0.759766 26.8217 0.759766 25.2384V13.3608C0.759766 11.7776 2.04374 10.4937 3.62695 10.4937H16.5566C18.1396 10.494 19.4225 11.7778 19.4225 13.3608V25.2384Z",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M21.5408 1.53356C25.0304 1.71055 27.8051 4.59622 27.8054 8.12975L27.7967 8.46995C27.6256 11.8438 24.9231 14.5474 21.5506 14.7235V12.5313C23.8265 12.3529 25.618 10.4514 25.6182 8.12975C25.6179 5.69045 23.6399 3.7123 21.2006 3.71209C18.7613 3.71237 16.7832 5.6905 16.7829 8.12975C16.7829 8.20716 16.7851 8.28465 16.7891 8.36109H14.6019L14.5957 8.12975C14.596 4.48234 17.5531 1.52519 21.2006 1.5249L21.5408 1.53356Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M21.2094 1.14502L21.5496 1.15368H21.5595C25.25 1.34113 28.1838 4.39292 28.1841 8.12965V8.13955L28.1755 8.47975V8.48965C27.9942 12.0579 25.136 14.9169 21.5694 15.1032L21.1698 15.1242V12.1799L21.5199 12.1527C23.4697 11.9998 25.031 10.4625 25.2188 8.52305L25.2374 8.12965C25.2371 5.96992 23.5402 4.20512 21.4073 4.09673L21.1995 4.09178C18.9701 4.09207 17.1619 5.90029 17.1616 8.12965L17.1678 8.3412L17.1876 8.74078H14.2309L14.2148 8.13955V8.12965C14.2151 4.27238 17.3422 1.14532 21.1995 1.14502H21.2094ZM25.6171 8.12965C25.6169 10.4513 23.8254 12.3528 21.5496 12.5312V14.7234C24.9221 14.5473 27.6245 11.8437 27.7957 8.46986L27.8043 8.12965C27.804 4.59612 25.0293 1.71045 21.5397 1.53347L21.1995 1.52481C17.5521 1.5251 14.5949 4.48225 14.5946 8.12965L14.6008 8.36099H16.788C16.7841 8.28456 16.7818 8.20707 16.7818 8.12965C16.7821 5.6904 18.7602 3.71228 21.1995 3.71199C23.6388 3.71221 25.6169 5.69036 25.6171 8.12965Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ v(
          "path",
          {
            d: "M22.2473 23.941C21.5653 23.9932 21.0547 24.5884 21.1069 25.2704C21.1591 25.9524 21.7543 26.463 22.4364 26.4108C25.6817 26.1624 28.148 23.4551 28.1542 20.2549L28.5671 20.609L28.6676 20.6862C29.1829 21.0447 29.8958 20.9621 30.3133 20.4754C30.7309 19.9886 30.704 19.2715 30.2713 18.8167L30.1797 18.7291L27.5208 16.4483C27.0016 16.0029 26.2199 16.0627 25.7745 16.5819L23.4937 19.2408C23.0483 19.76 23.1082 20.5417 23.6273 20.9871C24.1465 21.4324 24.9283 21.3726 25.3736 20.8534L25.6698 20.5069C25.5402 22.3119 24.1061 23.7987 22.2473 23.941Z",
            fill: "rgb(var(--fill-primary))"
          }
        )
      ]
    }
  );
}
const Ql = "/api/dashboard/customer", Nr = "/api/dashboard/customer/data-files", Kl = `${Nr}/validate-and-get-upload-options`, Yl = (i) => `${Nr}/${i}/activate-file`, Xl = (i) => `${Ql}/draft-file/${i}`, Ln = "/api/data-files", Gl = `${Ln}/validate-and-get-upload-options`, Jl = (i) => `${Ln}/${i}/activate-file`, Fi = "/api/dashboard/management/data-files", Zl = `${Fi}/validate-and-get-upload-options`, ec = (i) => `${Fi}/${i}/activate-file`, tc = (i) => `${Fi}/${i}/delete-draft`, Mn = async ({
  startFrom: i,
  limit: e,
  order: t,
  sortColumn: r,
  sortDirection: s,
  filter: n,
  fileManagerApiType: a
}) => {
  var c, h;
  const o = () => a != null && a.isCommon ? Fi : Nr;
  return (await Cr.get(
    o() + "?" + (n != null && n.name ? `&filter[names][]=${n == null ? void 0 : n.name}` : "") + ((c = n == null ? void 0 : n.source) != null && c.length ? n.source.map((d) => `&filter[sources][]=${encodeURIComponent(d)}`).join("") : "") + ((h = n == null ? void 0 : n.type) != null && h.length ? n.type.map((d) => `&filter[types][]=${encodeURIComponent(d)}`).join("") : "") + (i ? `&pagination[startFrom]=${i}` : "") + (r ? `&pagination[sortColumn]=${r}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (e ? `&pagination[limit]=${e}` : "") + (t ? `&pagination[order]=${t}` : "")
  )).data;
}, Tu = ({
  startFrom: i,
  limit: e = 10,
  order: t = wr.Next,
  sortColumn: r,
  sortDirection: s,
  filter: n,
  fileManagerApiType: a
}, o) => {
  const l = Pi(), h = a != null && a.isCommon ? "common-data-files" : a != null && a.isPublic ? "public-data-files" : "data-files", d = [h], u = [
    h,
    { startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n }
  ];
  return {
    ...In({
      queryKey: u,
      queryFn: () => Mn({ startFrom: i, limit: e, order: t, sortColumn: r, sortDirection: s, filter: n, fileManagerApiType: a }),
      ...o
    }),
    resetAndRefetch: () => {
      l.invalidateQueries({ queryKey: d });
    },
    triggerFetch: () => {
      l.fetchQuery({ queryKey: u });
    },
    deleteItemFromData: (x) => {
      l.getQueryCache().findAll({ queryKey: d }).forEach((w) => {
        l.setQueryData(
          w.queryKey,
          (R) => {
            if (R)
              return {
                ...R,
                items: R.items.filter((g) => g.id !== x)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: x, name: N }) => {
      l.getQueryCache().findAll({ queryKey: d }).forEach((R) => {
        l.setQueryData(
          R.queryKey,
          (g) => {
            if (g)
              return {
                ...g,
                items: g.items.map((E) => E.id === x ? { ...E, name: N } : E)
              };
          }
        );
      });
    }
  };
}, ic = ({
  limit: i = 10,
  order: e = wr.Next,
  sortColumn: t,
  sortDirection: r,
  filter: s,
  fileManagerApiType: n
}, a) => {
  const o = Pi(), h = [n != null && n.isCommon ? "common-infinite-data-files" : n != null && n.isPublic ? "public-infinite-data-files" : "infinite-data-files", { limit: i, order: e, sortColumn: t, sortDirection: r, filter: s }];
  return { ...Bl({
    initialPageParam: void 0,
    queryKey: h,
    queryFn: ({ pageParam: b }) => Mn({
      startFrom: typeof b == "string" ? b : void 0,
      limit: i,
      order: e,
      sortColumn: t,
      sortDirection: r,
      filter: s,
      fileManagerApiType: n
    }),
    getPreviousPageParam: (b) => {
      if (!b.hasMore) return;
      const m = b.items[0];
      if (m)
        return encodeURIComponent(
          JSON.stringify({
            id: m.id,
            field: m[t ?? "name"]
          })
        );
    },
    getNextPageParam: (b) => {
      if (!b.hasMore) return;
      const m = b.items[b.items.length - 1];
      if (m)
        return encodeURIComponent(
          JSON.stringify({
            id: m.id,
            field: m[t ?? "name"]
          })
        );
    },
    ...a
  }), resetAndRefetch: () => {
    o.invalidateQueries({ queryKey: h });
  }, deleteItemFromData: (b) => {
    o.setQueryData(h, (m) => m && {
      ...m,
      pages: m.pages.map((S) => ({
        ...S,
        items: S.items.filter((x) => x.id !== b)
      }))
    });
  }, renameItemFromData: ({ id: b, name: m }) => {
    o.setQueryData(h, (S) => S && {
      ...S,
      pages: S.pages.map((x) => ({
        ...x,
        items: x.items.map((N) => N.id === b ? { ...N, name: m } : N)
      }))
    });
  } };
}, rc = ({ id: i, fileManagerApiType: e }, t) => {
  const r = Pi(), s = ["file-details", { id: i }], n = () => e != null && e.isCommon ? "/api/dashboard/management/data-files/" : "/api/dashboard/customer/data-files/";
  return { ...In({
    queryKey: s,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof i < "u",
    queryFn: async ({ queryKey: l }) => {
      const [, { id: c }] = l;
      return (await Cr.get(n() + c)).data;
    },
    ...t
  }), resetAndRefetch: () => {
    r.invalidateQueries({ queryKey: s });
  } };
}, kn = () => {
  const { fetcher: i } = Ot({
    method: St.delete
  }), { fetcher: e } = Ot({
    method: St.get
  }), { fetcher: t } = Ot({
    method: St.post
  });
  return { deleteFile: async ({ id: a }) => {
    await i("/api/dashboard/customer/data-files/" + a);
  }, downloadFile: async ({ id: a }) => {
    const { link: o } = await e(`/api/dashboard/customer/data-files/${a}/download-link`), l = document.createElement("a");
    l.setAttribute("href", o), l.setAttribute("download", ""), l.click();
  }, renameFile: async ({ id: a, name: o }) => await t(`/api/dashboard/customer/data-files/${a}/rename`, {
    name: o
  }) };
};
function sc({
  isFetching: i,
  values: e,
  disabled: t,
  disabledFileSourceSelect: r,
  disabledFileTypeSelect: s,
  onChange: n,
  onSubmit: a
}) {
  const { t: o } = pe();
  return /* @__PURE__ */ T(
    "form",
    {
      onSubmit: (l) => {
        l.preventDefault(), l.stopPropagation(), a();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ v(
          ga,
          {
            disabled: i || t,
            label: o("file_manager.file_selector.search_file"),
            placeholder: o("file_manager.search"),
            value: e.name,
            onClear: () => n == null ? void 0 : n({ ...e, name: "" }),
            onChange: (l) => n == null ? void 0 : n({ ...e, name: l.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ v(
          Ur,
          {
            disabled: i || t || r,
            placeholder: o("file_manager.select_source"),
            value: e.source,
            data: Object.values(G).filter((l) => l !== G.BlockPreview && l !== G.Community).map((l) => ({
              id: l,
              caption: o(za[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, source: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v(
          Ur,
          {
            disabled: i || t || s,
            placeholder: o("file_manager.select_type"),
            value: e.type,
            data: Object.values(X).map((l) => ({
              id: l,
              caption: o(Ua[l])
            })),
            onChange: (l) => n == null ? void 0 : n({ ...e, type: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v(
          oi,
          {
            type: "submit",
            isFetching: i,
            disabled: t,
            className: "min-w-14",
            children: o("file_manager.search")
          }
        )
      ]
    }
  );
}
function bt(i, e, t) {
  let r = t.initialDeps ?? [], s, n = !0;
  function a() {
    var o, l, c;
    let h;
    t.key && ((o = t.debug) != null && o.call(t)) && (h = Date.now());
    const d = i();
    if (!(d.length !== r.length || d.some((y, b) => r[b] !== y)))
      return s;
    r = d;
    let p;
    if (t.key && ((l = t.debug) != null && l.call(t)) && (p = Date.now()), s = e(...d), t.key && ((c = t.debug) != null && c.call(t))) {
      const y = Math.round((Date.now() - h) * 100) / 100, b = Math.round((Date.now() - p) * 100) / 100, m = b / 16, S = (x, N) => {
        for (x = String(x); x.length < N; )
          x = " " + x;
        return x;
      };
      console.info(
        `%c⏱ ${S(b, 5)} /${S(y, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(n && t.skipInitialOnChange) && t.onChange(s), n = !1, s;
  }
  return a.updateDeps = (o) => {
    r = o;
  }, a;
}
function Ss(i, e) {
  if (i === void 0)
    throw new Error("Unexpected undefined");
  return i;
}
const nc = (i, e) => Math.abs(i - e) < 1.01, ac = (i, e, t) => {
  let r;
  return function(...s) {
    i.clearTimeout(r), r = i.setTimeout(() => e.apply(this, s), t);
  };
}, Os = (i) => {
  const { offsetWidth: e, offsetHeight: t } = i;
  return { width: e, height: t };
}, oc = (i) => i, lc = (i) => {
  const e = Math.max(i.startIndex - i.overscan, 0), t = Math.min(i.endIndex + i.overscan, i.count - 1), r = [];
  for (let s = e; s <= t; s++)
    r.push(s);
  return r;
}, cc = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  const s = (a) => {
    const { width: o, height: l } = a;
    e({ width: Math.round(o), height: Math.round(l) });
  };
  if (s(Os(t)), !r.ResizeObserver)
    return () => {
    };
  const n = new r.ResizeObserver((a) => {
    const o = () => {
      const l = a[0];
      if (l != null && l.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          s({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      s(Os(t));
    };
    i.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
  });
  return n.observe(t, { box: "border-box" }), () => {
    n.unobserve(t);
  };
}, Es = {
  passive: !0
}, Ns = typeof window > "u" ? !0 : "onscrollend" in window, uc = (i, e) => {
  const t = i.scrollElement;
  if (!t)
    return;
  const r = i.targetWindow;
  if (!r)
    return;
  let s = 0;
  const n = i.options.useScrollendEvent && Ns ? () => {
  } : ac(
    r,
    () => {
      e(s, !1);
    },
    i.options.isScrollingResetDelay
  ), a = (h) => () => {
    const { horizontal: d, isRtl: u } = i.options;
    s = d ? t.scrollLeft * (u && -1 || 1) : t.scrollTop, n(), e(s, h);
  }, o = a(!0), l = a(!1);
  l(), t.addEventListener("scroll", o, Es);
  const c = i.options.useScrollendEvent && Ns;
  return c && t.addEventListener("scrollend", l, Es), () => {
    t.removeEventListener("scroll", o), c && t.removeEventListener("scrollend", l);
  };
}, hc = (i, e, t) => {
  if (e != null && e.borderBoxSize) {
    const r = e.borderBoxSize[0];
    if (r)
      return Math.round(
        r[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return i[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, dc = (i, {
  adjustments: e = 0,
  behavior: t
}, r) => {
  var s, n;
  const a = i + e;
  (n = (s = r.scrollElement) == null ? void 0 : s.scrollTo) == null || n.call(s, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: t
  });
};
class fc {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const r = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((n) => {
          const a = () => {
            this._measureElement(n.target, n);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(a) : a();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = r()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var n;
          return (n = r()) == null ? void 0 : n.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([r, s]) => {
        typeof s > "u" && delete t[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: oc,
        rangeExtractor: lc,
        onChange: () => {
        },
        measureElement: hc,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var r, s;
      (s = (r = this.options).onChange) == null || s.call(r, this, t);
    }, this.maybeNotify = bt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, n) => {
            this.scrollAdjustments = 0, this.scrollDirection = n ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = n, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, r) => {
      const s = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const o = t[a];
        if (s.has(o.lane))
          continue;
        const l = n.get(
          o.lane
        );
        if (l == null || o.end > l.end ? n.set(o.lane, o) : o.end < l.end && s.set(o.lane, !0), s.size === this.options.lanes)
          break;
      }
      return n.size === this.options.lanes ? Array.from(n.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = bt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, r, s, n, a, o) => (this.prevLanes !== void 0 && this.prevLanes !== o && (this.lanesChangedFlag = !0), this.prevLanes = o, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: r,
        scrollMargin: s,
        getItemKey: n,
        enabled: a,
        lanes: o
      }),
      {
        key: !1,
        skipInitialOnChange: !0,
        onChange: () => {
          this.notify(this.isScrolling);
        }
      }
    ), this.getMeasurements = bt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: r, scrollMargin: s, getItemKey: n, enabled: a, lanes: o }, l) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const u of this.laneAssignments.keys())
            u >= t && this.laneAssignments.delete(u);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const c = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const h = this.measurementsCache.slice(0, c), d = new Array(o).fill(
          void 0
        );
        for (let u = 0; u < c; u++) {
          const p = h[u];
          p && (d[p.lane] = u);
        }
        for (let u = c; u < t; u++) {
          const p = n(u), y = this.laneAssignments.get(u);
          let b, m;
          if (y !== void 0 && this.options.lanes > 1) {
            b = y;
            const w = d[b], R = w !== void 0 ? h[w] : void 0;
            m = R ? R.end + this.options.gap : r + s;
          } else {
            const w = this.options.lanes === 1 ? h[u - 1] : this.getFurthestMeasurement(h, u);
            m = w ? w.end + this.options.gap : r + s, b = w ? w.lane : u % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(u, b);
          }
          const S = l.get(p), x = typeof S == "number" ? S : this.options.estimateSize(u), N = m + x;
          h[u] = {
            index: u,
            start: m,
            size: x,
            end: N,
            key: p,
            lane: b
          }, d[b] = u;
        }
        return this.measurementsCache = h, h;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = bt(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, r, s, n) => this.range = t.length > 0 && r > 0 ? pc({
        measurements: t,
        outerSize: r,
        scrollOffset: s,
        lanes: n
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = bt(
      () => {
        let t = null, r = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, r = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, r]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          r
        ];
      },
      (t, r, s, n, a) => n === null || a === null ? [] : t({
        startIndex: n,
        endIndex: a,
        overscan: r,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const r = this.options.indexAttribute, s = t.getAttribute(r);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, r) => {
      const s = this.indexFromElement(t), n = this.measurementsCache[s];
      if (!n)
        return;
      const a = n.key, o = this.elementsCache.get(a);
      o !== t && (o && this.observer.unobserve(o), this.observer.observe(t), this.elementsCache.set(a, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, r, this));
    }, this.resizeItem = (t, r) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.itemSizeCache.get(s.key) ?? s.size, a = r - n;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, r)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((r, s) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = bt(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, r) => {
        const s = [];
        for (let n = 0, a = t.length; n < a; n++) {
          const o = t[n], l = r[o];
          s.push(l);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Ss(
          r[Tn(
            0,
            r.length - 1,
            (s) => Ss(r[s]).start,
            t
          )]
        );
    }, this.getOffsetForAlignment = (t, r, s = 0) => {
      const n = this.getSize(), a = this.getScrollOffset();
      r === "auto" && (r = t >= a + n ? "end" : "start"), r === "center" ? t += (s - n) / 2 : r === "end" && (t -= n);
      const o = this.getTotalSize() + this.options.scrollMargin - n;
      return Math.max(Math.min(o, t), 0);
    }, this.getOffsetForIndex = (t, r = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const n = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (s.end >= a + n - this.options.scrollPaddingEnd)
          r = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const o = r === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(o, r, s.size),
        r
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: r = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, r), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: r = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1));
      let n = 0;
      const a = 10, o = (c) => {
        if (!this.targetWindow) return;
        const h = this.getOffsetForIndex(t, c);
        if (!h) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [d, u] = h;
        this._scrollToOffset(d, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const p = this.getScrollOffset(), y = this.getOffsetForIndex(t, u);
          if (!y) {
            console.warn("Failed to get offset for index:", t);
            return;
          }
          nc(y[0], p) || l(u);
        });
      }, l = (c) => {
        this.targetWindow && (n++, n < a ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", n, a), this.targetWindow.requestAnimationFrame(() => o(c))) : console.warn(
          `Failed to scroll to index ${t} after ${a} attempts.`
        ));
      };
      o(r);
    }, this.scrollBy = (t, { behavior: r } = {}) => {
      r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var t;
      const r = this.getMeasurements();
      let s;
      if (r.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = r[r.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const n = Array(this.options.lanes).fill(null);
        let a = r.length - 1;
        for (; a >= 0 && n.some((o) => o === null); ) {
          const o = r[a];
          n[o.lane] === null && (n[o.lane] = o.end), a--;
        }
        s = Math.max(...n.filter((o) => o !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: r,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const Tn = (i, e, t, r) => {
  for (; i <= e; ) {
    const s = (i + e) / 2 | 0, n = t(s);
    if (n < r)
      i = s + 1;
    else if (n > r)
      e = s - 1;
    else
      return s;
  }
  return i > 0 ? i - 1 : 0;
};
function pc({
  measurements: i,
  outerSize: e,
  scrollOffset: t,
  lanes: r
}) {
  const s = i.length - 1, n = (l) => i[l].start;
  if (i.length <= r)
    return {
      startIndex: 0,
      endIndex: s
    };
  let a = Tn(
    0,
    s,
    n,
    t
  ), o = a;
  if (r === 1)
    for (; o < s && i[o].end < t + e; )
      o++;
  else if (r > 1) {
    const l = Array(r).fill(0);
    for (; o < s && l.some((h) => h < t + e); ) {
      const h = i[o];
      l[h.lane] = h.end, o++;
    }
    const c = Array(r).fill(t + e);
    for (; a >= 0 && c.some((h) => h >= t); ) {
      const h = i[a];
      c[h.lane] = h.start, a--;
    }
    a = Math.max(0, a - a % r), o = Math.min(s, o + (r - 1 - o % r));
  }
  return { startIndex: a, endIndex: o };
}
const _s = typeof document < "u" ? ue.useLayoutEffect : ue.useEffect;
function gc(i) {
  const e = ue.useReducer(() => ({}), {})[1], t = {
    ...i,
    onChange: (s, n) => {
      var a;
      n ? Aa(e) : e(), (a = i.onChange) == null || a.call(i, s, n);
    }
  }, [r] = ue.useState(
    () => new fc(t)
  );
  return r.setOptions(t), _s(() => r._didMount(), []), _s(() => r._willUpdate()), r;
}
function Rs(i) {
  return gc({
    observeElementRect: cc,
    observeElementOffset: uc,
    scrollToFn: dc,
    ...i
  });
}
const lr = 2, mc = 6, vc = lr * 2 + mc;
function yc({
  initialItemWidth: i = 150,
  initialItemHeight: e = 180,
  rowGap: t = 18,
  columnGap: r = 16,
  columnCount: s = 6,
  dataFilesApi: n,
  specialElementInGrid: a,
  onSelect: o,
  onDetails: l,
  onDelete: c,
  onRename: h,
  onDownload: d
}) {
  var ae;
  const u = Oe.useRef(null), p = Oe.useRef(null), [y, b] = V(s), [m, S] = V(i), [x, N] = V(e), [w, R] = V(), { data: g, fetchNextPage: E, hasNextPage: O, isFetchingNextPage: _, isFetching: C } = n, F = "specialElementInGridId", I = a ? y >= 2 ? [F, F] : [F] : [], A = [...I, ...((ae = g == null ? void 0 : g.pages) == null ? void 0 : ae.flatMap((j) => j.items)) ?? []], $ = A.length;
  Ee(() => {
    const j = () => {
      if (u.current) {
        const ee = u.current.offsetWidth - vc, W = Math.floor(ee / (i + r));
        b(W || 1);
        const D = (ee - r * (W - 1)) / W;
        S(D), N(D / i * e);
      }
    };
    j();
    const K = new ResizeObserver(j);
    return u.current && K.observe(u.current), () => K.disconnect();
  }, [i, e, r]);
  const Q = Rs({
    count: Math.ceil($ / y),
    gap: t,
    getScrollElement: () => u.current,
    estimateSize: () => x
  }), k = Rs({
    count: y,
    gap: r,
    getScrollElement: () => u.current,
    estimateSize: () => m,
    horizontal: !0
  });
  return Ee(() => {
    if (!p.current || !O || _) return;
    const j = new IntersectionObserver(
      (K) => {
        K[0].isIntersecting && E();
      },
      { root: u.current, threshold: 0.1 }
    );
    return j.observe(p.current), () => {
      p.current && j.unobserve(p.current);
    };
  }, [E, O, _]), Ee(() => {
    const j = A.filter(ja).find((K) => K.id === w);
    o == null || o(j);
  }, [w]), /* @__PURE__ */ T(
    "div",
    {
      ref: u,
      className: "relative overflow-auto w-full h-[400px] customScroll",
      style: { paddingTop: lr, paddingLeft: lr },
      children: [
        /* @__PURE__ */ T(
          "div",
          {
            style: {
              height: Q.getTotalSize(),
              width: k.getTotalSize()
            },
            className: "relative",
            children: [
              C && !_ ? Array.from({ length: 10 }).map((j, K) => /* @__PURE__ */ v(
                "div",
                {
                  className: "absolute bg-background-tertiary animate-pulse rounded-md",
                  style: {
                    top: Math.floor(K / y) * (x + t),
                    left: K % y * (m + r),
                    height: x,
                    width: m
                  }
                },
                K
              )) : Q.getVirtualItems().map(
                (j) => k.getVirtualItems().map((K) => {
                  const ee = j.index * y + K.index, W = A[ee];
                  if (!W) return null;
                  let D = Math.floor(ee / y) * (x + t);
                  const z = ee % y * (m + r);
                  let Y = 0;
                  switch (y) {
                    case 1:
                      Y = 180;
                      break;
                    case 2:
                      Y = 80;
                      break;
                  }
                  return a && (D = D - Y), F === W ? ee === 0 ? /* @__PURE__ */ v(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: x - Y,
                        width: m * I.length + r * (I.length - 1)
                      },
                      children: a
                    },
                    W + ee
                  ) : null : /* @__PURE__ */ v(
                    Wa,
                    {
                      src: W.thumbnail ?? W.path ?? void 0,
                      alt: W.name,
                      name: W.name,
                      imageWidth: m,
                      imageHeight: m * 0.869,
                      secondaryText: W.type,
                      fileType: W.type,
                      style: {
                        top: D,
                        left: z,
                        height: x,
                        width: m
                      },
                      selected: w === W.id,
                      onSelect: (he) => {
                        R(he ? W.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          l ? /* @__PURE__ */ v(
                            il,
                            {
                              onClick: () => l(W)
                            },
                            "details"
                          ) : void 0,
                          c ? /* @__PURE__ */ v(
                            rl,
                            {
                              onClick: () => c(W)
                            },
                            "delete"
                          ) : void 0,
                          h ? /* @__PURE__ */ v(
                            sl,
                            {
                              onClick: () => h(W)
                            },
                            "rename"
                          ) : void 0,
                          d ? /* @__PURE__ */ v(
                            nl,
                            {
                              onClick: () => d(W)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    W.id
                  );
                })
              ),
              O && /* @__PURE__ */ v("div", { ref: p, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ v("div", { className: "flex items-center justify-center w-full pt-4 h-11", children: _ && /* @__PURE__ */ v(ma, {}) })
      ]
    }
  );
}
const bc = (i) => {
  const { fetcher: e } = Ot({
    method: St.post
  }), { fetcher: t } = Ot({
    method: St.post
  }), { fetcher: r } = Ot({
    method: St.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: l,
      source: c,
      mimeType: h,
      cancelToken: d
    }) => await e(
      i != null && i.isCommon ? Zl : i != null && i.isPublic ? Gl : Kl,
      {
        source: c,
        fileName: l.name,
        fileSize: l.size,
        mimeType: h,
        isCommon: (i == null ? void 0 : i.isCommon) ?? !1
      },
      {
        cancelToken: d
      }
    ),
    uploadToFileStore: async ({
      file: l,
      uploadOptions: c,
      progressHandler: h,
      cancelToken: d
    }) => {
      const u = new FormData();
      return u.append("key", c.key), u.append("acl", c.acl), u.append("X-Amz-Credential", c.credential), u.append("X-Amz-Algorithm", c.algorithm), u.append("X-Amz-Date", c.date), u.append("Policy", c.policy), u.append("X-Amz-Signature", c.signature), u.append("Content-Type", c.contentType), u.append("Cache-Control", c.cacheControl), u.append("file", l), await br.post(c.url, u, {
        onUploadProgress: h,
        cancelToken: d
      });
    },
    activate: async ({
      fileId: l,
      cancelToken: c
    }) => await t(
      i != null && i.isCommon ? ec(l) : i != null && i.isPublic ? Jl(l) : Yl(l),
      {},
      {
        cancelToken: c,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeDraftFile: async (l) => await r(i != null && i.isCommon ? tc(l) : Xl(l))
  };
}, wc = () => {
  let i;
  return {
    createToken: () => (i = br.CancelToken.source(), i.token),
    cancel: () => {
      i && (i.cancel(), i = void 0);
    },
    getToken: () => i == null ? void 0 : i.token
  };
}, xc = ({
  onChange: i
}) => {
  let e = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const t = () => {
    i(e);
  }, r = () => {
    e = {
      ...e,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, t();
  }, s = () => {
    e = {
      ...e,
      isUploading: !1,
      isUploaded: !0
    }, t();
  }, n = (l, c) => {
    c && (e = {
      ...e,
      progress: Math.round(l * 100 / c),
      total: c
    }, t());
  };
  return {
    getState: () => e,
    startProgress: r,
    finishProgress: s,
    updateProgress: n,
    resetProgress: () => {
      e = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, t();
    },
    progressHandler: (l) => {
      const c = l.loaded, h = l.total;
      n(c, h);
    }
  };
}, Cc = (i) => {
  const e = i.name.match(/\.[a-zA-Z0-9_-]+$/i);
  switch (e && e[0]) {
    case $e.Docx:
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case $e.Doc:
      return "application/msword";
    case $e.Ttf:
      return "font/ttf";
    case $e.AD_PRT:
      return "application/vnd.alibre.part";
    case $e.AD_SMP:
      return "application/vnd.alibre.sheet_metal_part";
    case $e.AD_ASM:
      return "application/vnd.alibre.assembly";
    case $e.AD_DRW:
      return "application/vnd.alibre.drawing";
    default:
      return i.type;
  }
}, An = (i) => {
  const { t: e } = pe(), { validateAndGetUploadOptions: t, uploadToFileStore: r, activate: s, removeDraftFile: n } = bc(i);
  return {
    createFileUploader: (o) => {
      const l = xc({ onChange: o }), c = wc();
      return {
        progress: l,
        upload: async ({ file: u, source: p }) => {
          l.startProgress();
          const y = c.createToken();
          let b;
          try {
            const { uploadOptions: m, id: S } = await t({
              file: u,
              source: p,
              mimeType: Cc(u),
              cancelToken: y
            });
            b = S, await r({
              file: u,
              uploadOptions: m,
              progressHandler: l.progressHandler,
              cancelToken: y
            });
            const x = await s({
              fileId: S,
              cancelToken: y
            });
            return l.finishProgress(), x[S];
          } catch (m) {
            if (br.isCancel(m)) {
              be(e("file_manager.cancelled"));
              return;
            }
            throw typeof b == "number" ? await n(b) : be.error(e("file_manager.error")), m;
          }
        },
        cancelUpload: () => {
          c.cancel(), l.resetProgress();
        }
      };
    }
  };
}, Sc = ({
  preLoadedFiles: i,
  source: e,
  fileManagerApiType: t,
  onChange: r
}) => {
  const { t: s } = pe(), { createFileUploader: n } = An(t), { deleteFile: a } = kn(), [o, l] = V([]), [c, h] = V([]), [d, u] = V({}), [p, y] = V([]), b = (O) => {
    const _ = i == null ? void 0 : i.map((C) => C.id);
    return _ == null ? void 0 : _.includes(O.id);
  }, m = () => c.map((_) => {
    const C = !b(_);
    return {
      file: { ..._, name: _.filename },
      disabled: p.includes(_.id),
      uploaded: C
    };
  }), S = () => Object.entries(d).map(([_, C]) => ({
    file: { ...C, id: _, name: C.file.name },
    progress: C.progress.isUploading ? C.progress.progress : void 0,
    uploaded: C.progress.isUploaded
  })), x = m(), N = S(), w = async (O) => {
    try {
      y((_) => [..._, O]), await a({ id: O }), h((_) => {
        const C = _.filter((F) => F.id !== O);
        return r == null || r(C), C;
      });
    } catch (_) {
      throw _;
    } finally {
      y((_) => _.filter((C) => C !== O));
    }
  }, R = (O) => {
    d[O].cancelUpload(), u((_) => {
      const { [O]: C, ...F } = _;
      return F;
    });
  };
  return {
    waitingUploadFiles: o,
    setWaitingUploadFiles: l,
    removingFiles: p,
    uploadedFiles: c,
    setUploadedFiles: h,
    mappedUploadedFiles: x,
    mappedUploadingFiles: N,
    startUploading: async (O) => {
      const _ = await Zo(O) + "_" + crypto.randomUUID(), F = n((I) => {
        u((A) => ({
          ...A,
          [_]: {
            ...A[_],
            progress: I
          }
        }));
      });
      l((I) => I.filter((A) => A.file !== O)), u((I) => ({
        ...I,
        [_]: {
          file: O,
          progress: F.progress.getState(),
          cancelUpload: F.cancelUpload
        }
      }));
      try {
        const I = await F.upload({
          file: O,
          source: e
        });
        if (I)
          return h((A) => {
            const $ = [{ ...I, file: O }, ...A];
            return r == null || r($), $;
          }), I;
      } catch (I) {
        const A = I instanceof Error ? I : new Error(s("file_manager.error"));
        throw l(($) => [{ file: O, error: A }, ...$]), I;
      } finally {
        u((I) => {
          const { [_]: A, ...$ } = I;
          return $;
        });
      }
    },
    deleteUploadedOrUploadingFile: async (O) => {
      d[O] && await R(String(O)), c.find((F) => F.id === +O) && await w(Number(O));
    },
    deleteUploadedFile: w,
    deleteUploadingFile: R
  };
}, Oc = (i) => i instanceof File, Ec = (i) => "id" in i && "file" in i, Nc = (i) => "id" in i && "path" in i && "size" in i && "type" in i && "filename" in i && "thumbnail" in i, _c = ({ progress: i }) => {
  const t = 2 * Math.PI * 14, r = t * (1 - i / 100);
  return /* @__PURE__ */ T("div", { className: "relative w-8 h-8", children: [
    /* @__PURE__ */ v("svg", { className: "w-full h-full", children: /* @__PURE__ */ v(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ v("svg", { className: "absolute top-0 left-0 w-full h-full", children: /* @__PURE__ */ v(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: t,
        strokeDashoffset: r,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
function Ti({
  file: i,
  progress: e = 0,
  isError: t,
  isLoading: r,
  isLoaded: s,
  isDeleting: n,
  className: a,
  disabled: o,
  disabledDeleteButton: l,
  showDeleteButton: c,
  showEditButton: h,
  onDeleteFile: d,
  onEdit: u
}) {
  return /* @__PURE__ */ T(
    "div",
    {
      className: ie("relative w-24 h-24", a),
      onClick: (p) => p.stopPropagation(),
      children: [
        c && /* @__PURE__ */ v(
          "button",
          {
            type: "button",
            className: ie(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              n && "animate-pulse"
            ),
            onClick: (p) => {
              p.preventDefault(), p.stopPropagation(), d();
            },
            disabled: l || o,
            children: /* @__PURE__ */ v(
              Br,
              {
                className: ie(
                  "fill-text-secondary transition-colors",
                  !l && !o && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ T("div", { className: "relative w-full h-full group/edit", children: [
          i instanceof File ? /* @__PURE__ */ v(bn, { file: i, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ v(
            pt,
            {
              src: i.thumbnail || i.path,
              fileType: i.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: i.filename
            }
          ),
          /* @__PURE__ */ v(
            "div",
            {
              className: ie(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                h && !o && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ v("div", { onClick: u, className: "cursor-pointer group p-2", children: /* @__PURE__ */ v(ka, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        t && /* @__PURE__ */ v("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v(Br, { className: "fill-danger rounded-full" }) }),
        r && /* @__PURE__ */ v("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v(_c, { progress: e }) })
      ]
    }
  );
}
var jn = /* @__PURE__ */ ((i) => (i[i.Small = 0] = "Small", i[i.Medium = 1] = "Medium", i[i.Big = 2] = "Big", i))(jn || {});
const Rc = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
function zn({
  acceptTypes: i,
  children: e,
  dropZoneClassName: t,
  className: r,
  disabled: s,
  error: n,
  variant: a = jn.Medium,
  label: o,
  icon: l = /* @__PURE__ */ v(Ta, {}),
  isPreFetching: c,
  toastText: h,
  labelClassName: d,
  openNativeWindow: u = !0,
  onSelectFile: p,
  onClick: y
}) {
  const { t: b } = pe(), m = we(null), [S, x] = V(!1), [N, w] = V(""), R = (C) => {
    var F;
    C.preventDefault(), !s && (y == null || y(), u && ((F = m.current) == null || F.click()));
  }, g = (C) => {
    if (C.target.files && C.target.files[0]) {
      const F = C.target.files[0];
      i && !ds(F.type, i) ? w(b("file_manager.file_upload.file_not_supported")) : (p(F), h && be.success(h));
    }
    C.target.value = "";
  }, E = (C) => {
    C.preventDefault(), x(!0);
  }, O = (C) => {
    C.preventDefault(), x(!1);
  }, _ = (C) => {
    C.preventDefault(), C.stopPropagation();
    const { files: F } = C.dataTransfer;
    if (F && F.length) {
      const I = F[0];
      i && !ds(I.type, i) ? w(b("file_manager.file_upload.file_not_supported")) : (p(I), h && be.success(h));
    }
    x(!1);
  };
  return /* @__PURE__ */ T("div", { className: ie("font-medium", r), children: [
    /* @__PURE__ */ v(
      "input",
      {
        ref: m,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: g,
        disabled: c || s,
        accept: i && el(i)
      }
    ),
    /* @__PURE__ */ T(
      "button",
      {
        type: "button",
        className: ie(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          S ? "border-brand-primary" : "border-text-secondary",
          Rc[a],
          c && "animate-pulse",
          s || c ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          t
        ),
        onDragStart: E,
        onDragLeave: O,
        onDrop: _,
        onDragOver: E,
        onClick: R,
        children: [
          !!Pa.count(e) && /* @__PURE__ */ v("div", { className: "flex w-full flex-wrap gap-3", children: e }),
          /* @__PURE__ */ T(
            "div",
            {
              className: ie(
                "flex w-full flex-col items-center justify-center gap-1",
                d
              ),
              children: [
                l,
                o ?? b("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ v(mi, { error: N, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ v(mi, { error: n, errorClassName: "text-center mt-2" })
  ] });
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function Ps(i, e) {
  var t = Object.keys(i);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(i, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Un(i) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ps(Object(t), !0).forEach(function(r) {
      Ic(i, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t)) : Ps(Object(t)).forEach(function(r) {
      Object.defineProperty(i, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return i;
}
function Pc(i, e) {
  if (typeof i != "object" || !i) return i;
  var t = i[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(i, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(i);
}
function $n(i) {
  var e = Pc(i, "string");
  return typeof e == "symbol" ? e : e + "";
}
function cr(i) {
  "@babel/helpers - typeof";
  return cr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cr(i);
}
function Fc(i, e) {
  if (!(i instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fs(i, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, $n(r.key), r);
  }
}
function Dc(i, e, t) {
  return e && Fs(i.prototype, e), t && Fs(i, t), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function Ic(i, e, t) {
  return e = $n(e), e in i ? Object.defineProperty(i, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[e] = t, i;
}
function Bn(i) {
  return Lc(i) || Mc(i) || kc(i) || Tc();
}
function Lc(i) {
  if (Array.isArray(i)) return ur(i);
}
function Mc(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
}
function kc(i, e) {
  if (i) {
    if (typeof i == "string") return ur(i, e);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ur(i, e);
  }
}
function ur(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = i[t];
  return r;
}
function Tc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Di = typeof window < "u" && typeof window.document < "u", Te = Di ? window : {}, _r = Di && Te.document.documentElement ? "ontouchstart" in Te.document.documentElement : !1, Rr = Di ? "PointerEvent" in Te : !1, J = "cropper", Pr = "all", Hn = "crop", Vn = "move", Wn = "zoom", et = "e", tt = "w", wt = "s", Ue = "n", Vt = "ne", Wt = "nw", qt = "se", Qt = "sw", hr = "".concat(J, "-crop"), Ds = "".concat(J, "-disabled"), ye = "".concat(J, "-hidden"), Is = "".concat(J, "-hide"), Ac = "".concat(J, "-invisible"), Oi = "".concat(J, "-modal"), dr = "".concat(J, "-move"), ei = "".concat(J, "Action"), pi = "".concat(J, "Preview"), Fr = "crop", qn = "move", Qn = "none", fr = "crop", pr = "cropend", gr = "cropmove", mr = "cropstart", Ls = "dblclick", jc = _r ? "touchstart" : "mousedown", zc = _r ? "touchmove" : "mousemove", Uc = _r ? "touchend touchcancel" : "mouseup", Ms = Rr ? "pointerdown" : jc, ks = Rr ? "pointermove" : zc, Ts = Rr ? "pointerup pointercancel" : Uc, As = "ready", js = "resize", zs = "wheel", vr = "zoom", Us = "image/jpeg", $c = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Bc = /^data:/, Hc = /^data:image\/jpeg;base64,/, Vc = /^img|canvas$/i, Kn = 200, Yn = 100, $s = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: Fr,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Kn,
  minContainerHeight: Yn,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Wc = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', qc = Number.isNaN || Te.isNaN;
function U(i) {
  return typeof i == "number" && !qc(i);
}
var Bs = function(e) {
  return e > 0 && e < 1 / 0;
};
function Ai(i) {
  return typeof i > "u";
}
function mt(i) {
  return cr(i) === "object" && i !== null;
}
var Qc = Object.prototype.hasOwnProperty;
function xt(i) {
  if (!mt(i))
    return !1;
  try {
    var e = i.constructor, t = e.prototype;
    return e && t && Qc.call(t, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function me(i) {
  return typeof i == "function";
}
var Kc = Array.prototype.slice;
function Xn(i) {
  return Array.from ? Array.from(i) : Kc.call(i);
}
function ne(i, e) {
  return i && me(e) && (Array.isArray(i) || U(i.length) ? Xn(i).forEach(function(t, r) {
    e.call(i, t, r, i);
  }) : mt(i) && Object.keys(i).forEach(function(t) {
    e.call(i, i[t], t, i);
  })), i;
}
var Z = Object.assign || function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    r[s - 1] = arguments[s];
  return mt(e) && r.length > 0 && r.forEach(function(n) {
    mt(n) && Object.keys(n).forEach(function(a) {
      e[a] = n[a];
    });
  }), e;
}, Yc = /\.\d*(?:0|9){12}\d*$/;
function Et(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return Yc.test(i) ? Math.round(i * e) / e : i;
}
var Xc = /^width|height|left|top|marginLeft|marginTop$/;
function Xe(i, e) {
  var t = i.style;
  ne(e, function(r, s) {
    Xc.test(s) && U(r) && (r = "".concat(r, "px")), t[s] = r;
  });
}
function Gc(i, e) {
  return i.classList ? i.classList.contains(e) : i.className.indexOf(e) > -1;
}
function le(i, e) {
  if (e) {
    if (U(i.length)) {
      ne(i, function(r) {
        le(r, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.add(e);
      return;
    }
    var t = i.className.trim();
    t ? t.indexOf(e) < 0 && (i.className = "".concat(t, " ").concat(e)) : i.className = e;
  }
}
function ke(i, e) {
  if (e) {
    if (U(i.length)) {
      ne(i, function(t) {
        ke(t, e);
      });
      return;
    }
    if (i.classList) {
      i.classList.remove(e);
      return;
    }
    i.className.indexOf(e) >= 0 && (i.className = i.className.replace(e, ""));
  }
}
function Ct(i, e, t) {
  if (e) {
    if (U(i.length)) {
      ne(i, function(r) {
        Ct(r, e, t);
      });
      return;
    }
    t ? le(i, e) : ke(i, e);
  }
}
var Jc = /([a-z\d])([A-Z])/g;
function Dr(i) {
  return i.replace(Jc, "$1-$2").toLowerCase();
}
function yr(i, e) {
  return mt(i[e]) ? i[e] : i.dataset ? i.dataset[e] : i.getAttribute("data-".concat(Dr(e)));
}
function ti(i, e, t) {
  mt(t) ? i[e] = t : i.dataset ? i.dataset[e] = t : i.setAttribute("data-".concat(Dr(e)), t);
}
function Zc(i, e) {
  if (mt(i[e]))
    try {
      delete i[e];
    } catch {
      i[e] = void 0;
    }
  else if (i.dataset)
    try {
      delete i.dataset[e];
    } catch {
      i.dataset[e] = void 0;
    }
  else
    i.removeAttribute("data-".concat(Dr(e)));
}
var Gn = /\s\s*/, Jn = (function() {
  var i = !1;
  if (Di) {
    var e = !1, t = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return i = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(n) {
        e = n;
      }
    });
    Te.addEventListener("test", t, r), Te.removeEventListener("test", t, r);
  }
  return i;
})();
function _e(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(Gn).forEach(function(n) {
    if (!Jn) {
      var a = i.listeners;
      a && a[n] && a[n][t] && (s = a[n][t], delete a[n][t], Object.keys(a[n]).length === 0 && delete a[n], Object.keys(a).length === 0 && delete i.listeners);
    }
    i.removeEventListener(n, s, r);
  });
}
function xe(i, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = t;
  e.trim().split(Gn).forEach(function(n) {
    if (r.once && !Jn) {
      var a = i.listeners, o = a === void 0 ? {} : a;
      s = function() {
        delete o[n][t], i.removeEventListener(n, s, r);
        for (var c = arguments.length, h = new Array(c), d = 0; d < c; d++)
          h[d] = arguments[d];
        t.apply(i, h);
      }, o[n] || (o[n] = {}), o[n][t] && i.removeEventListener(n, o[n][t], r), o[n][t] = s, i.listeners = o;
    }
    i.addEventListener(n, s, r);
  });
}
function Nt(i, e, t) {
  var r;
  return me(Event) && me(CustomEvent) ? r = new CustomEvent(e, {
    detail: t,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(e, !0, !0, t)), i.dispatchEvent(r);
}
function Zn(i) {
  var e = i.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var ji = Te.location, eu = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Hs(i) {
  var e = i.match(eu);
  return e !== null && (e[1] !== ji.protocol || e[2] !== ji.hostname || e[3] !== ji.port);
}
function Vs(i) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return i + (i.indexOf("?") === -1 ? "?" : "&") + e;
}
function Xt(i) {
  var e = i.rotate, t = i.scaleX, r = i.scaleY, s = i.translateX, n = i.translateY, a = [];
  U(s) && s !== 0 && a.push("translateX(".concat(s, "px)")), U(n) && n !== 0 && a.push("translateY(".concat(n, "px)")), U(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), U(t) && t !== 1 && a.push("scaleX(".concat(t, ")")), U(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var o = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: o,
    msTransform: o,
    transform: o
  };
}
function tu(i) {
  var e = Un({}, i), t = 0;
  return ne(i, function(r, s) {
    delete e[s], ne(e, function(n) {
      var a = Math.abs(r.startX - n.startX), o = Math.abs(r.startY - n.startY), l = Math.abs(r.endX - n.endX), c = Math.abs(r.endY - n.endY), h = Math.sqrt(a * a + o * o), d = Math.sqrt(l * l + c * c), u = (d - h) / h;
      Math.abs(u) > Math.abs(t) && (t = u);
    });
  }), t;
}
function gi(i, e) {
  var t = i.pageX, r = i.pageY, s = {
    endX: t,
    endY: r
  };
  return e ? s : Un({
    startX: t,
    startY: r
  }, s);
}
function iu(i) {
  var e = 0, t = 0, r = 0;
  return ne(i, function(s) {
    var n = s.startX, a = s.startY;
    e += n, t += a, r += 1;
  }), e /= r, t /= r, {
    pageX: e,
    pageY: t
  };
}
function Ge(i) {
  var e = i.aspectRatio, t = i.height, r = i.width, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", n = Bs(r), a = Bs(t);
  if (n && a) {
    var o = t * e;
    s === "contain" && o > r || s === "cover" && o < r ? t = r / e : r = t * e;
  } else n ? t = r / e : a && (r = t * e);
  return {
    width: r,
    height: t
  };
}
function ru(i) {
  var e = i.width, t = i.height, r = i.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: t,
      height: e
    };
  var s = r % 90 * Math.PI / 180, n = Math.sin(s), a = Math.cos(s), o = e * a + t * n, l = e * n + t * a;
  return r > 90 ? {
    width: l,
    height: o
  } : {
    width: o,
    height: l
  };
}
function su(i, e, t, r) {
  var s = e.aspectRatio, n = e.naturalWidth, a = e.naturalHeight, o = e.rotate, l = o === void 0 ? 0 : o, c = e.scaleX, h = c === void 0 ? 1 : c, d = e.scaleY, u = d === void 0 ? 1 : d, p = t.aspectRatio, y = t.naturalWidth, b = t.naturalHeight, m = r.fillColor, S = m === void 0 ? "transparent" : m, x = r.imageSmoothingEnabled, N = x === void 0 ? !0 : x, w = r.imageSmoothingQuality, R = w === void 0 ? "low" : w, g = r.maxWidth, E = g === void 0 ? 1 / 0 : g, O = r.maxHeight, _ = O === void 0 ? 1 / 0 : O, C = r.minWidth, F = C === void 0 ? 0 : C, I = r.minHeight, A = I === void 0 ? 0 : I, $ = document.createElement("canvas"), Q = $.getContext("2d"), k = Ge({
    aspectRatio: p,
    width: E,
    height: _
  }), ae = Ge({
    aspectRatio: p,
    width: F,
    height: A
  }, "cover"), j = Math.min(k.width, Math.max(ae.width, y)), K = Math.min(k.height, Math.max(ae.height, b)), ee = Ge({
    aspectRatio: s,
    width: E,
    height: _
  }), W = Ge({
    aspectRatio: s,
    width: F,
    height: A
  }, "cover"), D = Math.min(ee.width, Math.max(W.width, n)), z = Math.min(ee.height, Math.max(W.height, a)), Y = [-D / 2, -z / 2, D, z];
  return $.width = Et(j), $.height = Et(K), Q.fillStyle = S, Q.fillRect(0, 0, j, K), Q.save(), Q.translate(j / 2, K / 2), Q.rotate(l * Math.PI / 180), Q.scale(h, u), Q.imageSmoothingEnabled = N, Q.imageSmoothingQuality = R, Q.drawImage.apply(Q, [i].concat(Bn(Y.map(function(he) {
    return Math.floor(Et(he));
  })))), Q.restore(), $;
}
var ea = String.fromCharCode;
function nu(i, e, t) {
  var r = "";
  t += e;
  for (var s = e; s < t; s += 1)
    r += ea(i.getUint8(s));
  return r;
}
var au = /^data:.*,/;
function ou(i) {
  var e = i.replace(au, ""), t = atob(e), r = new ArrayBuffer(t.length), s = new Uint8Array(r);
  return ne(s, function(n, a) {
    s[a] = t.charCodeAt(a);
  }), r;
}
function lu(i, e) {
  for (var t = [], r = 8192, s = new Uint8Array(i); s.length > 0; )
    t.push(ea.apply(null, Xn(s.subarray(0, r)))), s = s.subarray(r);
  return "data:".concat(e, ";base64,").concat(btoa(t.join("")));
}
function cu(i) {
  var e = new DataView(i), t;
  try {
    var r, s, n;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, o = 2; o + 1 < a; ) {
        if (e.getUint8(o) === 255 && e.getUint8(o + 1) === 225) {
          s = o;
          break;
        }
        o += 1;
      }
    if (s) {
      var l = s + 4, c = s + 10;
      if (nu(e, l, 4) === "Exif") {
        var h = e.getUint16(c);
        if (r = h === 18761, (r || h === 19789) && e.getUint16(c + 2, r) === 42) {
          var d = e.getUint32(c + 4, r);
          d >= 8 && (n = c + d);
        }
      }
    }
    if (n) {
      var u = e.getUint16(n, r), p, y;
      for (y = 0; y < u; y += 1)
        if (p = n + y * 12 + 2, e.getUint16(p, r) === 274) {
          p += 8, t = e.getUint16(p, r), e.setUint16(p, 1, r);
          break;
        }
    }
  } catch {
    t = 1;
  }
  return t;
}
function uu(i) {
  var e = 0, t = 1, r = 1;
  switch (i) {
    // Flip horizontal
    case 2:
      t = -1;
      break;
    // Rotate left 180°
    case 3:
      e = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      e = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      e = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      e = 90, t = -1;
      break;
    // Rotate left 90°
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: t,
    scaleY: r
  };
}
var hu = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, r = this.container, s = this.cropper, n = Number(t.minContainerWidth), a = Number(t.minContainerHeight);
    le(s, ye), ke(e, ye);
    var o = {
      width: Math.max(r.offsetWidth, n >= 0 ? n : Kn),
      height: Math.max(r.offsetHeight, a >= 0 ? a : Yn)
    };
    this.containerData = o, Xe(s, {
      width: o.width,
      height: o.height
    }), le(e, ye), ke(s, ye);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, r = this.options.viewMode, s = Math.abs(t.rotate) % 180 === 90, n = s ? t.naturalHeight : t.naturalWidth, a = s ? t.naturalWidth : t.naturalHeight, o = n / a, l = e.width, c = e.height;
    e.height * o > e.width ? r === 3 ? l = e.height * o : c = e.width / o : r === 3 ? c = e.width / o : l = e.height * o;
    var h = {
      aspectRatio: o,
      naturalWidth: n,
      naturalHeight: a,
      width: l,
      height: c
    };
    this.canvasData = h, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), h.width = Math.min(Math.max(h.width, h.minWidth), h.maxWidth), h.height = Math.min(Math.max(h.height, h.minHeight), h.maxHeight), h.left = (e.width - h.width) / 2, h.top = (e.height - h.height) / 2, h.oldLeft = h.left, h.oldTop = h.top, this.initialCanvasData = Z({}, h);
  },
  limitCanvas: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = r.viewMode, l = n.aspectRatio, c = this.cropped && a;
    if (e) {
      var h = Number(r.minCanvasWidth) || 0, d = Number(r.minCanvasHeight) || 0;
      o > 1 ? (h = Math.max(h, s.width), d = Math.max(d, s.height), o === 3 && (d * l > h ? h = d * l : d = h / l)) : o > 0 && (h ? h = Math.max(h, c ? a.width : 0) : d ? d = Math.max(d, c ? a.height : 0) : c && (h = a.width, d = a.height, d * l > h ? h = d * l : d = h / l));
      var u = Ge({
        aspectRatio: l,
        width: h,
        height: d
      });
      h = u.width, d = u.height, n.minWidth = h, n.minHeight = d, n.maxWidth = 1 / 0, n.maxHeight = 1 / 0;
    }
    if (t)
      if (o > (c ? 0 : 1)) {
        var p = s.width - n.width, y = s.height - n.height;
        n.minLeft = Math.min(0, p), n.minTop = Math.min(0, y), n.maxLeft = Math.max(0, p), n.maxTop = Math.max(0, y), c && this.limited && (n.minLeft = Math.min(a.left, a.left + (a.width - n.width)), n.minTop = Math.min(a.top, a.top + (a.height - n.height)), n.maxLeft = a.left, n.maxTop = a.top, o === 2 && (n.width >= s.width && (n.minLeft = Math.min(0, p), n.maxLeft = Math.max(0, p)), n.height >= s.height && (n.minTop = Math.min(0, y), n.maxTop = Math.max(0, y))));
      } else
        n.minLeft = -n.width, n.minTop = -n.height, n.maxLeft = s.width, n.maxTop = s.height;
  },
  renderCanvas: function(e, t) {
    var r = this.canvasData, s = this.imageData;
    if (t) {
      var n = ru({
        width: s.naturalWidth * Math.abs(s.scaleX || 1),
        height: s.naturalHeight * Math.abs(s.scaleY || 1),
        degree: s.rotate || 0
      }), a = n.width, o = n.height, l = r.width * (a / r.naturalWidth), c = r.height * (o / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (c - r.height) / 2, r.width = l, r.height = c, r.aspectRatio = a / o, r.naturalWidth = a, r.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, Xe(this.canvas, Z({
      width: r.width,
      height: r.height
    }, Xt({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, r = this.imageData, s = r.naturalWidth * (t.width / t.naturalWidth), n = r.naturalHeight * (t.height / t.naturalHeight);
    Z(r, {
      width: s,
      height: n,
      left: (t.width - s) / 2,
      top: (t.height - n) / 2
    }), Xe(this.image, Z({
      width: r.width,
      height: r.height
    }, Xt(Z({
      translateX: r.left,
      translateY: r.top
    }, r)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, r = e.aspectRatio || e.initialAspectRatio, s = Number(e.autoCropArea) || 0.8, n = {
      width: t.width,
      height: t.height
    };
    r && (t.height * r > t.width ? n.height = n.width / r : n.width = n.height * r), this.cropBoxData = n, this.limitCropBox(!0, !0), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), n.width = Math.max(n.minWidth, n.width * s), n.height = Math.max(n.minHeight, n.height * s), n.left = t.left + (t.width - n.width) / 2, n.top = t.top + (t.height - n.height) / 2, n.oldLeft = n.left, n.oldTop = n.top, this.initialCropBoxData = Z({}, n);
  },
  limitCropBox: function(e, t) {
    var r = this.options, s = this.containerData, n = this.canvasData, a = this.cropBoxData, o = this.limited, l = r.aspectRatio;
    if (e) {
      var c = Number(r.minCropBoxWidth) || 0, h = Number(r.minCropBoxHeight) || 0, d = o ? Math.min(s.width, n.width, n.width + n.left, s.width - n.left) : s.width, u = o ? Math.min(s.height, n.height, n.height + n.top, s.height - n.top) : s.height;
      c = Math.min(c, s.width), h = Math.min(h, s.height), l && (c && h ? h * l > c ? h = c / l : c = h * l : c ? h = c / l : h && (c = h * l), u * l > d ? u = d / l : d = u * l), a.minWidth = Math.min(c, d), a.minHeight = Math.min(h, u), a.maxWidth = d, a.maxHeight = u;
    }
    t && (o ? (a.minLeft = Math.max(0, n.left), a.minTop = Math.max(0, n.top), a.maxLeft = Math.min(s.width, n.left + n.width) - a.width, a.maxTop = Math.min(s.height, n.top + n.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = s.width - a.width, a.maxTop = s.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, e.movable && e.cropBoxMovable && ti(this.face, ei, r.width >= t.width && r.height >= t.height ? Vn : Pr), Xe(this.cropBox, Z({
      width: r.width,
      height: r.height
    }, Xt({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Nt(this.element, fr, this.getData());
  }
}, du = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, r = this.options.preview, s = t ? this.crossOriginUrl : this.url, n = e.alt || "The image to preview", a = document.createElement("img");
    if (t && (a.crossOrigin = t), a.src = s, a.alt = n, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var o = r;
      typeof r == "string" ? o = e.ownerDocument.querySelectorAll(r) : r.querySelector && (o = [r]), this.previews = o, ne(o, function(l) {
        var c = document.createElement("img");
        ti(l, pi, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), t && (c.crossOrigin = t), c.src = s, c.alt = n, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    ne(this.previews, function(e) {
      var t = yr(e, pi);
      Xe(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, Zc(e, pi);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, r = this.cropBoxData, s = r.width, n = r.height, a = e.width, o = e.height, l = r.left - t.left - e.left, c = r.top - t.top - e.top;
    !this.cropped || this.disabled || (Xe(this.viewBoxImage, Z({
      width: a,
      height: o
    }, Xt(Z({
      translateX: -l,
      translateY: -c
    }, e)))), ne(this.previews, function(h) {
      var d = yr(h, pi), u = d.width, p = d.height, y = u, b = p, m = 1;
      s && (m = u / s, b = n * m), n && b > p && (m = p / n, y = s * m, b = p), Xe(h, {
        width: y,
        height: b
      }), Xe(h.getElementsByTagName("img")[0], Z({
        width: a * m,
        height: o * m
      }, Xt(Z({
        translateX: -l * m,
        translateY: -c * m
      }, e))));
    }));
  }
}, fu = {
  bind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    me(t.cropstart) && xe(e, mr, t.cropstart), me(t.cropmove) && xe(e, gr, t.cropmove), me(t.cropend) && xe(e, pr, t.cropend), me(t.crop) && xe(e, fr, t.crop), me(t.zoom) && xe(e, vr, t.zoom), xe(r, Ms, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && xe(r, zs, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && xe(r, Ls, this.onDblclick = this.dblclick.bind(this)), xe(e.ownerDocument, ks, this.onCropMove = this.cropMove.bind(this)), xe(e.ownerDocument, Ts, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && xe(window, js, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    me(t.cropstart) && _e(e, mr, t.cropstart), me(t.cropmove) && _e(e, gr, t.cropmove), me(t.cropend) && _e(e, pr, t.cropend), me(t.crop) && _e(e, fr, t.crop), me(t.zoom) && _e(e, vr, t.zoom), _e(r, Ms, this.onCropStart), t.zoomable && t.zoomOnWheel && _e(r, zs, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && _e(r, Ls, this.onDblclick), _e(e.ownerDocument, ks, this.onCropMove), _e(e.ownerDocument, Ts, this.onCropEnd), t.responsive && _e(window, js, this.onResize);
  }
}, pu = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, r = this.containerData, s = t.offsetWidth / r.width, n = t.offsetHeight / r.height, a = Math.abs(s - 1) > Math.abs(n - 1) ? s : n;
      if (a !== 1) {
        var o, l;
        e.restore && (o = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(ne(o, function(c, h) {
          o[h] = c * a;
        })), this.setCropBoxData(ne(l, function(c, h) {
          l[h] = c * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === Qn || this.setDragMode(Gc(this.dragBox, hr) ? qn : Fr);
  },
  wheel: function(e) {
    var t = this, r = Number(this.options.wheelZoomRatio) || 0.1, s = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? s = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? s = -e.wheelDelta / 120 : e.detail && (s = e.detail > 0 ? 1 : -1), this.zoom(-s * r, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, r = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (U(t) && t !== 1 || U(r) && r !== 0 || e.ctrlKey))) {
      var s = this.options, n = this.pointers, a;
      e.changedTouches ? ne(e.changedTouches, function(o) {
        n[o.identifier] = gi(o);
      }) : n[e.pointerId || 0] = gi(e), Object.keys(n).length > 1 && s.zoomable && s.zoomOnTouch ? a = Wn : a = yr(e.target, ei), $c.test(a) && Nt(this.element, mr, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === Hn && (this.cropping = !0, le(this.dragBox, Oi)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var r = this.pointers;
      e.preventDefault(), Nt(this.element, gr, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? ne(e.changedTouches, function(s) {
        Z(r[s.identifier] || {}, gi(s, !0));
      }) : Z(r[e.pointerId || 0] || {}, gi(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, r = this.pointers;
      e.changedTouches ? ne(e.changedTouches, function(s) {
        delete r[s.identifier];
      }) : delete r[e.pointerId || 0], t && (e.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, Ct(this.dragBox, Oi, this.cropped && this.options.modal)), Nt(this.element, pr, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, gu = {
  change: function(e) {
    var t = this.options, r = this.canvasData, s = this.containerData, n = this.cropBoxData, a = this.pointers, o = this.action, l = t.aspectRatio, c = n.left, h = n.top, d = n.width, u = n.height, p = c + d, y = h + u, b = 0, m = 0, S = s.width, x = s.height, N = !0, w;
    !l && e.shiftKey && (l = d && u ? d / u : 1), this.limited && (b = n.minLeft, m = n.minTop, S = b + Math.min(s.width, r.width, r.left + r.width), x = m + Math.min(s.height, r.height, r.top + r.height));
    var R = a[Object.keys(a)[0]], g = {
      x: R.endX - R.startX,
      y: R.endY - R.startY
    }, E = function(_) {
      switch (_) {
        case et:
          p + g.x > S && (g.x = S - p);
          break;
        case tt:
          c + g.x < b && (g.x = b - c);
          break;
        case Ue:
          h + g.y < m && (g.y = m - h);
          break;
        case wt:
          y + g.y > x && (g.y = x - y);
          break;
      }
    };
    switch (o) {
      // Move crop box
      case Pr:
        c += g.x, h += g.y;
        break;
      // Resize crop box
      case et:
        if (g.x >= 0 && (p >= S || l && (h <= m || y >= x))) {
          N = !1;
          break;
        }
        E(et), d += g.x, d < 0 && (o = tt, d = -d, c -= d), l && (u = d / l, h += (n.height - u) / 2);
        break;
      case Ue:
        if (g.y <= 0 && (h <= m || l && (c <= b || p >= S))) {
          N = !1;
          break;
        }
        E(Ue), u -= g.y, h += g.y, u < 0 && (o = wt, u = -u, h -= u), l && (d = u * l, c += (n.width - d) / 2);
        break;
      case tt:
        if (g.x <= 0 && (c <= b || l && (h <= m || y >= x))) {
          N = !1;
          break;
        }
        E(tt), d -= g.x, c += g.x, d < 0 && (o = et, d = -d, c -= d), l && (u = d / l, h += (n.height - u) / 2);
        break;
      case wt:
        if (g.y >= 0 && (y >= x || l && (c <= b || p >= S))) {
          N = !1;
          break;
        }
        E(wt), u += g.y, u < 0 && (o = Ue, u = -u, h -= u), l && (d = u * l, c += (n.width - d) / 2);
        break;
      case Vt:
        if (l) {
          if (g.y <= 0 && (h <= m || p >= S)) {
            N = !1;
            break;
          }
          E(Ue), u -= g.y, h += g.y, d = u * l;
        } else
          E(Ue), E(et), g.x >= 0 ? p < S ? d += g.x : g.y <= 0 && h <= m && (N = !1) : d += g.x, g.y <= 0 ? h > m && (u -= g.y, h += g.y) : (u -= g.y, h += g.y);
        d < 0 && u < 0 ? (o = Qt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = Wt, d = -d, c -= d) : u < 0 && (o = qt, u = -u, h -= u);
        break;
      case Wt:
        if (l) {
          if (g.y <= 0 && (h <= m || c <= b)) {
            N = !1;
            break;
          }
          E(Ue), u -= g.y, h += g.y, d = u * l, c += n.width - d;
        } else
          E(Ue), E(tt), g.x <= 0 ? c > b ? (d -= g.x, c += g.x) : g.y <= 0 && h <= m && (N = !1) : (d -= g.x, c += g.x), g.y <= 0 ? h > m && (u -= g.y, h += g.y) : (u -= g.y, h += g.y);
        d < 0 && u < 0 ? (o = qt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = Vt, d = -d, c -= d) : u < 0 && (o = Qt, u = -u, h -= u);
        break;
      case Qt:
        if (l) {
          if (g.x <= 0 && (c <= b || y >= x)) {
            N = !1;
            break;
          }
          E(tt), d -= g.x, c += g.x, u = d / l;
        } else
          E(wt), E(tt), g.x <= 0 ? c > b ? (d -= g.x, c += g.x) : g.y >= 0 && y >= x && (N = !1) : (d -= g.x, c += g.x), g.y >= 0 ? y < x && (u += g.y) : u += g.y;
        d < 0 && u < 0 ? (o = Vt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = qt, d = -d, c -= d) : u < 0 && (o = Wt, u = -u, h -= u);
        break;
      case qt:
        if (l) {
          if (g.x >= 0 && (p >= S || y >= x)) {
            N = !1;
            break;
          }
          E(et), d += g.x, u = d / l;
        } else
          E(wt), E(et), g.x >= 0 ? p < S ? d += g.x : g.y >= 0 && y >= x && (N = !1) : d += g.x, g.y >= 0 ? y < x && (u += g.y) : u += g.y;
        d < 0 && u < 0 ? (o = Wt, u = -u, d = -d, h -= u, c -= d) : d < 0 ? (o = Qt, d = -d, c -= d) : u < 0 && (o = Vt, u = -u, h -= u);
        break;
      // Move canvas
      case Vn:
        this.move(g.x, g.y), N = !1;
        break;
      // Zoom canvas
      case Wn:
        this.zoom(tu(a), e), N = !1;
        break;
      // Create crop box
      case Hn:
        if (!g.x || !g.y) {
          N = !1;
          break;
        }
        w = Zn(this.cropper), c = R.startX - w.left, h = R.startY - w.top, d = n.minWidth, u = n.minHeight, g.x > 0 ? o = g.y > 0 ? qt : Vt : g.x < 0 && (c -= d, o = g.y > 0 ? Qt : Wt), g.y < 0 && (h -= u), this.cropped || (ke(this.cropBox, ye), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    N && (n.width = d, n.height = u, n.left = c, n.top = h, this.action = o, this.renderCropBox()), ne(a, function(O) {
      O.startX = O.endX, O.startY = O.endY;
    });
  }
}, mu = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && le(this.dragBox, Oi), ke(this.cropBox, ye), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = Z({}, this.initialImageData), this.canvasData = Z({}, this.initialCanvasData), this.cropBoxData = Z({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (Z(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), ke(this.dragBox, Oi), le(this.cropBox, ye)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, ne(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, ke(this.cropper, Ds)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, le(this.cropper, Ds)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[J] ? (e[J] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = r.left, n = r.top;
    return this.moveTo(Ai(e) ? e : s + Number(e), Ai(t) ? t : n + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (U(e) && (r.left = e, s = !0), U(t) && (r.top = t, s = !0), s && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var r = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(r.width * e / r.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, r) {
    var s = this.options, n = this.canvasData, a = n.width, o = n.height, l = n.naturalWidth, c = n.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && s.zoomable) {
      var h = l * e, d = c * e;
      if (Nt(this.element, vr, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var u = this.pointers, p = Zn(this.cropper), y = u && Object.keys(u).length ? iu(u) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        n.left -= (h - a) * ((y.pageX - p.left - n.left) / a), n.top -= (d - o) * ((y.pageY - p.top - n.top) / o);
      } else xt(t) && U(t.x) && U(t.y) ? (n.left -= (h - a) * ((t.x - n.left) / a), n.top -= (d - o) * ((t.y - n.top) / o)) : (n.left -= (h - a) / 2, n.top -= (d - o) / 2);
      n.width = h, n.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), U(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, U(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(U(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.imageData, s = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (U(e) && (r.scaleX = e, s = !0), U(t) && (r.scaleY = t, s = !0), s && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, r = this.imageData, s = this.canvasData, n = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: n.left - s.left,
        y: n.top - s.top,
        width: n.width,
        height: n.height
      };
      var o = r.width / r.naturalWidth;
      if (ne(a, function(h, d) {
        a[d] = h / o;
      }), e) {
        var l = Math.round(a.y + a.height), c = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = c - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (a.rotate = r.rotate || 0), t.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, r = this.imageData, s = this.canvasData, n = {};
    if (this.ready && !this.disabled && xt(e)) {
      var a = !1;
      t.rotatable && U(e.rotate) && e.rotate !== r.rotate && (r.rotate = e.rotate, a = !0), t.scalable && (U(e.scaleX) && e.scaleX !== r.scaleX && (r.scaleX = e.scaleX, a = !0), U(e.scaleY) && e.scaleY !== r.scaleY && (r.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var o = r.width / r.naturalWidth;
      U(e.x) && (n.left = e.x * o + s.left), U(e.y) && (n.top = e.y * o + s.top), U(e.width) && (n.width = e.width * o), U(e.height) && (n.height = e.height * o), this.setCropBoxData(n);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? Z({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? Z({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && ne(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      t[r] = e[r];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, r = t.aspectRatio;
    return this.ready && !this.disabled && xt(e) && (U(e.left) && (t.left = e.left), U(e.top) && (t.top = e.top), U(e.width) ? (t.width = e.width, t.height = e.width / r) : U(e.height) && (t.height = e.height, t.width = e.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, r = this.options.aspectRatio, s, n;
    return this.ready && this.cropped && !this.disabled && xt(e) && (U(e.left) && (t.left = e.left), U(e.top) && (t.top = e.top), U(e.width) && e.width !== t.width && (s = !0, t.width = e.width), U(e.height) && e.height !== t.height && (n = !0, t.height = e.height), r && (s ? t.height = t.width / r : n && (t.width = t.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, r = su(this.image, this.imageData, t, e);
    if (!this.cropped)
      return r;
    var s = this.getData(e.rounded), n = s.x, a = s.y, o = s.width, l = s.height, c = r.width / Math.floor(t.naturalWidth);
    c !== 1 && (n *= c, a *= c, o *= c, l *= c);
    var h = o / l, d = Ge({
      aspectRatio: h,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), u = Ge({
      aspectRatio: h,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), p = Ge({
      aspectRatio: h,
      width: e.width || (c !== 1 ? r.width : o),
      height: e.height || (c !== 1 ? r.height : l)
    }), y = p.width, b = p.height;
    y = Math.min(d.width, Math.max(u.width, y)), b = Math.min(d.height, Math.max(u.height, b));
    var m = document.createElement("canvas"), S = m.getContext("2d");
    m.width = Et(y), m.height = Et(b), S.fillStyle = e.fillColor || "transparent", S.fillRect(0, 0, y, b);
    var x = e.imageSmoothingEnabled, N = x === void 0 ? !0 : x, w = e.imageSmoothingQuality;
    S.imageSmoothingEnabled = N, w && (S.imageSmoothingQuality = w);
    var R = r.width, g = r.height, E = n, O = a, _, C, F, I, A, $;
    E <= -o || E > R ? (E = 0, _ = 0, F = 0, A = 0) : E <= 0 ? (F = -E, E = 0, _ = Math.min(R, o + E), A = _) : E <= R && (F = 0, _ = Math.min(o, R - E), A = _), _ <= 0 || O <= -l || O > g ? (O = 0, C = 0, I = 0, $ = 0) : O <= 0 ? (I = -O, O = 0, C = Math.min(g, l + O), $ = C) : O <= g && (I = 0, C = Math.min(l, g - O), $ = C);
    var Q = [E, O, _, C];
    if (A > 0 && $ > 0) {
      var k = y / o;
      Q.push(F * k, I * k, A * k, $ * k);
    }
    return S.drawImage.apply(S, [r].concat(Bn(Q.map(function(ae) {
      return Math.floor(Et(ae));
    })))), m;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !Ai(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, r = this.dragBox, s = this.face;
    if (this.ready && !this.disabled) {
      var n = e === Fr, a = t.movable && e === qn;
      e = n || a ? e : Qn, t.dragMode = e, ti(r, ei, e), Ct(r, hr, n), Ct(r, dr, a), t.cropBoxMovable || (ti(s, ei, e), Ct(s, hr, n), Ct(s, dr, a));
    }
    return this;
  }
}, vu = Te.Cropper, ta = /* @__PURE__ */ (function() {
  function i(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Fc(this, i), !e || !Vc.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = Z({}, $s, xt(t) && t), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return Dc(i, [{
    key: "init",
    value: function() {
      var t = this.element, r = t.tagName.toLowerCase(), s;
      if (!t[J]) {
        if (t[J] = this, r === "img") {
          if (this.isImg = !0, s = t.getAttribute("src") || "", this.originalUrl = s, !s)
            return;
          s = t.src;
        } else r === "canvas" && window.HTMLCanvasElement && (s = t.toDataURL());
        this.load(s);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var r = this;
      if (t) {
        this.url = t, this.imageData = {};
        var s = this.element, n = this.options;
        if (!n.rotatable && !n.scalable && (n.checkOrientation = !1), !n.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Bc.test(t)) {
          Hc.test(t) ? this.read(ou(t)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = o, a.onerror = o, a.ontimeout = o, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Us && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, n.checkCrossOrigin && Hs(t) && s.crossOrigin && (t = Vs(t)), a.open("GET", t, !0), a.responseType = "arraybuffer", a.withCredentials = s.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var r = this.options, s = this.imageData, n = cu(t), a = 0, o = 1, l = 1;
      if (n > 1) {
        this.url = lu(t, Us);
        var c = uu(n);
        a = c.rotate, o = c.scaleX, l = c.scaleY;
      }
      r.rotatable && (s.rotate = a), r.scalable && (s.scaleX = o, s.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, r = this.url, s = t.crossOrigin, n = r;
      this.options.checkCrossOrigin && Hs(r) && (s || (s = "anonymous"), n = Vs(r)), this.crossOrigin = s, this.crossOriginUrl = n;
      var a = document.createElement("img");
      s && (a.crossOrigin = s), a.src = n || r, a.alt = t.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), le(a, Is), t.parentNode.insertBefore(a, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var s = Te.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Te.navigator.userAgent), n = function(c, h) {
        Z(t.imageData, {
          naturalWidth: c,
          naturalHeight: h,
          aspectRatio: c / h
        }), t.initialImageData = Z({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (r.naturalWidth && !s) {
        n(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        n(a.width, a.height), s || o.removeChild(a);
      }, a.src = r.src, s || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, r = this.options, s = this.image, n = t.parentNode, a = document.createElement("div");
        a.innerHTML = Wc;
        var o = a.querySelector(".".concat(J, "-container")), l = o.querySelector(".".concat(J, "-canvas")), c = o.querySelector(".".concat(J, "-drag-box")), h = o.querySelector(".".concat(J, "-crop-box")), d = h.querySelector(".".concat(J, "-face"));
        this.container = n, this.cropper = o, this.canvas = l, this.dragBox = c, this.cropBox = h, this.viewBox = o.querySelector(".".concat(J, "-view-box")), this.face = d, l.appendChild(s), le(t, ye), n.insertBefore(o, t.nextSibling), ke(s, Is), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, le(h, ye), r.guides || le(h.getElementsByClassName("".concat(J, "-dashed")), ye), r.center || le(h.getElementsByClassName("".concat(J, "-center")), ye), r.background && le(o, "".concat(J, "-bg")), r.highlight || le(d, Ac), r.cropBoxMovable && (le(d, dr), ti(d, ei, Pr)), r.cropBoxResizable || (le(h.getElementsByClassName("".concat(J, "-line")), ye), le(h.getElementsByClassName("".concat(J, "-point")), ye)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), me(r.ready) && xe(t, As, r.ready, {
          once: !0
        }), Nt(t, As);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), ke(this.element, ye);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = vu, i;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      Z($s, xt(t) && t);
    }
  }]);
})();
Z(ta.prototype, hu, du, fu, pu, gu, mu);
var it = function() {
  return it = Object.assign || function(i) {
    for (var e, t = 1, r = arguments.length; t < r; t++) for (var s in e = arguments[t]) Object.prototype.hasOwnProperty.call(e, s) && (i[s] = e[s]);
    return i;
  }, it.apply(this, arguments);
};
function zi(i, e) {
  var t = {};
  for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function") {
    var s = 0;
    for (r = Object.getOwnPropertySymbols(i); s < r.length; s++) e.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(i, r[s]) && (t[r[s]] = i[r[s]]);
  }
  return t;
}
var yu = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], bu = { opacity: 0, maxWidth: "100%" }, wu = Oe.forwardRef((function(i, e) {
  var t = zi(i, []), r = t.dragMode, s = r === void 0 ? "crop" : r, n = t.src, a = t.style, o = t.className, l = t.crossOrigin, c = t.scaleX, h = t.scaleY, d = t.enable, u = t.zoomTo, p = t.rotateTo, y = t.alt, b = y === void 0 ? "picture" : y, m = t.ready, S = t.onInitialized, x = zi(t, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), N = { scaleY: h, scaleX: c, enable: d, zoomTo: u, rotateTo: p }, w = (function() {
    for (var g = [], E = 0; E < arguments.length; E++) g[E] = arguments[E];
    var O = we(null);
    return Oe.useEffect((function() {
      g.forEach((function(_) {
        _ && (typeof _ == "function" ? _(O.current) : _.current = O.current);
      }));
    }), [g]), O;
  })(e, we(null));
  Ee((function() {
    var g;
    !((g = w.current) === null || g === void 0) && g.cropper && typeof u == "number" && w.current.cropper.zoomTo(u);
  }), [t.zoomTo]), Ee((function() {
    var g;
    !((g = w.current) === null || g === void 0) && g.cropper && n !== void 0 && w.current.cropper.reset().clear().replace(n);
  }), [n]), Ee((function() {
    if (w.current !== null) {
      var g = new ta(w.current, it(it({ dragMode: s }, x), { ready: function(E) {
        E.currentTarget !== null && (function(O, _) {
          _ === void 0 && (_ = {});
          var C = _.enable, F = C === void 0 || C, I = _.scaleX, A = I === void 0 ? 1 : I, $ = _.scaleY, Q = $ === void 0 ? 1 : $, k = _.zoomTo, ae = k === void 0 ? 0 : k, j = _.rotateTo;
          F ? O.enable() : O.disable(), O.scaleX(A), O.scaleY(Q), j !== void 0 && O.rotateTo(j), ae > 0 && O.zoomTo(ae);
        })(E.currentTarget.cropper, N), m && m(E);
      } }));
      S && S(g);
    }
    return function() {
      var E, O;
      (O = (E = w.current) === null || E === void 0 ? void 0 : E.cropper) === null || O === void 0 || O.destroy();
    };
  }), [w]);
  var R = (function(g) {
    return yu.reduce((function(E, O) {
      var _ = E, C = O;
      return _[C], zi(_, [typeof C == "symbol" ? C : C + ""]);
    }), g);
  })(it(it({}, x), { crossOrigin: l, src: n, alt: b }));
  return Oe.createElement("div", { style: a, className: o }, Oe.createElement("img", it({}, R, { style: bu, ref: w })));
}));
const ia = Fa(
  ({ imageCropperRef: i, isRounded: e, imageFile: t, imageCropperProps: r }) => {
    const {
      viewMode: s = 1,
      autoCropArea: n = 1,
      aspectRatio: a = 1,
      checkOrientation: o = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: h = !1,
      style: d = { height: 400, width: "100%" },
      ...u
    } = r || {}, p = we(null), y = we(null), b = we(null), m = we(null), S = () => {
      y.current && (y.current.style.opacity = ""), b.current && (b.current.style.display = "block"), m.current && (m.current.style.zIndex = "", m.current.innerText = "");
    }, x = () => {
      b.current && m.current && (m.current.appendChild(b.current.cloneNode(!0)), m.current.style.zIndex = "1000", b.current.style.display = "none"), y.current && (y.current.style.opacity = "0");
    }, N = (w) => new Promise((R, g) => {
      var E;
      try {
        const O = (E = p.current) == null ? void 0 : E.cropper;
        if (!O) throw new Error();
        if (e) {
          const _ = O == null ? void 0 : O.getCroppedCanvas();
          if (!_) throw new Error();
          const C = Math.min(_.width, _.height), F = document.createElement("canvas");
          F.width = C, F.height = C;
          const I = F.getContext("2d");
          if (!I) throw new Error();
          I.beginPath(), I.arc(C / 2, C / 2, C / 2, 0, Math.PI * 2), I.closePath(), I.clip(), I.drawImage(_, 0, 0, C, C), F.toBlob((A) => {
            if (!t || !A)
              return g(new Error());
            const $ = ls(
              hs(t, A),
              a
            );
            R($);
          });
        } else
          O.getCroppedCanvas(w).toBlob((_) => {
            if (!t || !_)
              return g(new Error());
            const C = ls(
              hs(t, _),
              a
            );
            R(C);
          });
      } catch (O) {
        g(O);
      }
    });
    return i && (i.current = {
      hidePreview: S,
      showPreview: x,
      getCroppedFile: N
    }), /* @__PURE__ */ v("div", { children: /* @__PURE__ */ T("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ v(
        "div",
        {
          ref: m,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ v(
        "div",
        {
          ref: b,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: e ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ v("div", { ref: y, children: /* @__PURE__ */ v(
        wu,
        {
          className: e ? "sio-cropper-rounded" : "",
          ref: p,
          src: t && URL.createObjectURL(t),
          preview: b || void 0,
          style: d,
          viewMode: s,
          background: l,
          autoCropArea: n,
          aspectRatio: a,
          checkOrientation: o,
          dragMode: c,
          toggleDragModeOnDblclick: h,
          ...u
        }
      ) })
    ] }) });
  }
);
ia.displayName = "ImageCropper";
function ra({
  imageFile: i,
  opened: e,
  actionButtonLabel: t,
  isFetching: r,
  onClose: s,
  onCrop: n,
  isRounded: a = !1,
  allowSwitchingCroppingShape: o = !1,
  ...l
}) {
  const { t: c } = pe(), h = we(void 0), [d, u] = V(!1), [p, y] = V(a), b = (S) => {
    var x, N;
    u(S), S ? (x = h.current) == null || x.showPreview() : (N = h.current) == null || N.hidePreview();
  }, m = async () => {
    var S;
    try {
      const x = await ((S = h.current) == null ? void 0 : S.getCroppedFile());
      if (!x) throw new Error();
      n(x);
    } catch {
      be.error(c("file_manager.error"));
    }
  };
  return /* @__PURE__ */ T(
    Ei,
    {
      title: c("file_manager.file_upload.crop_file"),
      opened: e,
      onClose: s,
      afterLeave: () => u(!1),
      isFetching: r,
      isCentered: !0,
      children: [
        /* @__PURE__ */ v(
          ia,
          {
            imageCropperRef: h,
            imageFile: i,
            isRounded: o ? p : a,
            ...l
          }
        ),
        /* @__PURE__ */ T("div", { className: "mt-10 flex items-center justify-between gap-5", children: [
          /* @__PURE__ */ T("div", { className: "flex flex-wrap gap-5", children: [
            /* @__PURE__ */ v(
              va,
              {
                wrapperClassName: "flex-row",
                label: c("file_manager.preview"),
                selected: d,
                onChange: b
              }
            ),
            o && !d && /* @__PURE__ */ v(
              ya,
              {
                wrapperClassName: "flex-row",
                selected: p,
                onChange: y,
                label: c(p ? "file_manager.image_cropper.rounded_crop" : "file_manager.image_cropper.square_crop"),
                switcherElement: p ? /* @__PURE__ */ v(Wl, {}) : /* @__PURE__ */ v(ql, {})
              }
            )
          ] }),
          /* @__PURE__ */ v(oi, { onClick: m, isFetching: r, children: t ?? c("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
const xu = ({
  uploaderRef: i,
  opened: e,
  source: t,
  imageCropperModalProps: r,
  showCroppingNote: s,
  acceptTypes: n,
  fileManagerApiType: a,
  actionLabel: o,
  singleFileMode: l,
  openCroppingModalOnAdding: c,
  requireCropping: h,
  onClose: d,
  onUploadFinish: u
}) => {
  const { t: p } = pe(), [y, b] = V(!1), [m, S] = V(), {
    waitingUploadFiles: x,
    setWaitingUploadFiles: N,
    removingFiles: w,
    mappedUploadedFiles: R,
    mappedUploadingFiles: g,
    startUploading: E,
    setUploadedFiles: O,
    deleteUploadedOrUploadingFile: _
  } = Sc({
    fileManagerApiType: a,
    source: t
  }), C = async (D) => {
    var ci;
    const z = (ci = r == null ? void 0 : r.imageCropperProps) == null ? void 0 : ci.aspectRatio;
    if (!Wi(D) || !z || isNaN(z))
      return !0;
    const Y = URL.createObjectURL(D), [he, Ut] = await mn(Y);
    return !!vn(Ut, z);
  };
  cs(x, async (D, z) => {
    if (!c) return;
    const { added: Y } = D ? us(D, z) : { added: z };
    for (const { file: he } of Y)
      if (!await C(he)) {
        K(he);
        break;
      }
  }), cs(x, async (D, z) => {
    if (!s) return;
    const { added: Y } = D ? us(D, z) : { added: z };
    for (const { file: he } of Y)
      if (!await C(he)) {
        be(p("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const F = async (D) => {
    N(l ? [{ file: D }] : (z) => [{ file: D }, ...z]);
  }, I = async (D) => {
    try {
      Oc(D) && N((z) => z == null ? void 0 : z.filter((Y) => Y.file !== D)), Ec(D) && (await _(D.id), N((z) => z == null ? void 0 : z.filter((Y) => Y.file !== D.file))), Nc(D) && await _(D.id);
    } catch {
      be.error(p("file_manager.error"));
    }
  }, A = async () => {
    try {
      if (S(void 0), b(!0), h) {
        for await (const { file: Y } of x)
          if (!await C(Y))
            throw new Error(p("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const D = [], z = await Promise.allSettled(
        x.map(
          ({ file: Y }) => E(Y).catch(() => {
            D.push(p("file_manager.error") + ": " + Y.name);
          })
        )
      );
      if (D.length)
        throw new Error(D.join(", "));
      await u(
        z.map((Y) => {
          if (Y.status === "fulfilled")
            return Y.value;
        })
      ), be.success(p("file_manager.file_upload.uploaded_successfully"));
    } catch (D) {
      const z = D instanceof Error ? D : new Error(p("file_manager.error"));
      S(z);
    } finally {
      b(!1);
    }
  }, $ = !![...x, ...g, ...R].length, [Q, k] = V(!1), [ae, j] = V(), K = (D) => {
    k(!0), j(D);
  }, ee = () => {
    k(!1), j(void 0);
  }, W = (D) => {
    N(
      (z) => z.map((Y) => Y.file === ae ? { file: D } : Y)
    ), ee();
  };
  return i && (i.current = {
    setWaitingUploadFiles: N
  }), /* @__PURE__ */ T($i, { children: [
    /* @__PURE__ */ v(
      Ei,
      {
        title: p("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: y,
        opened: e,
        onClose: d,
        afterLeave: () => {
          O([]), N([]);
        },
        children: /* @__PURE__ */ T("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ T(
            zn,
            {
              acceptTypes: n,
              onSelectFile: F,
              dropZoneClassName: ie("min-h-[400px]", !$ && "items-center"),
              label: p("file_manager.file_upload.drop_files_here"),
              disabled: y,
              children: [
                x.map((D, z) => /* @__PURE__ */ v("div", { title: D.file.name, children: /* @__PURE__ */ v(
                  Ti,
                  {
                    file: D.file,
                    isError: !!D.error,
                    onDeleteFile: () => I(D.file),
                    showDeleteButton: !0,
                    showEditButton: Wi(D.file),
                    onEdit: () => K(D.file)
                  }
                ) }, z + D.file.name)),
                g.map((D) => /* @__PURE__ */ v("div", { title: D.file.name, children: /* @__PURE__ */ v(
                  Ti,
                  {
                    file: D.file.file,
                    progress: D.progress,
                    isLoading: !0,
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id)),
                R.map((D) => /* @__PURE__ */ v("div", { title: D.file.name, children: /* @__PURE__ */ v(
                  Ti,
                  {
                    file: D.file,
                    progress: D.progress,
                    isLoaded: !0,
                    isDeleting: w.includes(D.file.id),
                    onDeleteFile: () => I(D.file)
                  }
                ) }, D.file.id))
              ]
            }
          ),
          /* @__PURE__ */ v("div", { children: /* @__PURE__ */ v(
            mi,
            {
              error: m == null ? void 0 : m.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ T("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ v(tn, { disabled: y, onClick: () => d(), children: p("file_manager.cancel") }),
            /* @__PURE__ */ v(
              oi,
              {
                isFetching: y,
                onClick: A,
                disabled: !$,
                children: o ?? p("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ v(
      ra,
      {
        imageFile: ae,
        opened: Q,
        onClose: ee,
        onCrop: W,
        ...r
      }
    )
  ] });
};
function Cu({
  uploadingFromSource: i,
  requiredCropping: e = !0,
  fileUploaderModalProps: t,
  initialSearchFilters: r,
  disabledFileTypeSelect: s,
  disabledFileSourceSelect: n,
  fileSelectorRef: a,
  onSelect: o,
  fileManagerApiType: l
}) {
  var Ar, jr;
  e = !!(e && ((jr = (Ar = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Ar.imageCropperProps) != null && jr.aspectRatio));
  const { t: c } = pe(), { width: h } = ba(), [d, u] = V(
    r ?? {
      name: "",
      source: [],
      type: []
    }
  ), [p, y] = V(d), [b, m] = V(), [S, x] = V(), [N, w] = V(), [R, g] = V(""), [E, O] = V(), _ = ic({
    filter: p,
    sortColumn: "createdAt",
    sortDirection: sn.Desc,
    fileManagerApiType: l
  }), { resetAndRefetch: C, deleteItemFromData: F, renameItemFromData: I } = _, { deleteFile: A, downloadFile: $, renameFile: Q } = kn(), { data: k, isFetching: ae } = rc({
    id: b == null ? void 0 : b.id,
    fileManagerApiType: l
  }), j = async () => {
    S && (await A(S), F(S.id), be.success(c("file_manager.file_deleted_successfully")), x(void 0));
  }, K = async (se) => {
    try {
      await $(se);
    } catch {
    }
  }, [ee, W] = V(), D = async () => {
    var se;
    if (N)
      try {
        W(void 0), await Q({ id: N.id, name: R }), I({ id: N.id, name: R }), be.success(c("file_manager.file_renamed_successfully")), w(void 0);
      } catch (Ne) {
        if (Ne instanceof Na)
          W((se = Ne.errors.fields.name) == null ? void 0 : se.join(" "));
        else
          throw Ne;
      }
  }, z = we(void 0), [Y, he] = V(!1), Ut = (se) => {
    var Ne;
    (Ne = z.current) == null || Ne.setWaitingUploadFiles((Ze) => [...Ze, { file: se }]), he(!0);
  };
  Ee(() => {
    t != null && t.uploaderRef && (t.uploaderRef.current = z.current);
  }, [z.current]), a && (a.current = {
    setFileUploadModalOpen: he
  });
  const { createFileUploader: ci } = An(l), [sa, Ir] = V(!1), [na, Lr] = V(!1), [aa, Mr] = V(!1), [oa, kr] = V(), la = (se) => {
    Ir(!0), kr(se);
  }, Tr = () => {
    Ir(!1), kr(void 0);
  }, ca = async (se) => {
    try {
      Lr(!0);
      const Ze = await ci(() => {
      }).upload({
        file: se,
        source: i
      });
      if (!Ze) throw new Error();
      const ui = Go(Ze, i);
      o(ui), C(), Tr();
    } catch {
      be.error(c("file_manager.error"));
    } finally {
      Lr(!1);
    }
  }, ua = async () => {
    var Ne, Ze;
    if (!E) return;
    const se = (Ze = (Ne = t == null ? void 0 : t.imageCropperModalProps) == null ? void 0 : Ne.imageCropperProps) == null ? void 0 : Ze.aspectRatio;
    if (!e || !Wi(E) || !se || isNaN(se)) {
      o(E);
      return;
    }
    try {
      Mr(!0);
      const [ui, ha] = await mn(E.path);
      if (vn(ha, se)) {
        o(E);
        return;
      }
      be(Xo(se));
      const da = await Jo(ui, E.name, E.type);
      la(da);
    } catch {
      be.error(c("file_manager.error"));
    } finally {
      Mr(!1);
    }
  };
  return /* @__PURE__ */ T("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ v(
      "div",
      {
        className: ie(
          b ? "w-1/2" : "w-full",
          h < 1024 && b ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ T("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ v(
            sc,
            {
              isFetching: _.isFetching,
              values: d,
              disabledFileSourceSelect: n,
              disabledFileTypeSelect: s,
              onChange: u,
              onSubmit: () => {
                y(d);
              }
            }
          ),
          /* @__PURE__ */ v(
            yc,
            {
              dataFilesApi: _,
              onDetails: m,
              onSelect: O,
              specialElementInGrid: /* @__PURE__ */ v(
                zn,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: Ut
                }
              ),
              ...!(l != null && l.isCommon) && {
                onDelete: x,
                onDownload: K,
                onRename: (se) => {
                  w(se), g(se.name);
                }
              }
            }
          ),
          /* @__PURE__ */ T("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ T("div", { className: "text-text-tertiary text-sm", children: [
              +!!E,
              " ",
              c("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ v(
              oi,
              {
                className: "min-w-14",
                disabled: E === void 0,
                isFetching: aa,
                onClick: () => ua(),
                children: c("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    b && /* @__PURE__ */ v(
      tl,
      {
        className: ie(h < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: k == null ? void 0 : k.type,
        src: (k == null ? void 0 : k.path) ?? (k == null ? void 0 : k.thumbnail) ?? void 0,
        alt: k == null ? void 0 : k.name,
        name: k == null ? void 0 : k.name,
        size: k == null ? void 0 : k.size,
        onClose: () => m(void 0),
        isFetching: ae
      }
    ),
    /* @__PURE__ */ v(
      fs,
      {
        opened: !!S,
        onClose: () => x(void 0),
        confirmationText: c("file_manager.file_selector.file_deletion_confirmation_text", {
          file: S == null ? void 0 : S.name
        }),
        onConfirm: () => j()
      }
    ),
    /* @__PURE__ */ v(
      fs,
      {
        opened: !!N,
        onClose: () => {
          w(void 0), W(void 0);
        },
        title: c("file_manager.file_selector.rename_file"),
        confirmButtonCaption: c("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ v(
          wa,
          {
            label: c("file_manager.file_selector.file_name"),
            placeholder: c("file_manager.file_selector.enter_new_file_name"),
            value: R,
            onChange: (se) => g(se.target.value),
            error: ee
          }
        ),
        onConfirm: () => D()
      }
    ),
    /* @__PURE__ */ v(
      xu,
      {
        ...t,
        uploaderRef: z,
        opened: Y,
        source: i,
        showCroppingNote: e,
        onClose: () => he(!1),
        onUploadFinish: () => {
          C(), he(!1);
        },
        fileManagerApiType: l
      }
    ),
    /* @__PURE__ */ v(
      ra,
      {
        isFetching: na,
        imageFile: oa,
        opened: sa,
        onClose: Tr,
        onCrop: ca,
        actionButtonLabel: c("file_manager.file_upload.crop_and_select_file"),
        ...t == null ? void 0 : t.imageCropperModalProps
      }
    )
  ] });
}
function Au({
  title: i,
  opened: e,
  onClose: t,
  onSelect: r,
  ...s
}) {
  const { t: n } = pe();
  return /* @__PURE__ */ v(
    Ei,
    {
      title: i ?? n("file_manager.file_selector.choose_file"),
      opened: e,
      isCentered: !0,
      size: xa.big,
      onClose: t,
      children: /* @__PURE__ */ v(Cu, { onSelect: r, ...s })
    }
  );
}
export {
  $a as AudioFileIcon,
  Wl as CircleToSquareSwapIcon,
  fs as ConfirmationModal,
  Hr as DocumentFileIcon,
  rl as FileActionMenuDeleteItem,
  il as FileActionMenuDetailsItem,
  nl as FileActionMenuDownloadItem,
  sl as FileActionMenuRenameItem,
  tl as FileDetails,
  jn as FileDropZoneVariantEnum,
  $e as FileExtensionEnum,
  yc as FileGrid,
  Wa as FileItem,
  pt as FilePreview,
  bn as FilePreviewFromOS,
  sc as FileSearch,
  Cu as FileSelector,
  Au as FileSelectorModal,
  G as FileSourceEnum,
  za as FileSourceEnumLocoKeys,
  X as FileTypeEnum,
  Ua as FileTypeEnumLocoKeys,
  zn as FileUploaderDropZone,
  Ti as FileUploaderItem,
  xu as FileUploaderModal,
  ia as ImageCropper,
  ra as ImageCropperModal,
  Ba as ImageFileIcon,
  Vl as LocaleContext,
  ku as LocaleProvider,
  wr as PaginationOrderEnum,
  Mu as QueryClientProvider,
  sn as SortDirectionEnum,
  ql as SquareToCircleSwapIcon,
  Ha as VideoFileIcon,
  ls as appendAspectRatioToFileName,
  vn as areAspectRatiosEqual,
  Go as convertFileInfoToDataFile,
  wc as createCanceler,
  xc as createProgress,
  Iu as fileInputAcceptTypes,
  el as formatAcceptTypeForInput,
  Ko as formatBytes,
  us as getArrayDifference,
  yn as getAspectRatioLabel,
  Xo as getAspectRatioNote,
  Lu as getFileTypeFromName,
  mn as getImageAspectRatio,
  Cc as getMimeType,
  Va as getThumbnailByType,
  Zo as hashFile,
  Cr as httpClient,
  re as i18n,
  Jo as imageToFile,
  ds as isAcceptTypeValid,
  ja as isDataFileInterface,
  Nc as isFileInfoInterface,
  Wi as isImageFile,
  Oc as isOsFile,
  Ec as isOsFileWithId,
  Qo as loadLangBundle,
  xr as namespace,
  hs as replaceImageFileBlob,
  gn as t,
  Tu as useDataFiles,
  Ot as useFetch,
  kn as useFileActions,
  rc as useFileDetails,
  An as useFileUploader,
  bc as useFileUploaderActions,
  Sc as useFileUploaderManager,
  ic as useInfiniteDataFiles,
  cs as useStateWatcher,
  pe as useTranslation,
  Rc as variantClassName
};
